"use strict";
module.exports = [
  {
    value: "1",
    label: "北京",
    children: [
      {
        value: "0",
        label: "市辖区",
        children: [
          {
            value: "1",
            label: "东城区",
          },
          {
            value: "2",
            label: "西城区",
          },
          {
            value: "3",
            label: "崇文区",
          },
          {
            value: "4",
            label: "宣武区",
          },
          {
            value: "5",
            label: "朝阳区",
          },
          {
            value: "6",
            label: "丰台区",
          },
          {
            value: "7",
            label: "石景山区",
          },
          {
            value: "8",
            label: "海淀区",
          },
          {
            value: "9",
            label: "门头沟区",
          },
          {
            value: "A",
            label: "房山区",
          },
          {
            value: "B",
            label: "通州区",
          },
          {
            value: "C",
            label: "顺义区",
          },
          {
            value: "D",
            label: "昌平区",
          },
          {
            value: "E",
            label: "大兴区",
          },
          {
            value: "F",
            label: "怀柔区",
          },
          {
            value: "G",
            label: "平谷区",
          },
          {
            value: "H",
            label: "经济开发区",
          },
        ],
      },
      {
        value: "1",
        label: "县",
        children: [
          {
            value: "1",
            label: "密云县",
          },
          {
            value: "2",
            label: "延庆县",
          },
        ],
      },
    ],
  },
  {
    value: "2",
    label: "天津",
    children: [
      {
        value: "0",
        label: "市辖区",
        children: [
          {
            value: "1",
            label: "和平区",
          },
          {
            value: "2",
            label: "河东区",
          },
          {
            value: "3",
            label: "河西区",
          },
          {
            value: "4",
            label: "南开区",
          },
          {
            value: "5",
            label: "河北区",
          },
          {
            value: "6",
            label: "红桥区",
          },
          {
            value: "7",
            label: "塘沽区",
          },
          {
            value: "8",
            label: "汉沽区",
          },
          {
            value: "9",
            label: "大港区",
          },
          {
            value: "A",
            label: "东丽区",
          },
          {
            value: "B",
            label: "西青区",
          },
          {
            value: "C",
            label: "津南区",
          },
          {
            value: "D",
            label: "北辰区",
          },
          {
            value: "E",
            label: "武清区",
          },
          {
            value: "F",
            label: "宝坻区",
          },
        ],
      },
      {
        value: "1",
        label: "县",
        children: [
          {
            value: "1",
            label: "宁河县",
          },
          {
            value: "2",
            label: "静海县",
          },
          {
            value: "3",
            label: "蓟县",
          },
        ],
      },
    ],
  },
  {
    value: "3",
    label: "上海",
    children: [
      {
        value: "0",
        label: "市辖区",
        children: [
          {
            value: "1",
            label: "黄浦区",
          },
          {
            value: "2",
            label: "卢湾区",
          },
          {
            value: "3",
            label: "徐汇区",
          },
          {
            value: "4",
            label: "长宁区",
          },
          {
            value: "5",
            label: "静安区",
          },
          {
            value: "6",
            label: "普陀区",
          },
          {
            value: "7",
            label: "闸北区",
          },
          {
            value: "8",
            label: "虹口区",
          },
          {
            value: "9",
            label: "杨浦区",
          },
          {
            value: "A",
            label: "闵行区",
          },
          {
            value: "B",
            label: "宝山区",
          },
          {
            value: "C",
            label: "嘉定区",
          },
          {
            value: "D",
            label: "浦东新区",
          },
          {
            value: "E",
            label: "金山区",
          },
          {
            value: "F",
            label: "松江区",
          },
          {
            value: "G",
            label: "青浦区",
          },
          {
            value: "H",
            label: "南汇区",
          },
          {
            value: "I",
            label: "奉贤区",
          },
        ],
      },
      {
        value: "1",
        label: "县",
        children: [
          {
            value: "1",
            label: "崇明县",
          },
        ],
      },
    ],
  },
  {
    value: "4",
    label: "重庆",
    children: [
      {
        value: "1",
        label: "市辖区",
        children: [
          {
            value: "1",
            label: "万州区",
          },
          {
            value: "2",
            label: "涪陵区",
          },
          {
            value: "3",
            label: "渝中区",
          },
          {
            value: "4",
            label: "大渡口区",
          },
          {
            value: "5",
            label: "江北区",
          },
          {
            value: "6",
            label: "沙坪坝区",
          },
          {
            value: "7",
            label: "九龙坡区",
          },
          {
            value: "8",
            label: "南岸区",
          },
          {
            value: "9",
            label: "北碚区",
          },
          {
            value: "A",
            label: "万盛区",
          },
          {
            value: "B",
            label: "双桥区",
          },
          {
            value: "C",
            label: "渝北区",
          },
          {
            value: "D",
            label: "巴南区",
          },
          {
            value: "E",
            label: "黔江区",
          },
          {
            value: "F",
            label: "长寿区",
          },
        ],
      },
      {
        value: "2",
        label: "县",
        children: [
          {
            value: "1",
            label: "綦江县",
          },
          {
            value: "2",
            label: "潼南县",
          },
          {
            value: "3",
            label: "铜梁县",
          },
          {
            value: "4",
            label: "大足县",
          },
          {
            value: "5",
            label: "荣昌县",
          },
          {
            value: "6",
            label: "璧山县",
          },
          {
            value: "7",
            label: "梁平县",
          },
          {
            value: "8",
            label: "城口县",
          },
          {
            value: "9",
            label: "丰都县",
          },
          {
            value: "A",
            label: "垫江县",
          },
          {
            value: "B",
            label: "武隆县",
          },
          {
            value: "C",
            label: "忠县",
          },
          {
            value: "D",
            label: "开县",
          },
          {
            value: "E",
            label: "云阳县",
          },
          {
            value: "F",
            label: "奉节县",
          },
          {
            value: "G",
            label: "巫山县",
          },
          {
            value: "H",
            label: "巫溪县",
          },
          {
            value: "I",
            label: "石柱土家族自治县",
          },
          {
            value: "J",
            label: "秀山土家族苗族自治县",
          },
          {
            value: "K",
            label: "酉阳土家族苗族自治县",
          },
          {
            value: "L",
            label: "彭水苗族土家族自治县",
          },
        ],
      },
      {
        value: "3",
        label: "市",
        children: [
          {
            value: "1",
            label: "江津市",
          },
          {
            value: "2",
            label: "合川市",
          },
          {
            value: "3",
            label: "永川市",
          },
          {
            value: "4",
            label: "南川市",
          },
        ],
      },
    ],
  },
  {
    value: "5",
    label: "河北",
    children: [
      {
        value: "0",
        label: "石家庄市",
        children: [
          {
            value: "1",
            label: "石家庄市",
          },
          {
            value: "2",
            label: "长安区",
          },
          {
            value: "3",
            label: "桥东区",
          },
          {
            value: "4",
            label: "桥西区",
          },
          {
            value: "5",
            label: "新华区",
          },
          {
            value: "6",
            label: "井陉矿区",
          },
          {
            value: "7",
            label: "裕华区",
          },
          {
            value: "8",
            label: "井陉县",
          },
          {
            value: "9",
            label: "正定县",
          },
          {
            value: "A",
            label: "栾城县",
          },
          {
            value: "B",
            label: "行唐县",
          },
          {
            value: "C",
            label: "灵寿县",
          },
          {
            value: "D",
            label: "高邑县",
          },
          {
            value: "E",
            label: "深泽县",
          },
          {
            value: "F",
            label: "赞皇县",
          },
          {
            value: "G",
            label: "无极县",
          },
          {
            value: "H",
            label: "平山县",
          },
          {
            value: "I",
            label: "元氏县",
          },
          {
            value: "J",
            label: "赵县",
          },
          {
            value: "K",
            label: "辛集市",
          },
          {
            value: "L",
            label: "藁城市",
          },
          {
            value: "M",
            label: "晋州市",
          },
          {
            value: "N",
            label: "新乐市",
          },
          {
            value: "O",
            label: "鹿泉市",
          },
        ],
      },
      {
        value: "1",
        label: "唐山市",
        children: [
          {
            value: "1",
            label: "唐山市",
          },
          {
            value: "2",
            label: "路南区",
          },
          {
            value: "3",
            label: "路北区",
          },
          {
            value: "4",
            label: "古冶区",
          },
          {
            value: "5",
            label: "开平区",
          },
          {
            value: "6",
            label: "丰南区",
          },
          {
            value: "7",
            label: "丰润区",
          },
          {
            value: "8",
            label: "滦县",
          },
          {
            value: "9",
            label: "滦南县",
          },
          {
            value: "A",
            label: "乐亭县",
          },
          {
            value: "B",
            label: "迁西县",
          },
          {
            value: "C",
            label: "玉田县",
          },
          {
            value: "D",
            label: "唐海县",
          },
          {
            value: "E",
            label: "遵化市",
          },
          {
            value: "F",
            label: "迁安市",
          },
          {
            value: "G",
            label: "开滦区",
          },
        ],
      },
      {
        value: "2",
        label: "秦皇岛市",
        children: [
          {
            value: "1",
            label: "秦皇岛市",
          },
          {
            value: "2",
            label: "海港区",
          },
          {
            value: "3",
            label: "山海关区",
          },
          {
            value: "4",
            label: "北戴河区",
          },
          {
            value: "5",
            label: "青龙满族自治县",
          },
          {
            value: "6",
            label: "昌黎县",
          },
          {
            value: "7",
            label: "抚宁县",
          },
          {
            value: "8",
            label: "卢龙县",
          },
        ],
      },
      {
        value: "3",
        label: "邯郸市",
        children: [
          {
            value: "1",
            label: "邯郸市",
          },
          {
            value: "2",
            label: "邯山区",
          },
          {
            value: "3",
            label: "丛台区",
          },
          {
            value: "4",
            label: "复兴区",
          },
          {
            value: "5",
            label: "峰峰矿区",
          },
          {
            value: "6",
            label: "邯郸县",
          },
          {
            value: "7",
            label: "临漳县",
          },
          {
            value: "8",
            label: "成安县",
          },
          {
            value: "9",
            label: "大名县",
          },
          {
            value: "A",
            label: "涉县",
          },
          {
            value: "B",
            label: "磁县",
          },
          {
            value: "C",
            label: "肥乡县",
          },
          {
            value: "D",
            label: "永年县",
          },
          {
            value: "E",
            label: "邱县",
          },
          {
            value: "F",
            label: "鸡泽县",
          },
          {
            value: "G",
            label: "广平县",
          },
          {
            value: "H",
            label: "馆陶县",
          },
          {
            value: "I",
            label: "魏县",
          },
          {
            value: "J",
            label: "曲周县",
          },
          {
            value: "K",
            label: "武安市",
          },
        ],
      },
      {
        value: "4",
        label: "邢台市",
        children: [
          {
            value: "1",
            label: "邢台市",
          },
          {
            value: "2",
            label: "桥东区",
          },
          {
            value: "3",
            label: "桥西区",
          },
          {
            value: "4",
            label: "邢台县",
          },
          {
            value: "5",
            label: "临城县",
          },
          {
            value: "6",
            label: "内丘县",
          },
          {
            value: "7",
            label: "柏乡县",
          },
          {
            value: "8",
            label: "隆尧县",
          },
          {
            value: "9",
            label: "任县",
          },
          {
            value: "A",
            label: "南和县",
          },
          {
            value: "B",
            label: "宁晋县",
          },
          {
            value: "C",
            label: "巨鹿县",
          },
          {
            value: "D",
            label: "新河县",
          },
          {
            value: "E",
            label: "广宗县",
          },
          {
            value: "F",
            label: "平乡县",
          },
          {
            value: "G",
            label: "威县",
          },
          {
            value: "H",
            label: "清河县",
          },
          {
            value: "I",
            label: "临西县",
          },
          {
            value: "J",
            label: "南宫市",
          },
          {
            value: "K",
            label: "沙河市",
          },
        ],
      },
      {
        value: "5",
        label: "保定市",
        children: [
          {
            value: "1",
            label: "保定市",
          },
          {
            value: "2",
            label: "竞秀区",
          },
          {
            value: "3",
            label: "莲池区",
          },
          {
            value: "4",
            label: "满城县",
          },
          {
            value: "5",
            label: "清苑县",
          },
          {
            value: "6",
            label: "涞水县",
          },
          {
            value: "7",
            label: "阜平县",
          },
          {
            value: "8",
            label: "徐水县",
          },
          {
            value: "9",
            label: "定兴县",
          },
          {
            value: "A",
            label: "唐县",
          },
          {
            value: "B",
            label: "高阳县",
          },
          {
            value: "C",
            label: "容城县",
          },
          {
            value: "D",
            label: "涞源县",
          },
          {
            value: "E",
            label: "望都县",
          },
          {
            value: "F",
            label: "安新县",
          },
          {
            value: "G",
            label: "易县",
          },
          {
            value: "H",
            label: "曲阳县",
          },
          {
            value: "I",
            label: "蠡县",
          },
          {
            value: "J",
            label: "顺平县",
          },
          {
            value: "K",
            label: "博野县",
          },
          {
            value: "L",
            label: "雄县",
          },
          {
            value: "M",
            label: "涿州市",
          },
          {
            value: "N",
            label: "定州市",
          },
          {
            value: "O",
            label: "安国市",
          },
          {
            value: "P",
            label: "高碑店市",
          },
        ],
      },
      {
        value: "6",
        label: "张家口市",
        children: [
          {
            value: "1",
            label: "张家口市",
          },
          {
            value: "2",
            label: "桥东区",
          },
          {
            value: "3",
            label: "桥西区",
          },
          {
            value: "4",
            label: "宣化区",
          },
          {
            value: "5",
            label: "下花园区",
          },
          {
            value: "6",
            label: "宣化县",
          },
          {
            value: "7",
            label: "张北县",
          },
          {
            value: "8",
            label: "康保县",
          },
          {
            value: "9",
            label: "沽源县",
          },
          {
            value: "A",
            label: "尚义县",
          },
          {
            value: "B",
            label: "蔚县",
          },
          {
            value: "C",
            label: "阳原县",
          },
          {
            value: "D",
            label: "怀安县",
          },
          {
            value: "E",
            label: "万全县",
          },
          {
            value: "F",
            label: "怀来县",
          },
          {
            value: "G",
            label: "涿鹿县",
          },
          {
            value: "H",
            label: "赤城县",
          },
          {
            value: "I",
            label: "崇礼县",
          },
        ],
      },
      {
        value: "7",
        label: "承德市",
        children: [
          {
            value: "1",
            label: "承德市",
          },
          {
            value: "2",
            label: "双桥区",
          },
          {
            value: "3",
            label: "双滦区",
          },
          {
            value: "4",
            label: "鹰手营子矿区",
          },
          {
            value: "5",
            label: "承德县",
          },
          {
            value: "6",
            label: "兴隆县",
          },
          {
            value: "7",
            label: "平泉县",
          },
          {
            value: "8",
            label: "滦平县",
          },
          {
            value: "9",
            label: "隆化县",
          },
          {
            value: "A",
            label: "丰宁满族自治县",
          },
          {
            value: "B",
            label: "宽城满族自治县",
          },
          {
            value: "C",
            label: "围场满族蒙古族自治县",
          },
          {
            value: "D",
            label: "营子区",
          },
        ],
      },
      {
        value: "8",
        label: "沧州市",
        children: [
          {
            value: "1",
            label: "沧州市",
          },
          {
            value: "2",
            label: "新华区",
          },
          {
            value: "3",
            label: "运河区",
          },
          {
            value: "4",
            label: "沧县",
          },
          {
            value: "5",
            label: "青县",
          },
          {
            value: "6",
            label: "东光县",
          },
          {
            value: "7",
            label: "海兴县",
          },
          {
            value: "8",
            label: "盐山县",
          },
          {
            value: "9",
            label: "肃宁县",
          },
          {
            value: "A",
            label: "南皮县",
          },
          {
            value: "B",
            label: "吴桥县",
          },
          {
            value: "C",
            label: "献县",
          },
          {
            value: "D",
            label: "孟村回族自治县",
          },
          {
            value: "E",
            label: "泊头市",
          },
          {
            value: "F",
            label: "任丘市",
          },
          {
            value: "G",
            label: "黄骅市",
          },
          {
            value: "H",
            label: "河间市",
          },
        ],
      },
      {
        value: "9",
        label: "廊坊市",
        children: [
          {
            value: "1",
            label: "廊坊市",
          },
          {
            value: "2",
            label: "安次区",
          },
          {
            value: "3",
            label: "广阳区",
          },
          {
            value: "4",
            label: "固安县",
          },
          {
            value: "5",
            label: "永清县",
          },
          {
            value: "6",
            label: "香河县",
          },
          {
            value: "7",
            label: "大城县",
          },
          {
            value: "8",
            label: "文安县",
          },
          {
            value: "9",
            label: "大厂回族自治县",
          },
          {
            value: "A",
            label: "霸州市",
          },
          {
            value: "B",
            label: "三河市",
          },
        ],
      },
      {
        value: "A",
        label: "衡水市",
        children: [
          {
            value: "1",
            label: "衡水市",
          },
          {
            value: "2",
            label: "桃城区",
          },
          {
            value: "3",
            label: "枣强县",
          },
          {
            value: "4",
            label: "武邑县",
          },
          {
            value: "5",
            label: "武强县",
          },
          {
            value: "6",
            label: "饶阳县",
          },
          {
            value: "7",
            label: "安平县",
          },
          {
            value: "8",
            label: "故城县",
          },
          {
            value: "9",
            label: "景县",
          },
          {
            value: "A",
            label: "阜城县",
          },
          {
            value: "B",
            label: "冀州市",
          },
          {
            value: "C",
            label: "深州市",
          },
        ],
      },
    ],
  },
  {
    value: "6",
    label: "山西",
    children: [
      {
        value: "0",
        label: "太原市",
        children: [
          {
            value: "1",
            label: "太原市",
          },
          {
            value: "2",
            label: "小店区",
          },
          {
            value: "3",
            label: "迎泽区",
          },
          {
            value: "4",
            label: "杏花岭区",
          },
          {
            value: "5",
            label: "尖草坪区",
          },
          {
            value: "6",
            label: "万柏林区",
          },
          {
            value: "7",
            label: "晋源区",
          },
          {
            value: "8",
            label: "清徐县",
          },
          {
            value: "9",
            label: "阳曲县",
          },
          {
            value: "A",
            label: "娄烦县",
          },
          {
            value: "B",
            label: "古交市",
          },
        ],
      },
      {
        value: "1",
        label: "大同市",
        children: [
          {
            value: "1",
            label: "大同市",
          },
          {
            value: "2",
            label: "城区",
          },
          {
            value: "3",
            label: "矿区",
          },
          {
            value: "4",
            label: "南郊区",
          },
          {
            value: "5",
            label: "新荣区",
          },
          {
            value: "6",
            label: "阳高县",
          },
          {
            value: "7",
            label: "天镇县",
          },
          {
            value: "8",
            label: "广灵县",
          },
          {
            value: "9",
            label: "灵丘县",
          },
          {
            value: "A",
            label: "浑源县",
          },
          {
            value: "B",
            label: "左云县",
          },
          {
            value: "C",
            label: "大同县",
          },
        ],
      },
      {
        value: "2",
        label: "阳泉市",
        children: [
          {
            value: "1",
            label: "阳泉市",
          },
          {
            value: "2",
            label: "城区",
          },
          {
            value: "3",
            label: "矿区",
          },
          {
            value: "4",
            label: "郊区",
          },
          {
            value: "5",
            label: "平定县",
          },
          {
            value: "6",
            label: "盂县",
          },
        ],
      },
      {
        value: "3",
        label: "长治市",
        children: [
          {
            value: "1",
            label: "长治市",
          },
          {
            value: "2",
            label: "城区",
          },
          {
            value: "3",
            label: "郊区",
          },
          {
            value: "4",
            label: "长治县",
          },
          {
            value: "5",
            label: "襄垣县",
          },
          {
            value: "6",
            label: "屯留县",
          },
          {
            value: "7",
            label: "平顺县",
          },
          {
            value: "8",
            label: "黎城县",
          },
          {
            value: "9",
            label: "壶关县",
          },
          {
            value: "A",
            label: "长子县",
          },
          {
            value: "B",
            label: "武乡县",
          },
          {
            value: "C",
            label: "沁县",
          },
          {
            value: "D",
            label: "沁源县",
          },
          {
            value: "E",
            label: "潞城市",
          },
        ],
      },
      {
        value: "4",
        label: "晋城市",
        children: [
          {
            value: "1",
            label: "晋城市",
          },
          {
            value: "2",
            label: "城区",
          },
          {
            value: "3",
            label: "沁水县",
          },
          {
            value: "4",
            label: "阳城县",
          },
          {
            value: "5",
            label: "陵川县",
          },
          {
            value: "6",
            label: "泽州县",
          },
          {
            value: "7",
            label: "高平市",
          },
        ],
      },
      {
        value: "5",
        label: "朔州市",
        children: [
          {
            value: "1",
            label: "朔州市",
          },
          {
            value: "2",
            label: "朔城区",
          },
          {
            value: "3",
            label: "平鲁区",
          },
          {
            value: "4",
            label: "山阴县",
          },
          {
            value: "5",
            label: "应县",
          },
          {
            value: "6",
            label: "右玉县",
          },
          {
            value: "7",
            label: "怀仁县",
          },
        ],
      },
      {
        value: "6",
        label: "晋中市",
        children: [
          {
            value: "1",
            label: "晋中市",
          },
          {
            value: "2",
            label: "榆次区",
          },
          {
            value: "3",
            label: "榆社县",
          },
          {
            value: "4",
            label: "左权县",
          },
          {
            value: "5",
            label: "和顺县",
          },
          {
            value: "6",
            label: "昔阳县",
          },
          {
            value: "7",
            label: "寿阳县",
          },
          {
            value: "8",
            label: "太谷县",
          },
          {
            value: "9",
            label: "祁县",
          },
          {
            value: "A",
            label: "平遥县",
          },
          {
            value: "B",
            label: "灵石县",
          },
          {
            value: "C",
            label: "介休市",
          },
        ],
      },
      {
        value: "7",
        label: "运城市",
        children: [
          {
            value: "1",
            label: "运城市",
          },
          {
            value: "2",
            label: "盐湖区",
          },
          {
            value: "3",
            label: "临猗县",
          },
          {
            value: "4",
            label: "万荣县",
          },
          {
            value: "5",
            label: "闻喜县",
          },
          {
            value: "6",
            label: "稷山县",
          },
          {
            value: "7",
            label: "新绛县",
          },
          {
            value: "8",
            label: "绛县",
          },
          {
            value: "9",
            label: "垣曲县",
          },
          {
            value: "A",
            label: "夏县",
          },
          {
            value: "B",
            label: "平陆县",
          },
          {
            value: "C",
            label: "芮城县",
          },
          {
            value: "D",
            label: "永济市",
          },
          {
            value: "E",
            label: "河津市",
          },
        ],
      },
      {
        value: "8",
        label: "忻州市",
        children: [
          {
            value: "1",
            label: "忻州市",
          },
          {
            value: "2",
            label: "忻府区",
          },
          {
            value: "3",
            label: "定襄县",
          },
          {
            value: "4",
            label: "五台县",
          },
          {
            value: "5",
            label: "代县",
          },
          {
            value: "6",
            label: "繁峙县",
          },
          {
            value: "7",
            label: "宁武县",
          },
          {
            value: "8",
            label: "静乐县",
          },
          {
            value: "9",
            label: "神池县",
          },
          {
            value: "A",
            label: "五寨县",
          },
          {
            value: "B",
            label: "岢岚县",
          },
          {
            value: "C",
            label: "河曲县",
          },
          {
            value: "D",
            label: "保德县",
          },
          {
            value: "E",
            label: "偏关县",
          },
          {
            value: "F",
            label: "原平市",
          },
        ],
      },
      {
        value: "9",
        label: "临汾市",
        children: [
          {
            value: "1",
            label: "临汾市",
          },
          {
            value: "2",
            label: "尧都区",
          },
          {
            value: "3",
            label: "曲沃县",
          },
          {
            value: "4",
            label: "翼城县",
          },
          {
            value: "5",
            label: "襄汾县",
          },
          {
            value: "6",
            label: "洪洞县",
          },
          {
            value: "7",
            label: "古县",
          },
          {
            value: "8",
            label: "安泽县",
          },
          {
            value: "9",
            label: "浮山县",
          },
          {
            value: "A",
            label: "吉县",
          },
          {
            value: "B",
            label: "乡宁县",
          },
          {
            value: "C",
            label: "大宁县",
          },
          {
            value: "D",
            label: "隰县",
          },
          {
            value: "E",
            label: "永和县",
          },
          {
            value: "F",
            label: "蒲县",
          },
          {
            value: "G",
            label: "汾西县",
          },
          {
            value: "H",
            label: "侯马市",
          },
          {
            value: "I",
            label: "霍州市",
          },
        ],
      },
      {
        value: "A",
        label: "吕梁市",
        children: [
          {
            value: "1",
            label: "吕梁市",
          },
          {
            value: "2",
            label: "离石区",
          },
          {
            value: "3",
            label: "文水县",
          },
          {
            value: "4",
            label: "交城县",
          },
          {
            value: "5",
            label: "兴县",
          },
          {
            value: "6",
            label: "临县",
          },
          {
            value: "7",
            label: "柳林县",
          },
          {
            value: "8",
            label: "石楼县",
          },
          {
            value: "9",
            label: "岚县",
          },
          {
            value: "A",
            label: "方山县",
          },
          {
            value: "B",
            label: "中阳县",
          },
          {
            value: "C",
            label: "交口县",
          },
          {
            value: "D",
            label: "孝义市",
          },
          {
            value: "E",
            label: "汾阳市",
          },
        ],
      },
    ],
  },
  {
    value: "7",
    label: "辽宁",
    children: [
      {
        value: "0",
        label: "沈阳市",
        children: [
          {
            value: "1",
            label: "沈阳市",
          },
          {
            value: "2",
            label: "和平区",
          },
          {
            value: "3",
            label: "沈河区",
          },
          {
            value: "4",
            label: "大东区",
          },
          {
            value: "5",
            label: "皇姑区",
          },
          {
            value: "6",
            label: "铁西区",
          },
          {
            value: "7",
            label: "苏家屯区",
          },
          {
            value: "8",
            label: "东陵区",
          },
          {
            value: "9",
            label: "新城子区",
          },
          {
            value: "A",
            label: "于洪区",
          },
          {
            value: "B",
            label: "辽中县",
          },
          {
            value: "C",
            label: "康平县",
          },
          {
            value: "D",
            label: "法库县",
          },
          {
            value: "E",
            label: "新民市",
          },
        ],
      },
      {
        value: "1",
        label: "大连市",
        children: [
          {
            value: "1",
            label: "大连市",
          },
          {
            value: "2",
            label: "中山区",
          },
          {
            value: "3",
            label: "西岗区",
          },
          {
            value: "4",
            label: "沙河口区",
          },
          {
            value: "5",
            label: "甘井子区",
          },
          {
            value: "6",
            label: "旅顺口区",
          },
          {
            value: "7",
            label: "金州区",
          },
          {
            value: "8",
            label: "长海县",
          },
          {
            value: "9",
            label: "瓦房店市",
          },
          {
            value: "A",
            label: "普兰店市",
          },
          {
            value: "B",
            label: "庄河市",
          },
        ],
      },
      {
        value: "2",
        label: "鞍山市",
        children: [
          {
            value: "1",
            label: "鞍山市",
          },
          {
            value: "2",
            label: "铁东区",
          },
          {
            value: "3",
            label: "铁西区",
          },
          {
            value: "4",
            label: "立山区",
          },
          {
            value: "5",
            label: "千山区",
          },
          {
            value: "6",
            label: "台安县",
          },
          {
            value: "7",
            label: "岫岩满族自治县",
          },
          {
            value: "8",
            label: "海城市",
          },
        ],
      },
      {
        value: "3",
        label: "抚顺市",
        children: [
          {
            value: "1",
            label: "抚顺市",
          },
          {
            value: "2",
            label: "新抚区",
          },
          {
            value: "3",
            label: "东洲区",
          },
          {
            value: "4",
            label: "望花区",
          },
          {
            value: "5",
            label: "顺城区",
          },
          {
            value: "6",
            label: "抚顺县",
          },
          {
            value: "7",
            label: "新宾满族自治县",
          },
          {
            value: "8",
            label: "清原满族自治县",
          },
        ],
      },
      {
        value: "4",
        label: "本溪市",
        children: [
          {
            value: "1",
            label: "本溪市",
          },
          {
            value: "2",
            label: "平山区",
          },
          {
            value: "3",
            label: "溪湖区",
          },
          {
            value: "4",
            label: "明山区",
          },
          {
            value: "5",
            label: "南芬区",
          },
          {
            value: "6",
            label: "本溪满族自治县",
          },
          {
            value: "7",
            label: "桓仁满族自治县",
          },
        ],
      },
      {
        value: "5",
        label: "丹东市",
        children: [
          {
            value: "1",
            label: "丹东市",
          },
          {
            value: "2",
            label: "元宝区",
          },
          {
            value: "3",
            label: "振兴区",
          },
          {
            value: "4",
            label: "振安区",
          },
          {
            value: "5",
            label: "宽甸满族自治县",
          },
          {
            value: "6",
            label: "东港市",
          },
          {
            value: "7",
            label: "凤城市",
          },
        ],
      },
      {
        value: "6",
        label: "锦州市",
        children: [
          {
            value: "1",
            label: "锦州市",
          },
          {
            value: "2",
            label: "古塔区",
          },
          {
            value: "3",
            label: "凌河区",
          },
          {
            value: "4",
            label: "太和区",
          },
          {
            value: "5",
            label: "黑山县",
          },
          {
            value: "6",
            label: "义县",
          },
          {
            value: "7",
            label: "凌海市",
          },
          {
            value: "8",
            label: "北宁市",
          },
        ],
      },
      {
        value: "7",
        label: "营口市",
        children: [
          {
            value: "1",
            label: "营口市",
          },
          {
            value: "2",
            label: "站前区",
          },
          {
            value: "3",
            label: "西市区",
          },
          {
            value: "4",
            label: "鲅鱼圈区",
          },
          {
            value: "5",
            label: "老边区",
          },
          {
            value: "6",
            label: "盖州市",
          },
          {
            value: "7",
            label: "大石桥市",
          },
        ],
      },
      {
        value: "8",
        label: "阜新市",
        children: [
          {
            value: "1",
            label: "阜新市",
          },
          {
            value: "2",
            label: "海州区",
          },
          {
            value: "3",
            label: "新邱区",
          },
          {
            value: "4",
            label: "太平区",
          },
          {
            value: "5",
            label: "清河门区",
          },
          {
            value: "6",
            label: "细河区",
          },
          {
            value: "7",
            label: "阜新蒙古族自治县",
          },
          {
            value: "8",
            label: "彰武县",
          },
        ],
      },
      {
        value: "9",
        label: "辽阳市",
        children: [
          {
            value: "1",
            label: "辽阳市",
          },
          {
            value: "2",
            label: "白塔区",
          },
          {
            value: "3",
            label: "文圣区",
          },
          {
            value: "4",
            label: "宏伟区",
          },
          {
            value: "5",
            label: "弓长岭区",
          },
          {
            value: "6",
            label: "太子河区",
          },
          {
            value: "7",
            label: "辽阳县",
          },
          {
            value: "8",
            label: "灯塔市",
          },
        ],
      },
      {
        value: "A",
        label: "盘锦市",
        children: [
          {
            value: "1",
            label: "盘锦市",
          },
          {
            value: "2",
            label: "双台子区",
          },
          {
            value: "3",
            label: "兴隆台区",
          },
          {
            value: "4",
            label: "大洼县",
          },
          {
            value: "5",
            label: "盘山县",
          },
        ],
      },
      {
        value: "B",
        label: "铁岭市",
        children: [
          {
            value: "1",
            label: "铁岭市",
          },
          {
            value: "2",
            label: "银州区",
          },
          {
            value: "3",
            label: "清河区",
          },
          {
            value: "4",
            label: "铁岭县",
          },
          {
            value: "5",
            label: "西丰县",
          },
          {
            value: "6",
            label: "昌图县",
          },
          {
            value: "7",
            label: "调兵山市",
          },
          {
            value: "8",
            label: "开原市",
          },
        ],
      },
      {
        value: "C",
        label: "朝阳市",
        children: [
          {
            value: "1",
            label: "朝阳市",
          },
          {
            value: "2",
            label: "双塔区",
          },
          {
            value: "3",
            label: "龙城区",
          },
          {
            value: "4",
            label: "朝阳县",
          },
          {
            value: "5",
            label: "建平县",
          },
          {
            value: "6",
            label: "喀喇沁左翼蒙古族自治县",
          },
          {
            value: "7",
            label: "北票市",
          },
          {
            value: "8",
            label: "凌源市",
          },
        ],
      },
      {
        value: "D",
        label: "葫芦岛市",
        children: [
          {
            value: "1",
            label: "葫芦岛市",
          },
          {
            value: "2",
            label: "连山区",
          },
          {
            value: "3",
            label: "龙港区",
          },
          {
            value: "4",
            label: "南票区",
          },
          {
            value: "5",
            label: "绥中县",
          },
          {
            value: "6",
            label: "建昌县",
          },
          {
            value: "7",
            label: "兴城市",
          },
        ],
      },
    ],
  },
  {
    value: "8",
    label: "吉林",
    children: [
      {
        value: "0",
        label: "长春市",
        children: [
          {
            value: "1",
            label: "长春市",
          },
          {
            value: "2",
            label: "南关区",
          },
          {
            value: "3",
            label: "宽城区",
          },
          {
            value: "4",
            label: "朝阳区",
          },
          {
            value: "5",
            label: "二道区",
          },
          {
            value: "6",
            label: "绿园区",
          },
          {
            value: "7",
            label: "双阳区",
          },
          {
            value: "8",
            label: "农安县",
          },
          {
            value: "9",
            label: "九台市",
          },
          {
            value: "A",
            label: "榆树市",
          },
          {
            value: "B",
            label: "德惠市",
          },
        ],
      },
      {
        value: "1",
        label: "吉林市",
        children: [
          {
            value: "1",
            label: "吉林市",
          },
          {
            value: "2",
            label: "昌邑区",
          },
          {
            value: "3",
            label: "龙潭区",
          },
          {
            value: "4",
            label: "船营区",
          },
          {
            value: "5",
            label: "丰满区",
          },
          {
            value: "6",
            label: "永吉县",
          },
          {
            value: "7",
            label: "蛟河市",
          },
          {
            value: "8",
            label: "桦甸市",
          },
          {
            value: "9",
            label: "舒兰市",
          },
          {
            value: "A",
            label: "磐石市",
          },
        ],
      },
      {
        value: "2",
        label: "四平市",
        children: [
          {
            value: "1",
            label: "四平市",
          },
          {
            value: "2",
            label: "铁西区",
          },
          {
            value: "3",
            label: "铁东区",
          },
          {
            value: "4",
            label: "梨树县",
          },
          {
            value: "5",
            label: "伊通满族自治县",
          },
          {
            value: "6",
            label: "公主岭市",
          },
          {
            value: "7",
            label: "双辽市",
          },
        ],
      },
      {
        value: "3",
        label: "辽源市",
        children: [
          {
            value: "1",
            label: "辽源市",
          },
          {
            value: "2",
            label: "龙山区",
          },
          {
            value: "3",
            label: "西安区",
          },
          {
            value: "4",
            label: "东丰县",
          },
          {
            value: "5",
            label: "东辽县",
          },
        ],
      },
      {
        value: "4",
        label: "通化市",
        children: [
          {
            value: "1",
            label: "通化市",
          },
          {
            value: "2",
            label: "东昌区",
          },
          {
            value: "3",
            label: "二道江区",
          },
          {
            value: "4",
            label: "通化县",
          },
          {
            value: "5",
            label: "辉南县",
          },
          {
            value: "6",
            label: "柳河县",
          },
          {
            value: "7",
            label: "梅河口市",
          },
          {
            value: "8",
            label: "集安市",
          },
        ],
      },
      {
        value: "5",
        label: "白山市",
        children: [
          {
            value: "1",
            label: "白山市",
          },
          {
            value: "2",
            label: "八道江区",
          },
          {
            value: "3",
            label: "抚松县",
          },
          {
            value: "4",
            label: "靖宇县",
          },
          {
            value: "5",
            label: "长白朝鲜族自治县",
          },
          {
            value: "6",
            label: "江源县",
          },
          {
            value: "7",
            label: "临江市",
          },
        ],
      },
      {
        value: "6",
        label: "松原市",
        children: [
          {
            value: "1",
            label: "松原市",
          },
          {
            value: "2",
            label: "宁江区",
          },
          {
            value: "3",
            label: "前郭尔罗斯蒙古族自治县",
          },
          {
            value: "4",
            label: "长岭县",
          },
          {
            value: "5",
            label: "乾安县",
          },
          {
            value: "6",
            label: "扶余县",
          },
        ],
      },
      {
        value: "7",
        label: "白城市",
        children: [
          {
            value: "1",
            label: "白城市",
          },
          {
            value: "2",
            label: "洮北区",
          },
          {
            value: "3",
            label: "镇赉县",
          },
          {
            value: "4",
            label: "通榆县",
          },
          {
            value: "5",
            label: "洮南市",
          },
          {
            value: "6",
            label: "大安市",
          },
        ],
      },
      {
        value: "8",
        label: "延边朝鲜族自治州",
        children: [
          {
            value: "1",
            label: "延吉市",
          },
          {
            value: "2",
            label: "图们市",
          },
          {
            value: "3",
            label: "敦化市",
          },
          {
            value: "4",
            label: "珲春市",
          },
          {
            value: "5",
            label: "龙井市",
          },
          {
            value: "6",
            label: "和龙市",
          },
          {
            value: "7",
            label: "汪清县",
          },
          {
            value: "8",
            label: "安图县",
          },
        ],
      },
    ],
  },
  {
    value: "9",
    label: "黑龙江",
    children: [
      {
        value: "0",
        label: "哈尔滨市",
        children: [
          {
            value: "1",
            label: "哈尔滨市",
          },
          {
            value: "2",
            label: "道里区",
          },
          {
            value: "3",
            label: "南岗区",
          },
          {
            value: "4",
            label: "道外区",
          },
          {
            value: "5",
            label: "香坊区",
          },
          {
            value: "6",
            label: "动力区",
          },
          {
            value: "7",
            label: "平房区",
          },
          {
            value: "8",
            label: "松北区",
          },
          {
            value: "9",
            label: "呼兰区",
          },
          {
            value: "A",
            label: "依兰县",
          },
          {
            value: "B",
            label: "方正县",
          },
          {
            value: "C",
            label: "宾县",
          },
          {
            value: "D",
            label: "巴彦县",
          },
          {
            value: "E",
            label: "木兰县",
          },
          {
            value: "F",
            label: "通河县",
          },
          {
            value: "G",
            label: "延寿县",
          },
          {
            value: "H",
            label: "阿城市",
          },
          {
            value: "I",
            label: "双城市",
          },
          {
            value: "J",
            label: "尚志市",
          },
          {
            value: "K",
            label: "五常市",
          },
        ],
      },
      {
        value: "1",
        label: "齐齐哈尔市",
        children: [
          {
            value: "1",
            label: "齐齐哈尔市",
          },
          {
            value: "2",
            label: "龙沙区",
          },
          {
            value: "3",
            label: "建华区",
          },
          {
            value: "4",
            label: "铁锋区",
          },
          {
            value: "5",
            label: "昂昂溪区",
          },
          {
            value: "6",
            label: "富拉尔基区",
          },
          {
            value: "7",
            label: "碾子山区",
          },
          {
            value: "8",
            label: "梅里斯达斡尔族区",
          },
          {
            value: "9",
            label: "龙江县",
          },
          {
            value: "A",
            label: "依安县",
          },
          {
            value: "B",
            label: "泰来县",
          },
          {
            value: "C",
            label: "甘南县",
          },
          {
            value: "D",
            label: "富裕县",
          },
          {
            value: "E",
            label: "克山县",
          },
          {
            value: "F",
            label: "克东县",
          },
          {
            value: "G",
            label: "拜泉县",
          },
          {
            value: "H",
            label: "讷河市",
          },
        ],
      },
      {
        value: "2",
        label: "鸡西市",
        children: [
          {
            value: "1",
            label: "鸡西市",
          },
          {
            value: "2",
            label: "鸡冠区",
          },
          {
            value: "3",
            label: "恒山区",
          },
          {
            value: "4",
            label: "滴道区",
          },
          {
            value: "5",
            label: "梨树区",
          },
          {
            value: "6",
            label: "城子河区",
          },
          {
            value: "7",
            label: "麻山区",
          },
          {
            value: "8",
            label: "鸡东县",
          },
          {
            value: "9",
            label: "虎林市",
          },
          {
            value: "A",
            label: "密山市",
          },
        ],
      },
      {
        value: "3",
        label: "鹤岗市",
        children: [
          {
            value: "1",
            label: "鹤岗市",
          },
          {
            value: "2",
            label: "向阳区",
          },
          {
            value: "3",
            label: "工农区",
          },
          {
            value: "4",
            label: "南山区",
          },
          {
            value: "5",
            label: "兴安区",
          },
          {
            value: "6",
            label: "东山区",
          },
          {
            value: "7",
            label: "兴山区",
          },
          {
            value: "8",
            label: "萝北县",
          },
          {
            value: "9",
            label: "绥滨县",
          },
        ],
      },
      {
        value: "4",
        label: "双鸭山市",
        children: [
          {
            value: "1",
            label: "双鸭山市",
          },
          {
            value: "2",
            label: "尖山区",
          },
          {
            value: "3",
            label: "岭东区",
          },
          {
            value: "4",
            label: "四方台区",
          },
          {
            value: "5",
            label: "宝山区",
          },
          {
            value: "6",
            label: "集贤县",
          },
          {
            value: "7",
            label: "友谊县",
          },
          {
            value: "8",
            label: "宝清县",
          },
          {
            value: "9",
            label: "饶河县",
          },
        ],
      },
      {
        value: "5",
        label: "大庆市",
        children: [
          {
            value: "1",
            label: "大庆市",
          },
          {
            value: "2",
            label: "萨尔图区",
          },
          {
            value: "3",
            label: "龙凤区",
          },
          {
            value: "4",
            label: "让胡路区",
          },
          {
            value: "5",
            label: "红岗区",
          },
          {
            value: "6",
            label: "大同区",
          },
          {
            value: "7",
            label: "肇州县",
          },
          {
            value: "8",
            label: "肇源县",
          },
          {
            value: "9",
            label: "林甸县",
          },
          {
            value: "A",
            label: "杜尔伯特蒙古族自治县",
          },
        ],
      },
      {
        value: "6",
        label: "伊春市",
        children: [
          {
            value: "1",
            label: "伊春市",
          },
          {
            value: "2",
            label: "伊春区",
          },
          {
            value: "3",
            label: "南岔区",
          },
          {
            value: "4",
            label: "友好区",
          },
          {
            value: "5",
            label: "西林区",
          },
          {
            value: "6",
            label: "翠峦区",
          },
          {
            value: "7",
            label: "新青区",
          },
          {
            value: "8",
            label: "美溪区",
          },
          {
            value: "9",
            label: "金山屯区",
          },
          {
            value: "A",
            label: "五营区",
          },
          {
            value: "B",
            label: "乌马河区",
          },
          {
            value: "C",
            label: "汤旺河区",
          },
          {
            value: "D",
            label: "带岭区",
          },
          {
            value: "E",
            label: "乌伊岭区",
          },
          {
            value: "F",
            label: "红星区",
          },
          {
            value: "G",
            label: "上甘岭区",
          },
          {
            value: "H",
            label: "嘉荫县",
          },
          {
            value: "I",
            label: "铁力市",
          },
        ],
      },
      {
        value: "7",
        label: "佳木斯市",
        children: [
          {
            value: "1",
            label: "佳木斯市",
          },
          {
            value: "2",
            label: "永红区",
          },
          {
            value: "3",
            label: "向阳区",
          },
          {
            value: "4",
            label: "前进区",
          },
          {
            value: "5",
            label: "东风区",
          },
          {
            value: "6",
            label: "郊区",
          },
          {
            value: "7",
            label: "桦南县",
          },
          {
            value: "8",
            label: "桦川县",
          },
          {
            value: "9",
            label: "汤原县",
          },
          {
            value: "A",
            label: "抚远县",
          },
          {
            value: "B",
            label: "同江市",
          },
          {
            value: "C",
            label: "富锦市",
          },
        ],
      },
      {
        value: "8",
        label: "七台河市",
        children: [
          {
            value: "1",
            label: "七台河市",
          },
          {
            value: "2",
            label: "新兴区",
          },
          {
            value: "3",
            label: "桃山区",
          },
          {
            value: "4",
            label: "茄子河区",
          },
          {
            value: "5",
            label: "勃利县",
          },
        ],
      },
      {
        value: "9",
        label: "牡丹江市",
        children: [
          {
            value: "1",
            label: "牡丹江市",
          },
          {
            value: "2",
            label: "东安区",
          },
          {
            value: "3",
            label: "阳明区",
          },
          {
            value: "4",
            label: "爱民区",
          },
          {
            value: "5",
            label: "西安区",
          },
          {
            value: "6",
            label: "东宁县",
          },
          {
            value: "7",
            label: "林口县",
          },
          {
            value: "8",
            label: "绥芬河市",
          },
          {
            value: "9",
            label: "海林市",
          },
          {
            value: "A",
            label: "宁安市",
          },
          {
            value: "B",
            label: "穆棱市",
          },
        ],
      },
      {
        value: "A",
        label: "黑河市",
        children: [
          {
            value: "1",
            label: "黑河市",
          },
          {
            value: "2",
            label: "爱辉区",
          },
          {
            value: "3",
            label: "嫩江县",
          },
          {
            value: "4",
            label: "逊克县",
          },
          {
            value: "5",
            label: "孙吴县",
          },
          {
            value: "6",
            label: "北安市",
          },
          {
            value: "7",
            label: "五大连池市",
          },
        ],
      },
      {
        value: "B",
        label: "绥化市",
        children: [
          {
            value: "1",
            label: "绥化市",
          },
          {
            value: "2",
            label: "北林区",
          },
          {
            value: "3",
            label: "望奎县",
          },
          {
            value: "4",
            label: "兰西县",
          },
          {
            value: "5",
            label: "青冈县",
          },
          {
            value: "6",
            label: "庆安县",
          },
          {
            value: "7",
            label: "明水县",
          },
          {
            value: "8",
            label: "绥棱县",
          },
          {
            value: "9",
            label: "安达市",
          },
          {
            value: "A",
            label: "肇东市",
          },
          {
            value: "B",
            label: "海伦市",
          },
        ],
      },
      {
        value: "C",
        label: "大兴安岭地区",
        children: [
          {
            value: "1",
            label: "呼玛县",
          },
          {
            value: "2",
            label: "塔河县",
          },
          {
            value: "3",
            label: "漠河县",
          },
        ],
      },
    ],
  },
  {
    value: "A",
    label: "江苏",
    children: [
      {
        value: "1",
        label: "南京市",
        children: [
          {
            value: "1",
            label: "南京市",
          },
          {
            value: "2",
            label: "玄武区",
          },
          {
            value: "3",
            label: "白下区",
          },
          {
            value: "4",
            label: "秦淮区",
          },
          {
            value: "5",
            label: "建邺区",
          },
          {
            value: "6",
            label: "鼓楼区",
          },
          {
            value: "7",
            label: "下关区",
          },
          {
            value: "8",
            label: "浦口区",
          },
          {
            value: "9",
            label: "栖霞区",
          },
          {
            value: "A",
            label: "雨花台区",
          },
          {
            value: "B",
            label: "江宁区",
          },
          {
            value: "C",
            label: "六合区",
          },
          {
            value: "D",
            label: "溧水县",
          },
          {
            value: "E",
            label: "高淳县",
          },
        ],
      },
      {
        value: "2",
        label: "无锡市",
        children: [
          {
            value: "1",
            label: "无锡市",
          },
          {
            value: "2",
            label: "新吴区",
          },
          {
            value: "3",
            label: "南长区",
          },
          {
            value: "4",
            label: "北塘区",
          },
          {
            value: "5",
            label: "锡山区",
          },
          {
            value: "6",
            label: "惠山区",
          },
          {
            value: "7",
            label: "滨湖区",
          },
          {
            value: "8",
            label: "江阴市",
          },
          {
            value: "9",
            label: "宜兴市",
          },
          {
            value: "A",
            label: "梁溪区",
          },
        ],
      },
      {
        value: "3",
        label: "徐州市",
        children: [
          {
            value: "1",
            label: "徐州市",
          },
          {
            value: "2",
            label: "鼓楼区",
          },
          {
            value: "3",
            label: "云龙区",
          },
          {
            value: "4",
            label: "九里区",
          },
          {
            value: "5",
            label: "贾汪区",
          },
          {
            value: "6",
            label: "泉山区",
          },
          {
            value: "7",
            label: "丰县",
          },
          {
            value: "8",
            label: "沛县",
          },
          {
            value: "9",
            label: "铜山县",
          },
          {
            value: "A",
            label: "睢宁县",
          },
          {
            value: "B",
            label: "新沂市",
          },
          {
            value: "C",
            label: "邳州市",
          },
        ],
      },
      {
        value: "4",
        label: "常州市",
        children: [
          {
            value: "1",
            label: "常州市",
          },
          {
            value: "2",
            label: "天宁区",
          },
          {
            value: "3",
            label: "钟楼区",
          },
          {
            value: "4",
            label: "戚墅堰区",
          },
          {
            value: "5",
            label: "新北区",
          },
          {
            value: "6",
            label: "武进区",
          },
          {
            value: "7",
            label: "溧阳市",
          },
          {
            value: "8",
            label: "金坛市",
          },
        ],
      },
      {
        value: "5",
        label: "苏州市",
        children: [
          {
            value: "1",
            label: "苏州市",
          },
          {
            value: "2",
            label: "姑苏区",
          },
          {
            value: "5",
            label: "虎丘区",
          },
          {
            value: "6",
            label: "吴中区",
          },
          {
            value: "7",
            label: "相城区",
          },
          {
            value: "8",
            label: "常熟市",
          },
          {
            value: "9",
            label: "张家港市",
          },
          {
            value: "A",
            label: "昆山市",
          },
          {
            value: "B",
            label: "吴江市",
          },
          {
            value: "C",
            label: "太仓市",
          },
          {
            value: "D",
            label: "苏州工业园区",
          },
        ],
      },
      {
        value: "6",
        label: "南通市",
        children: [
          {
            value: "1",
            label: "南通市",
          },
          {
            value: "2",
            label: "崇川区",
          },
          {
            value: "3",
            label: "港闸区",
          },
          {
            value: "4",
            label: "海安县",
          },
          {
            value: "5",
            label: "如东县",
          },
          {
            value: "6",
            label: "启东市",
          },
          {
            value: "7",
            label: "如皋市",
          },
          {
            value: "8",
            label: "通州市",
          },
          {
            value: "9",
            label: "海门市",
          },
        ],
      },
      {
        value: "7",
        label: "连云港市",
        children: [
          {
            value: "1",
            label: "连云港市",
          },
          {
            value: "2",
            label: "连云区",
          },
          {
            value: "3",
            label: "新浦区",
          },
          {
            value: "4",
            label: "海州区",
          },
          {
            value: "5",
            label: "赣榆县",
          },
          {
            value: "6",
            label: "东海县",
          },
          {
            value: "7",
            label: "灌云县",
          },
          {
            value: "8",
            label: "灌南县",
          },
        ],
      },
      {
        value: "8",
        label: "淮安市",
        children: [
          {
            value: "1",
            label: "淮安市",
          },
          {
            value: "2",
            label: "清河区",
          },
          {
            value: "3",
            label: "楚州区",
          },
          {
            value: "4",
            label: "淮阴区",
          },
          {
            value: "5",
            label: "清浦区",
          },
          {
            value: "6",
            label: "涟水县",
          },
          {
            value: "7",
            label: "洪泽县",
          },
          {
            value: "8",
            label: "盱眙县",
          },
          {
            value: "9",
            label: "金湖县",
          },
        ],
      },
      {
        value: "9",
        label: "盐城市",
        children: [
          {
            value: "1",
            label: "盐城市",
          },
          {
            value: "2",
            label: "亭湖区",
          },
          {
            value: "3",
            label: "盐都区",
          },
          {
            value: "4",
            label: "响水县",
          },
          {
            value: "5",
            label: "滨海县",
          },
          {
            value: "6",
            label: "阜宁县",
          },
          {
            value: "7",
            label: "射阳县",
          },
          {
            value: "8",
            label: "建湖县",
          },
          {
            value: "9",
            label: "东台市",
          },
          {
            value: "A",
            label: "大丰市",
          },
        ],
      },
      {
        value: "A",
        label: "扬州市",
        children: [
          {
            value: "1",
            label: "扬州市",
          },
          {
            value: "2",
            label: "广陵区",
          },
          {
            value: "3",
            label: "邗江区",
          },
          {
            value: "4",
            label: "郊区",
          },
          {
            value: "5",
            label: "宝应县",
          },
          {
            value: "6",
            label: "仪征市",
          },
          {
            value: "7",
            label: "高邮市",
          },
          {
            value: "8",
            label: "江都市",
          },
        ],
      },
      {
        value: "B",
        label: "镇江市",
        children: [
          {
            value: "1",
            label: "镇江市",
          },
          {
            value: "2",
            label: "京口区",
          },
          {
            value: "3",
            label: "润州区",
          },
          {
            value: "4",
            label: "丹徒区",
          },
          {
            value: "5",
            label: "丹阳市",
          },
          {
            value: "6",
            label: "扬中市",
          },
          {
            value: "7",
            label: "句容市",
          },
        ],
      },
      {
        value: "C",
        label: "泰州市",
        children: [
          {
            value: "1",
            label: "泰州市",
          },
          {
            value: "2",
            label: "海陵区",
          },
          {
            value: "3",
            label: "高港区",
          },
          {
            value: "4",
            label: "兴化市",
          },
          {
            value: "5",
            label: "靖江市",
          },
          {
            value: "6",
            label: "泰兴市",
          },
          {
            value: "7",
            label: "姜堰市",
          },
        ],
      },
      {
        value: "D",
        label: "宿迁市",
        children: [
          {
            value: "1",
            label: "宿迁市",
          },
          {
            value: "2",
            label: "宿城区",
          },
          {
            value: "3",
            label: "宿豫区",
          },
          {
            value: "4",
            label: "沭阳县",
          },
          {
            value: "5",
            label: "泗阳县",
          },
          {
            value: "6",
            label: "泗洪县",
          },
        ],
      },
    ],
  },
  {
    value: "B",
    label: "浙江",
    children: [
      {
        value: "0",
        label: "杭州市",
        children: [
          {
            value: "1",
            label: "杭州市",
          },
          {
            value: "2",
            label: "上城区",
          },
          {
            value: "3",
            label: "下城区",
          },
          {
            value: "4",
            label: "江干区",
          },
          {
            value: "5",
            label: "拱墅区",
          },
          {
            value: "6",
            label: "西湖区",
          },
          {
            value: "7",
            label: "滨江区",
          },
          {
            value: "8",
            label: "萧山区",
          },
          {
            value: "9",
            label: "余杭区",
          },
          {
            value: "A",
            label: "桐庐县",
          },
          {
            value: "B",
            label: "淳安县",
          },
          {
            value: "C",
            label: "建德市",
          },
          {
            value: "D",
            label: "富阳市",
          },
          {
            value: "E",
            label: "临安市",
          },
        ],
      },
      {
        value: "1",
        label: "宁波市",
        children: [
          {
            value: "1",
            label: "宁波市",
          },
          {
            value: "2",
            label: "海曙区",
          },
          {
            value: "3",
            label: "江东区",
          },
          {
            value: "4",
            label: "江北区",
          },
          {
            value: "5",
            label: "北仑区",
          },
          {
            value: "6",
            label: "镇海区",
          },
          {
            value: "7",
            label: "鄞州区",
          },
          {
            value: "8",
            label: "象山县",
          },
          {
            value: "9",
            label: "宁海县",
          },
          {
            value: "A",
            label: "余姚市",
          },
          {
            value: "B",
            label: "慈溪市",
          },
          {
            value: "C",
            label: "奉化市",
          },
        ],
      },
      {
        value: "2",
        label: "温州市",
        children: [
          {
            value: "1",
            label: "温州市",
          },
          {
            value: "2",
            label: "鹿城区",
          },
          {
            value: "3",
            label: "龙湾区",
          },
          {
            value: "4",
            label: "瓯海区",
          },
          {
            value: "5",
            label: "洞头县",
          },
          {
            value: "6",
            label: "永嘉县",
          },
          {
            value: "7",
            label: "平阳县",
          },
          {
            value: "8",
            label: "苍南县",
          },
          {
            value: "9",
            label: "文成县",
          },
          {
            value: "A",
            label: "泰顺县",
          },
          {
            value: "B",
            label: "瑞安市",
          },
          {
            value: "C",
            label: "乐清市",
          },
        ],
      },
      {
        value: "3",
        label: "嘉兴市",
        children: [
          {
            value: "1",
            label: "嘉兴市",
          },
          {
            value: "2",
            label: "秀城区",
          },
          {
            value: "3",
            label: "秀洲区",
          },
          {
            value: "4",
            label: "嘉善县",
          },
          {
            value: "5",
            label: "海盐县",
          },
          {
            value: "6",
            label: "海宁市",
          },
          {
            value: "7",
            label: "平湖市",
          },
          {
            value: "8",
            label: "桐乡市",
          },
          {
            value: "9",
            label: "南湖区",
          },
        ],
      },
      {
        value: "4",
        label: "湖州市",
        children: [
          {
            value: "1",
            label: "湖州市",
          },
          {
            value: "2",
            label: "吴兴区",
          },
          {
            value: "3",
            label: "南浔区",
          },
          {
            value: "4",
            label: "德清县",
          },
          {
            value: "5",
            label: "长兴县",
          },
          {
            value: "6",
            label: "安吉县",
          },
        ],
      },
      {
        value: "5",
        label: "绍兴市",
        children: [
          { value: "1", label: "绍兴市" },
          { value: "2", label: "越城区" },
          { value: "3", label: "绍兴县" },
          { value: "4", label: "新昌县" },
          { value: "5", label: "诸暨市" },
          { value: "6", label: "上虞市" },
          { value: "7", label: "嵊州市" },
          { value: "8", label: "柯桥区" },
        ],
      },
      {
        value: "6",
        label: "金华市",
        children: [
          {
            value: "1",
            label: "金华市",
          },
          {
            value: "2",
            label: "婺城区",
          },
          {
            value: "3",
            label: "金东区",
          },
          {
            value: "4",
            label: "武义县",
          },
          {
            value: "5",
            label: "浦江县",
          },
          {
            value: "6",
            label: "磐安县",
          },
          {
            value: "7",
            label: "兰溪市",
          },
          {
            value: "8",
            label: "义乌市",
          },
          {
            value: "9",
            label: "东阳市",
          },
          {
            value: "A",
            label: "永康市",
          },
        ],
      },
      {
        value: "7",
        label: "衢州市",
        children: [
          { value: "1", label: "衢州市" },
          { value: "2", label: "柯城区" },
          { value: "3", label: "衢江区" },
          { value: "4", label: "常山县" },
          { value: "5", label: "开化县" },
          { value: "6", label: "龙游县" },
          { value: "7", label: "江山市" },
        ],
      },
      {
        value: "8",
        label: "舟山市",
        children: [
          { value: "1", label: "舟山市" },
          { value: "2", label: "定海区" },
          { value: "3", label: "普陀区" },
          { value: "4", label: "岱山县" },
          { value: "5", label: "嵊泗县" },
        ],
      },
      {
        value: "9",
        label: "台州市",
        children: [
          { value: "1", label: "台州市" },
          { value: "2", label: "椒江区" },
          { value: "3", label: "黄岩区" },
          { value: "4", label: "路桥区" },
          { value: "5", label: "玉环县" },
          { value: "6", label: "三门县" },
          { value: "7", label: "天台县" },
          { value: "8", label: "仙居县" },
          { value: "9", label: "温岭市" },
          { value: "A", label: "临海市" },
        ],
      },
      {
        value: "A",
        label: "丽水市",
        children: [
          { value: "1", label: "丽水市" },
          { value: "2", label: "莲都区" },
          { value: "3", label: "青田县" },
          { value: "4", label: "缙云县" },
          { value: "5", label: "遂昌县" },
          { value: "6", label: "松阳县" },
          { value: "7", label: "云和县" },
          { value: "8", label: "庆元县" },
          { value: "9", label: "景宁畲族自治县" },
          { value: "A", label: "龙泉市" },
        ],
      },
    ],
  },
  {
    value: "C",
    label: "安徽",
    children: [
      {
        value: "1",
        label: "合肥市",
        children: [
          { value: "1", label: "瑶海区" },
          { value: "2", label: "庐阳区" },
          { value: "3", label: "蜀山区" },
          { value: "4", label: "包河区" },
          { value: "5", label: "长丰县" },
          { value: "6", label: "肥东县" },
          { value: "7", label: "肥西县" },
          { value: "8", label: "滨湖新区" },
          { value: "9", label: "金开区" },
        ],
      },
      {
        value: "2",
        label: "芜湖市",
        children: [
          { value: "1", label: "镜湖区" },
          { value: "2", label: "马塘区" },
          { value: "3", label: "新芜区" },
          { value: "4", label: "鸠江区" },
          { value: "5", label: "芜湖县" },
          { value: "6", label: "繁昌县" },
          { value: "7", label: "南陵县" },
          { value: "8", label: "弋江区" },
        ],
      },
      {
        value: "3",
        label: "蚌埠市",
        children: [
          { value: "1", label: "龙子湖区" },
          { value: "2", label: "蚌山区" },
          { value: "3", label: "禹会区" },
          { value: "4", label: "淮上区" },
          { value: "5", label: "怀远县" },
          { value: "6", label: "五河县" },
          { value: "7", label: "固镇县" },
        ],
      },
      {
        value: "4",
        label: "淮南市",
        children: [
          { value: "1", label: "大通区" },
          { value: "2", label: "田家庵区" },
          { value: "3", label: "谢家集区" },
          { value: "4", label: "八公山区" },
          { value: "5", label: "潘集区" },
          { value: "6", label: "凤台县" },
        ],
      },
      {
        value: "5",
        label: "马鞍山市",
        children: [
          { value: "1", label: "金家庄区" },
          { value: "2", label: "花山区" },
          { value: "3", label: "雨山区" },
          { value: "4", label: "当涂县" },
          { value: "5", label: "含山县" },
          { value: "6", label: "和县" },
        ],
      },
      {
        value: "6",
        label: "淮北市",
        children: [
          { value: "1", label: "杜集区" },
          { value: "2", label: "相山区" },
          { value: "3", label: "烈山区" },
          { value: "4", label: "濉溪县" },
        ],
      },
      {
        value: "7",
        label: "铜陵市",
        children: [
          { value: "1", label: "铜官山区" },
          { value: "2", label: "狮子山区" },
          { value: "3", label: "郊区" },
          { value: "4", label: "铜陵县" },
        ],
      },
      {
        value: "8",
        label: "安庆市",
        children: [
          { value: "1", label: "迎江区" },
          { value: "2", label: "大观区" },
          { value: "3", label: "郊区" },
          { value: "4", label: "怀宁县" },
          { value: "5", label: "枞阳县" },
          { value: "6", label: "潜山县" },
          { value: "7", label: "太湖县" },
          { value: "8", label: "宿松县" },
          { value: "9", label: "望江县" },
          { value: "A", label: "岳西县" },
          { value: "B", label: "桐城市" },
        ],
      },
      {
        value: "9",
        label: "黄山市",
        children: [
          {
            value: "1",
            label: "屯溪区",
          },
          {
            value: "2",
            label: "黄山区",
          },
          {
            value: "3",
            label: "徽州区",
          },
          {
            value: "4",
            label: "歙县",
          },
          {
            value: "5",
            label: "休宁县",
          },
          {
            value: "6",
            label: "黟县",
          },
          {
            value: "7",
            label: "祁门县",
          },
        ],
      },
      {
        value: "A",
        label: "滁州市",
        children: [
          {
            value: "1",
            label: "琅琊区",
          },
          {
            value: "2",
            label: "南谯区",
          },
          {
            value: "3",
            label: "来安县",
          },
          {
            value: "4",
            label: "全椒县",
          },
          {
            value: "5",
            label: "定远县",
          },
          {
            value: "6",
            label: "凤阳县",
          },
          {
            value: "7",
            label: "天长市",
          },
          {
            value: "8",
            label: "明光市",
          },
        ],
      },
      {
        value: "B",
        label: "阜阳市",
        children: [
          {
            value: "1",
            label: "颍州区",
          },
          {
            value: "2",
            label: "颍东区",
          },
          {
            value: "3",
            label: "颍泉区",
          },
          {
            value: "4",
            label: "临泉县",
          },
          {
            value: "5",
            label: "太和县",
          },
          {
            value: "6",
            label: "阜南县",
          },
          {
            value: "7",
            label: "颍上县",
          },
          {
            value: "8",
            label: "界首市",
          },
        ],
      },
      {
        value: "C",
        label: "宿州市",
        children: [
          {
            value: "1",
            label: "墉桥区",
          },
          {
            value: "2",
            label: "砀山县",
          },
          {
            value: "3",
            label: "萧县",
          },
          {
            value: "4",
            label: "灵璧县",
          },
          {
            value: "5",
            label: "泗县",
          },
        ],
      },
      {
        value: "D",
        label: "巢湖市",
        children: [
          {
            value: "1",
            label: "居巢区",
          },
          {
            value: "2",
            label: "庐江县",
          },
          {
            value: "3",
            label: "无为县",
          },
          {
            value: "4",
            label: "含山县",
          },
          {
            value: "5",
            label: "和县",
          },
        ],
      },
      {
        value: "E",
        label: "六安市",
        children: [
          {
            value: "1",
            label: "金安区",
          },
          {
            value: "2",
            label: "裕安区",
          },
          {
            value: "3",
            label: "寿县",
          },
          {
            value: "4",
            label: "霍邱县",
          },
          {
            value: "5",
            label: "舒城县",
          },
          {
            value: "6",
            label: "金寨县",
          },
          {
            value: "7",
            label: "霍山县",
          },
        ],
      },
      {
        value: "F",
        label: "亳州市",
        children: [
          {
            value: "1",
            label: "谯城区",
          },
          {
            value: "2",
            label: "涡阳县",
          },
          {
            value: "3",
            label: "蒙城县",
          },
          {
            value: "4",
            label: "利辛县",
          },
        ],
      },
      {
        value: "G",
        label: "池州市",
        children: [
          {
            value: "1",
            label: "贵池区",
          },
          {
            value: "2",
            label: "东至县",
          },
          {
            value: "3",
            label: "石台县",
          },
          {
            value: "4",
            label: "青阳县",
          },
        ],
      },
      {
        value: "H",
        label: "宣城市",
        children: [
          {
            value: "1",
            label: "宣州区",
          },
          {
            value: "2",
            label: "郎溪县",
          },
          {
            value: "3",
            label: "广德县",
          },
          {
            value: "4",
            label: "泾县",
          },
          {
            value: "5",
            label: "绩溪县",
          },
          {
            value: "6",
            label: "旌德县",
          },
          {
            value: "7",
            label: "宁国市",
          },
        ],
      },
    ],
  },
  {
    value: "D",
    label: "福建",
    children: [
      {
        value: "1",
        label: "福州市",
        children: [
          {
            value: "1",
            label: "鼓楼区",
          },
          {
            value: "2",
            label: "台江区",
          },
          {
            value: "3",
            label: "仓山区",
          },
          {
            value: "4",
            label: "马尾区",
          },
          {
            value: "5",
            label: "晋安区",
          },
          {
            value: "6",
            label: "闽侯县",
          },
          {
            value: "7",
            label: "连江县",
          },
          {
            value: "8",
            label: "罗源县",
          },
          {
            value: "9",
            label: "闽清县",
          },
          {
            value: "A",
            label: "永泰县",
          },
          {
            value: "B",
            label: "平潭县",
          },
          {
            value: "C",
            label: "福清市",
          },
          {
            value: "D",
            label: "长乐市",
          },
        ],
      },
      {
        value: "2",
        label: "厦门市",
        children: [
          {
            value: "1",
            label: "思明区",
          },
          {
            value: "2",
            label: "海沧区",
          },
          {
            value: "3",
            label: "湖里区",
          },
          {
            value: "4",
            label: "集美区",
          },
          {
            value: "5",
            label: "同安区",
          },
          {
            value: "6",
            label: "翔安区",
          },
        ],
      },
      {
        value: "3",
        label: "莆田市",
        children: [
          {
            value: "1",
            label: "城厢区",
          },
          {
            value: "2",
            label: "涵江区",
          },
          {
            value: "3",
            label: "荔城区",
          },
          {
            value: "4",
            label: "秀屿区",
          },
          {
            value: "5",
            label: "仙游县",
          },
        ],
      },
      {
        value: "4",
        label: "三明市",
        children: [
          {
            value: "1",
            label: "梅列区",
          },
          {
            value: "2",
            label: "三元区",
          },
          {
            value: "3",
            label: "明溪县",
          },
          {
            value: "4",
            label: "清流县",
          },
          {
            value: "5",
            label: "宁化县",
          },
          {
            value: "6",
            label: "大田县",
          },
          {
            value: "7",
            label: "尤溪县",
          },
          {
            value: "8",
            label: "沙县",
          },
          {
            value: "9",
            label: "将乐县",
          },
          {
            value: "A",
            label: "泰宁县",
          },
          {
            value: "B",
            label: "建宁县",
          },
          {
            value: "C",
            label: "永安市",
          },
        ],
      },
      {
        value: "5",
        label: "泉州市",
        children: [
          {
            value: "1",
            label: "鲤城区",
          },
          {
            value: "2",
            label: "丰泽区",
          },
          {
            value: "3",
            label: "洛江区",
          },
          {
            value: "4",
            label: "泉港区",
          },
          {
            value: "5",
            label: "惠安县",
          },
          {
            value: "6",
            label: "安溪县",
          },
          {
            value: "7",
            label: "永春县",
          },
          {
            value: "8",
            label: "德化县",
          },
          {
            value: "9",
            label: "金门县",
          },
          {
            value: "A",
            label: "石狮市",
          },
          {
            value: "B",
            label: "晋江市",
          },
          {
            value: "C",
            label: "南安市",
          },
        ],
      },
      {
        value: "6",
        label: "漳州市",
        children: [
          {
            value: "1",
            label: "芗城区",
          },
          {
            value: "2",
            label: "龙文区",
          },
          {
            value: "3",
            label: "云霄县",
          },
          {
            value: "4",
            label: "漳浦县",
          },
          {
            value: "5",
            label: "诏安县",
          },
          {
            value: "6",
            label: "长泰县",
          },
          {
            value: "7",
            label: "东山县",
          },
          {
            value: "8",
            label: "南靖县",
          },
          {
            value: "9",
            label: "平和县",
          },
          {
            value: "A",
            label: "华安县",
          },
          {
            value: "B",
            label: "龙海市",
          },
        ],
      },
      {
        value: "7",
        label: "南平市",
        children: [
          {
            value: "1",
            label: "延平区",
          },
          {
            value: "2",
            label: "顺昌县",
          },
          {
            value: "3",
            label: "浦城县",
          },
          {
            value: "4",
            label: "光泽县",
          },
          {
            value: "5",
            label: "松溪县",
          },
          {
            value: "6",
            label: "政和县",
          },
          {
            value: "7",
            label: "邵武市",
          },
          {
            value: "8",
            label: "武夷山市",
          },
          {
            value: "9",
            label: "建瓯市",
          },
          {
            value: "A",
            label: "建阳市",
          },
        ],
      },
      {
        value: "8",
        label: "龙岩市",
        children: [
          {
            value: "1",
            label: "新罗区",
          },
          {
            value: "2",
            label: "长汀县",
          },
          {
            value: "3",
            label: "永定县",
          },
          {
            value: "4",
            label: "上杭县",
          },
          {
            value: "5",
            label: "武平县",
          },
          {
            value: "6",
            label: "连城县",
          },
          {
            value: "7",
            label: "漳平市",
          },
        ],
      },
      {
        value: "9",
        label: "宁德市",
        children: [
          {
            value: "1",
            label: "蕉城区",
          },
          {
            value: "2",
            label: "霞浦县",
          },
          {
            value: "3",
            label: "古田县",
          },
          {
            value: "4",
            label: "屏南县",
          },
          {
            value: "5",
            label: "寿宁县",
          },
          {
            value: "6",
            label: "周宁县",
          },
          {
            value: "7",
            label: "柘荣县",
          },
          {
            value: "8",
            label: "福安市",
          },
          {
            value: "9",
            label: "福鼎市",
          },
        ],
      },
    ],
  },
  {
    value: "E",
    label: "江西",
    children: [
      {
        value: "1",
        label: "南昌市",
        children: [
          {
            value: "1",
            label: "东湖区",
          },
          {
            value: "2",
            label: "西湖区",
          },
          {
            value: "3",
            label: "青云谱区",
          },
          {
            value: "4",
            label: "湾里区",
          },
          {
            value: "5",
            label: "青山湖区",
          },
          {
            value: "6",
            label: "南昌县",
          },
          {
            value: "7",
            label: "新建县",
          },
          {
            value: "8",
            label: "安义县",
          },
          {
            value: "9",
            label: "进贤县",
          },
        ],
      },
      {
        value: "2",
        label: "景德镇市",
        children: [
          {
            value: "1",
            label: "昌江区",
          },
          {
            value: "2",
            label: "珠山区",
          },
          {
            value: "3",
            label: "浮梁县",
          },
          {
            value: "4",
            label: "乐平市",
          },
          {
            value: "5",
            label: "高新 ",
          },
          {
            value: "6",
            label: "东市区",
          },
        ],
      },
      {
        value: "3",
        label: "萍乡市",
        children: [
          {
            value: "1",
            label: "安源区",
          },
          {
            value: "2",
            label: "湘东区",
          },
          {
            value: "3",
            label: "莲花县",
          },
          {
            value: "4",
            label: "上栗县",
          },
          {
            value: "5",
            label: "芦溪县",
          },
        ],
      },
      {
        value: "4",
        label: "九江市",
        children: [
          {
            value: "1",
            label: "濂溪区",
          },
          {
            value: "2",
            label: "浔阳区",
          },
          {
            value: "3",
            label: "柴桑县",
          },
          {
            value: "4",
            label: "武宁县",
          },
          {
            value: "5",
            label: "修水县",
          },
          {
            value: "6",
            label: "永修县",
          },
          {
            value: "7",
            label: "德安县",
          },
          {
            value: "8",
            label: "庐山市",
          },
          {
            value: "9",
            label: "都昌县",
          },
          {
            value: "A",
            label: "湖口县",
          },
          {
            value: "B",
            label: "彭泽县",
          },
          {
            value: "C",
            label: "瑞昌市",
          },
        ],
      },
      {
        value: "5",
        label: "新余市",
        children: [
          {
            value: "1",
            label: "渝水区",
          },
          {
            value: "2",
            label: "分宜县",
          },
          {
            value: "3",
            label: "高新区",
          },
        ],
      },
      {
        value: "6",
        label: "鹰潭市",
        children: [
          {
            value: "1",
            label: "月湖区",
          },
          {
            value: "2",
            label: "余江县",
          },
          {
            value: "3",
            label: "贵溪市",
          },
        ],
      },
      {
        value: "7",
        label: "赣州市",
        children: [
          {
            value: "1",
            label: "章贡区",
          },
          {
            value: "2",
            label: "赣县",
          },
          {
            value: "3",
            label: "信丰县",
          },
          {
            value: "4",
            label: "大余县",
          },
          {
            value: "5",
            label: "上犹县",
          },
          {
            value: "6",
            label: "崇义县",
          },
          {
            value: "7",
            label: "安远县",
          },
          {
            value: "8",
            label: "龙南县",
          },
          {
            value: "9",
            label: "定南县",
          },
          {
            value: "A",
            label: "全南县",
          },
          {
            value: "B",
            label: "宁都县",
          },
          {
            value: "C",
            label: "于都县",
          },
          {
            value: "D",
            label: "兴国县",
          },
          {
            value: "E",
            label: "寻乌县",
          },
          {
            value: "F",
            label: "会昌县",
          },
          {
            value: "G",
            label: "石城县",
          },
          {
            value: "H",
            label: "瑞金市",
          },
          {
            value: "I",
            label: "南康市",
          },
        ],
      },
      {
        value: "8",
        label: "吉安市",
        children: [
          {
            value: "1",
            label: "吉州区",
          },
          {
            value: "2",
            label: "青原区",
          },
          {
            value: "3",
            label: "吉安县",
          },
          {
            value: "4",
            label: "吉水县",
          },
          {
            value: "5",
            label: "峡江县",
          },
          {
            value: "6",
            label: "新干县",
          },
          {
            value: "7",
            label: "永丰县",
          },
          {
            value: "8",
            label: "泰和县",
          },
          {
            value: "9",
            label: "遂川县",
          },
          {
            value: "A",
            label: "万安县",
          },
          {
            value: "B",
            label: "安福县",
          },
          {
            value: "C",
            label: "永新县",
          },
          {
            value: "D",
            label: "井冈山市",
          },
        ],
      },
      {
        value: "9",
        label: "宜春市",
        children: [
          {
            value: "1",
            label: "袁州区",
          },
          {
            value: "2",
            label: "奉新县",
          },
          {
            value: "3",
            label: "万载县",
          },
          {
            value: "4",
            label: "上高县",
          },
          {
            value: "5",
            label: "宜丰县",
          },
          {
            value: "6",
            label: "靖安县",
          },
          {
            value: "7",
            label: "铜鼓县",
          },
          {
            value: "8",
            label: "丰城市",
          },
          {
            value: "9",
            label: "樟树市",
          },
          {
            value: "A",
            label: "高安市",
          },
        ],
      },
      {
        value: "A",
        label: "抚州市",
        children: [
          {
            value: "1",
            label: "临川区",
          },
          {
            value: "2",
            label: "南城县",
          },
          {
            value: "3",
            label: "黎川县",
          },
          {
            value: "4",
            label: "南丰县",
          },
          {
            value: "5",
            label: "崇仁县",
          },
          {
            value: "6",
            label: "乐安县",
          },
          {
            value: "7",
            label: "宜黄县",
          },
          {
            value: "8",
            label: "金溪县",
          },
          {
            value: "9",
            label: "资溪县",
          },
          {
            value: "A",
            label: "东乡县",
          },
          {
            value: "B",
            label: "广昌县",
          },
        ],
      },
      {
        value: "B",
        label: "上饶市",
        children: [
          {
            value: "1",
            label: "信州区",
          },
          {
            value: "2",
            label: "上饶县",
          },
          {
            value: "3",
            label: "广丰县",
          },
          {
            value: "4",
            label: "玉山县",
          },
          {
            value: "5",
            label: "铅山县",
          },
          {
            value: "6",
            label: "横峰县",
          },
          {
            value: "7",
            label: "弋阳县",
          },
          {
            value: "8",
            label: "余干县",
          },
          {
            value: "9",
            label: "鄱阳县",
          },
          {
            value: "A",
            label: "万年县",
          },
          {
            value: "B",
            label: "婺源县",
          },
          {
            value: "C",
            label: "德兴市",
          },
        ],
      },
    ],
  },
  {
    value: "F",
    label: "山东",
    children: [
      {
        value: "1",
        label: "济南市",
        children: [
          {
            value: "1",
            label: "历下区",
          },
          {
            value: "2",
            label: "市中区",
          },
          {
            value: "3",
            label: "槐荫区",
          },
          {
            value: "4",
            label: "天桥区",
          },
          {
            value: "5",
            label: "历城区",
          },
          {
            value: "6",
            label: "长清区",
          },
          {
            value: "7",
            label: "平阴县",
          },
          {
            value: "8",
            label: "济阳县",
          },
          {
            value: "9",
            label: "商河县",
          },
          {
            value: "A",
            label: "章丘市",
          },
        ],
      },
      {
        value: "2",
        label: "青岛市",
        children: [
          {
            value: "1",
            label: "市南区",
          },
          {
            value: "2",
            label: "市北区",
          },
          {
            value: "3",
            label: "四方区",
          },
          {
            value: "4",
            label: "黄岛区",
          },
          {
            value: "5",
            label: "崂山区",
          },
          {
            value: "6",
            label: "李沧区",
          },
          {
            value: "7",
            label: "城阳区",
          },
          {
            value: "8",
            label: "胶州市",
          },
          {
            value: "9",
            label: "即墨市",
          },
          {
            value: "A",
            label: "平度市",
          },
          {
            value: "B",
            label: "胶南市",
          },
          {
            value: "C",
            label: "莱西市",
          },
        ],
      },
      {
        value: "3",
        label: "淄博市",
        children: [
          {
            value: "1",
            label: "淄川区",
          },
          {
            value: "2",
            label: "张店区",
          },
          {
            value: "3",
            label: "博山区",
          },
          {
            value: "4",
            label: "临淄区",
          },
          {
            value: "5",
            label: "周村区",
          },
          {
            value: "6",
            label: "桓台县",
          },
          {
            value: "7",
            label: "高青县",
          },
          {
            value: "8",
            label: "沂源县",
          },
        ],
      },
      {
        value: "4",
        label: "枣庄市",
        children: [
          {
            value: "1",
            label: "市中区",
          },
          {
            value: "2",
            label: "薛城区",
          },
          {
            value: "3",
            label: "峄城区",
          },
          {
            value: "4",
            label: "台儿庄区",
          },
          {
            value: "5",
            label: "山亭区",
          },
          {
            value: "6",
            label: "滕州市",
          },
        ],
      },
      {
        value: "5",
        label: "东营市",
        children: [
          {
            value: "1",
            label: "东营区",
          },
          {
            value: "2",
            label: "河口区",
          },
          {
            value: "3",
            label: "垦利县",
          },
          {
            value: "4",
            label: "利津县",
          },
          {
            value: "5",
            label: "广饶县",
          },
        ],
      },
      {
        value: "6",
        label: "烟台市",
        children: [
          {
            value: "1",
            label: "芝罘区",
          },
          {
            value: "2",
            label: "福山区",
          },
          {
            value: "3",
            label: "牟平区",
          },
          {
            value: "4",
            label: "莱山区",
          },
          {
            value: "5",
            label: "长岛县",
          },
          {
            value: "6",
            label: "龙口市",
          },
          {
            value: "7",
            label: "莱阳市",
          },
          {
            value: "8",
            label: "莱州市",
          },
          {
            value: "9",
            label: "蓬莱市",
          },
          {
            value: "A",
            label: "招远市",
          },
          {
            value: "B",
            label: "栖霞市",
          },
          {
            value: "C",
            label: "海阳市",
          },
        ],
      },
      {
        value: "7",
        label: "潍坊市",
        children: [
          {
            value: "1",
            label: "潍城区",
          },
          {
            value: "2",
            label: "寒亭区",
          },
          {
            value: "3",
            label: "坊子区",
          },
          {
            value: "4",
            label: "奎文区",
          },
          {
            value: "5",
            label: "临朐县",
          },
          {
            value: "6",
            label: "昌乐县",
          },
          {
            value: "7",
            label: "青州市",
          },
          {
            value: "8",
            label: "诸城市",
          },
          {
            value: "9",
            label: "寿光市",
          },
          {
            value: "A",
            label: "安丘市",
          },
          {
            value: "B",
            label: "高密市",
          },
          {
            value: "C",
            label: "昌邑市",
          },
          {
            value: "D",
            label: "益都",
          },
        ],
      },
      {
        value: "8",
        label: "济宁市",
        children: [
          {
            value: "1",
            label: "市中区",
          },
          {
            value: "2",
            label: "任城区",
          },
          {
            value: "3",
            label: "微山县",
          },
          {
            value: "4",
            label: "鱼台县",
          },
          {
            value: "5",
            label: "金乡县",
          },
          {
            value: "6",
            label: "嘉祥县",
          },
          {
            value: "7",
            label: "汶上县",
          },
          {
            value: "8",
            label: "泗水县",
          },
          {
            value: "9",
            label: "梁山县",
          },
          {
            value: "A",
            label: "曲阜市",
          },
          {
            value: "B",
            label: "兖州市",
          },
          {
            value: "C",
            label: "邹城市",
          },
        ],
      },
      {
        value: "9",
        label: "泰安市",
        children: [
          {
            value: "1",
            label: "泰山区",
          },
          {
            value: "2",
            label: "岱岳区",
          },
          {
            value: "3",
            label: "宁阳县",
          },
          {
            value: "4",
            label: "东平县",
          },
          {
            value: "5",
            label: "新泰市",
          },
          {
            value: "6",
            label: "肥城市",
          },
        ],
      },
      {
        value: "A",
        label: "威海市",
        children: [
          {
            value: "1",
            label: "环翠区",
          },
          {
            value: "2",
            label: "文登市",
          },
          {
            value: "3",
            label: "荣成市",
          },
          {
            value: "4",
            label: "乳山市",
          },
        ],
      },
      {
        value: "B",
        label: "日照市",
        children: [
          {
            value: "1",
            label: "东港区",
          },
          {
            value: "2",
            label: "岚山区",
          },
          {
            value: "3",
            label: "五莲县",
          },
          {
            value: "4",
            label: "莒县",
          },
        ],
      },
      {
        value: "C",
        label: "莱芜市",
        children: [
          {
            value: "1",
            label: "莱城区",
          },
          {
            value: "2",
            label: "钢城区",
          },
        ],
      },
      {
        value: "D",
        label: "临沂市",
        children: [
          {
            value: "1",
            label: "兰山区",
          },
          {
            value: "2",
            label: "罗庄区",
          },
          {
            value: "3",
            label: "河东区",
          },
          {
            value: "4",
            label: "沂南县",
          },
          {
            value: "5",
            label: "郯城县",
          },
          {
            value: "6",
            label: "沂水县",
          },
          {
            value: "7",
            label: "苍山县",
          },
          {
            value: "8",
            label: "费县",
          },
          {
            value: "9",
            label: "平邑县",
          },
          {
            value: "A",
            label: "莒南县",
          },
          {
            value: "B",
            label: "蒙阴县",
          },
          {
            value: "C",
            label: "临沭县",
          },
        ],
      },
      {
        value: "E",
        label: "德州市",
        children: [
          {
            value: "1",
            label: "德城区",
          },
          {
            value: "2",
            label: "陵县",
          },
          {
            value: "3",
            label: "宁津县",
          },
          {
            value: "4",
            label: "庆云县",
          },
          {
            value: "5",
            label: "临邑县",
          },
          {
            value: "6",
            label: "齐河县",
          },
          {
            value: "7",
            label: "平原县",
          },
          {
            value: "8",
            label: "夏津县",
          },
          {
            value: "9",
            label: "武城县",
          },
          {
            value: "A",
            label: "乐陵市",
          },
          {
            value: "B",
            label: "禹城市",
          },
        ],
      },
      {
        value: "F",
        label: "聊城市",
        children: [
          {
            value: "1",
            label: "东昌府区",
          },
          {
            value: "2",
            label: "阳谷县",
          },
          {
            value: "3",
            label: "莘县",
          },
          {
            value: "4",
            label: "茌平县",
          },
          {
            value: "5",
            label: "东阿县",
          },
          {
            value: "6",
            label: "冠县",
          },
          {
            value: "7",
            label: "高唐县",
          },
          {
            value: "8",
            label: "临清市",
          },
        ],
      },
      {
        value: "G",
        label: "滨州市",
        children: [
          {
            value: "1",
            label: "滨城区",
          },
          {
            value: "2",
            label: "惠民县",
          },
          {
            value: "3",
            label: "阳信县",
          },
          {
            value: "4",
            label: "无棣县",
          },
          {
            value: "5",
            label: "沾化县",
          },
          {
            value: "6",
            label: "博兴县",
          },
          {
            value: "7",
            label: "邹平县",
          },
        ],
      },
      {
        value: "H",
        label: "荷泽市",
        children: [
          {
            value: "1",
            label: "牡丹区",
          },
          {
            value: "2",
            label: "曹县",
          },
          {
            value: "3",
            label: "单县",
          },
          {
            value: "4",
            label: "成武县",
          },
          {
            value: "5",
            label: "巨野县",
          },
          {
            value: "6",
            label: "郓城县",
          },
          {
            value: "7",
            label: "鄄城县",
          },
          {
            value: "8",
            label: "定陶县",
          },
          {
            value: "9",
            label: "东明县",
          },
        ],
      },
    ],
  },
  {
    value: "G",
    label: "河南",
    children: [
      {
        value: "1",
        label: "郑州市",
        children: [
          {
            value: "1",
            label: "中原区",
          },
          {
            value: "2",
            label: "二七区",
          },
          {
            value: "3",
            label: "管城回族区",
          },
          {
            value: "4",
            label: "金水区",
          },
          {
            value: "5",
            label: "上街区",
          },
          {
            value: "6",
            label: "邙山区",
          },
          {
            value: "7",
            label: "中牟县",
          },
          {
            value: "8",
            label: "巩义市",
          },
          {
            value: "9",
            label: "荥阳市",
          },
          {
            value: "A",
            label: "新密市",
          },
          {
            value: "B",
            label: "新郑市",
          },
          {
            value: "C",
            label: "登封市",
          },
        ],
      },
      {
        value: "2",
        label: "开封市",
        children: [
          {
            value: "1",
            label: "龙亭区",
          },
          {
            value: "2",
            label: "顺河回族区",
          },
          {
            value: "3",
            label: "鼓楼区",
          },
          {
            value: "4",
            label: "南关区",
          },
          {
            value: "5",
            label: "郊区",
          },
          {
            value: "6",
            label: "杞县",
          },
          {
            value: "7",
            label: "通许县",
          },
          {
            value: "8",
            label: "尉氏县",
          },
          {
            value: "9",
            label: "开封县",
          },
          {
            value: "A",
            label: "兰考县",
          },
          {
            value: "B",
            label: "禹王台区",
          },
        ],
      },
      {
        value: "3",
        label: "洛阳市",
        children: [
          {
            value: "1",
            label: "老城区",
          },
          {
            value: "2",
            label: "西工区",
          },
          {
            value: "3",
            label: "廛河回族区",
          },
          {
            value: "4",
            label: "涧西区",
          },
          {
            value: "5",
            label: "吉利区",
          },
          {
            value: "6",
            label: "洛龙区",
          },
          {
            value: "7",
            label: "孟津县",
          },
          {
            value: "8",
            label: "新安县",
          },
          {
            value: "9",
            label: "栾川县",
          },
          {
            value: "A",
            label: "嵩县",
          },
          {
            value: "B",
            label: "汝阳县",
          },
          {
            value: "C",
            label: "宜阳县",
          },
          {
            value: "D",
            label: "洛宁县",
          },
          {
            value: "E",
            label: "伊川县",
          },
          {
            value: "F",
            label: "偃师市",
          },
          {
            value: "G",
            label: "高新技术开发区",
          },
        ],
      },
      {
        value: "4",
        label: "平顶山市",
        children: [
          {
            value: "1",
            label: "新华区",
          },
          {
            value: "2",
            label: "卫东区",
          },
          {
            value: "3",
            label: "石龙区",
          },
          {
            value: "4",
            label: "湛河区",
          },
          {
            value: "5",
            label: "宝丰县",
          },
          {
            value: "6",
            label: "叶县",
          },
          {
            value: "7",
            label: "鲁山县",
          },
          {
            value: "8",
            label: "郏县",
          },
          {
            value: "9",
            label: "舞钢市",
          },
          {
            value: "A",
            label: "汝州市",
          },
        ],
      },
      {
        value: "5",
        label: "安阳市",
        children: [
          {
            value: "1",
            label: "文峰区",
          },
          {
            value: "2",
            label: "北关区",
          },
          {
            value: "3",
            label: "殷都区",
          },
          {
            value: "4",
            label: "龙安区",
          },
          {
            value: "5",
            label: "安阳县",
          },
          {
            value: "6",
            label: "汤阴县",
          },
          {
            value: "7",
            label: "滑县",
          },
          {
            value: "8",
            label: "内黄县",
          },
          {
            value: "9",
            label: "林州市",
          },
        ],
      },
      {
        value: "6",
        label: "鹤壁市",
        children: [
          {
            value: "1",
            label: "鹤山区",
          },
          {
            value: "2",
            label: "山城区",
          },
          {
            value: "3",
            label: "淇滨区",
          },
          {
            value: "4",
            label: "浚县",
          },
          {
            value: "5",
            label: "淇县",
          },
        ],
      },
      {
        value: "7",
        label: "新乡市",
        children: [
          {
            value: "1",
            label: "红旗区",
          },
          {
            value: "2",
            label: "卫滨区",
          },
          {
            value: "3",
            label: "凤泉区",
          },
          {
            value: "4",
            label: "牧野区",
          },
          {
            value: "5",
            label: "新乡县",
          },
          {
            value: "6",
            label: "获嘉县",
          },
          {
            value: "7",
            label: "原阳县",
          },
          {
            value: "8",
            label: "延津县",
          },
          {
            value: "9",
            label: "封丘县",
          },
          {
            value: "A",
            label: "长垣县",
          },
          {
            value: "B",
            label: "卫辉市",
          },
          {
            value: "C",
            label: "辉县市",
          },
        ],
      },
      {
        value: "8",
        label: "焦作市",
        children: [
          {
            value: "1",
            label: "解放区",
          },
          {
            value: "2",
            label: "中站区",
          },
          {
            value: "3",
            label: "马村区",
          },
          {
            value: "4",
            label: "山阳区",
          },
          {
            value: "5",
            label: "修武县",
          },
          {
            value: "6",
            label: "博爱县",
          },
          {
            value: "7",
            label: "武陟县",
          },
          {
            value: "8",
            label: "温县",
          },
          {
            value: "9",
            label: "济源市",
          },
          {
            value: "A",
            label: "沁阳市",
          },
          {
            value: "B",
            label: "孟州市",
          },
        ],
      },
      {
        value: "9",
        label: "濮阳市",
        children: [
          {
            value: "1",
            label: "华龙区",
          },
          {
            value: "2",
            label: "清丰县",
          },
          {
            value: "3",
            label: "南乐县",
          },
          {
            value: "4",
            label: "范县",
          },
          {
            value: "5",
            label: "台前县",
          },
          {
            value: "6",
            label: "濮阳县",
          },
        ],
      },
      {
        value: "A",
        label: "漯河市",
        children: [
          {
            value: "1",
            label: "源汇区",
          },
          {
            value: "2",
            label: "郾城区",
          },
          {
            value: "3",
            label: "召陵区",
          },
          {
            value: "4",
            label: "舞阳县",
          },
          {
            value: "5",
            label: "临颍县",
          },
        ],
      },
      {
        value: "B",
        label: "三门峡市",
        children: [
          {
            value: "1",
            label: "湖滨区",
          },
          {
            value: "2",
            label: "渑池县",
          },
          {
            value: "3",
            label: "陕县",
          },
          {
            value: "4",
            label: "卢氏县",
          },
          {
            value: "5",
            label: "义马市",
          },
          {
            value: "6",
            label: "灵宝市",
          },
        ],
      },
      {
        value: "C",
        label: "南阳市",
        children: [
          {
            value: "1",
            label: "宛城区",
          },
          {
            value: "2",
            label: "卧龙区",
          },
          {
            value: "3",
            label: "南召县",
          },
          {
            value: "4",
            label: "方城县",
          },
          {
            value: "5",
            label: "西峡县",
          },
          {
            value: "6",
            label: "镇平县",
          },
          {
            value: "7",
            label: "内乡县",
          },
          {
            value: "8",
            label: "淅川县",
          },
          {
            value: "9",
            label: "社旗县",
          },
          {
            value: "A",
            label: "唐河县",
          },
          {
            value: "B",
            label: "新野县",
          },
          {
            value: "C",
            label: "桐柏县",
          },
          {
            value: "D",
            label: "邓州市",
          },
          {
            value: "E",
            label: "白河新区",
          },
          {
            value: "F",
            label: "高新区",
          },
        ],
      },
      {
        value: "D",
        label: "商丘市",
        children: [
          {
            value: "1",
            label: "梁园区",
          },
          {
            value: "2",
            label: "睢阳区",
          },
          {
            value: "3",
            label: "民权县",
          },
          {
            value: "4",
            label: "睢县",
          },
          {
            value: "5",
            label: "宁陵县",
          },
          {
            value: "6",
            label: "柘城县",
          },
          {
            value: "7",
            label: "虞城县",
          },
          {
            value: "8",
            label: "夏邑县",
          },
          {
            value: "9",
            label: "永城市",
          },
        ],
      },
      {
        value: "E",
        label: "信阳市",
        children: [
          {
            value: "1",
            label: "师河区",
          },
          {
            value: "2",
            label: "平桥区",
          },
          {
            value: "3",
            label: "罗山县",
          },
          {
            value: "4",
            label: "光山县",
          },
          {
            value: "5",
            label: "新县",
          },
          {
            value: "6",
            label: "商城县",
          },
          {
            value: "7",
            label: "固始县",
          },
          {
            value: "8",
            label: "潢川县",
          },
          {
            value: "9",
            label: "淮滨县",
          },
          {
            value: "A",
            label: "息县",
          },
        ],
      },
      {
        value: "F",
        label: "周口市",
        children: [
          {
            value: "1",
            label: "川汇区",
          },
          {
            value: "2",
            label: "扶沟县",
          },
          {
            value: "3",
            label: "西华县",
          },
          {
            value: "4",
            label: "商水县",
          },
          {
            value: "5",
            label: "沈丘县",
          },
          {
            value: "6",
            label: "郸城县",
          },
          {
            value: "7",
            label: "淮阳县",
          },
          {
            value: "8",
            label: "太康县",
          },
          {
            value: "9",
            label: "鹿邑县",
          },
          {
            value: "A",
            label: "项城市",
          },
        ],
      },
      {
        value: "G",
        label: "驻马店市",
        children: [
          {
            value: "1",
            label: "驿城区",
          },
          {
            value: "2",
            label: "西平县",
          },
          {
            value: "3",
            label: "上蔡县",
          },
          {
            value: "4",
            label: "平舆县",
          },
          {
            value: "5",
            label: "正阳县",
          },
          {
            value: "6",
            label: "确山县",
          },
          {
            value: "7",
            label: "泌阳县",
          },
          {
            value: "8",
            label: "汝南县",
          },
          {
            value: "9",
            label: "遂平县",
          },
          {
            value: "A",
            label: "新蔡县",
          },
          {
            value: "B",
            label: "板桥区",
          },
        ],
      },
      {
        value: "H",
        label: "许昌市",
        children: [
          {
            value: "1",
            label: "魏都区",
          },
          {
            value: "2",
            label: "许昌县",
          },
          {
            value: "3",
            label: "鄢陵县",
          },
          {
            value: "4",
            label: "襄城县",
          },
          {
            value: "5",
            label: "禹州市",
          },
          {
            value: "6",
            label: "长葛市",
          },
        ],
      },
    ],
  },
  {
    value: "H",
    label: "湖北",
    children: [
      {
        value: "1",
        label: "武汉市",
        children: [
          {
            value: "1",
            label: "江岸区",
          },
          {
            value: "2",
            label: "江汉区",
          },
          {
            value: "3",
            label: "硚口区",
          },
          {
            value: "4",
            label: "汉阳区",
          },
          {
            value: "5",
            label: "武昌区",
          },
          {
            value: "6",
            label: "青山区",
          },
          {
            value: "7",
            label: "洪山区",
          },
          {
            value: "8",
            label: "东西湖区",
          },
          {
            value: "9",
            label: "汉南区",
          },
          {
            value: "A",
            label: "蔡甸区",
          },
          {
            value: "B",
            label: "江夏区",
          },
          {
            value: "C",
            label: "黄陂区",
          },
          {
            value: "D",
            label: "新洲区",
          },
        ],
      },
      {
        value: "2",
        label: "黄石市",
        children: [
          {
            value: "1",
            label: "黄石港区",
          },
          {
            value: "2",
            label: "西塞山区",
          },
          {
            value: "3",
            label: "下陆区",
          },
          {
            value: "4",
            label: "铁山区",
          },
          {
            value: "5",
            label: "阳新县",
          },
          {
            value: "6",
            label: "大冶市",
          },
          {
            value: "7",
            label: "经济开发区",
          },
        ],
      },
      {
        value: "3",
        label: "十堰市",
        children: [
          {
            value: "1",
            label: "茅箭区",
          },
          {
            value: "2",
            label: "张湾区",
          },
          {
            value: "3",
            label: "郧县",
          },
          {
            value: "4",
            label: "郧西县",
          },
          {
            value: "5",
            label: "竹山县",
          },
          {
            value: "6",
            label: "竹溪县",
          },
          {
            value: "7",
            label: "房县",
          },
          {
            value: "8",
            label: "丹江口市",
          },
        ],
      },
      {
        value: "4",
        label: "宜昌市",
        children: [
          {
            value: "1",
            label: "西陵区",
          },
          {
            value: "2",
            label: "伍家岗区",
          },
          {
            value: "3",
            label: "点军区",
          },
          {
            value: "4",
            label: "猇亭区",
          },
          {
            value: "5",
            label: "夷陵区",
          },
          {
            value: "6",
            label: "远安县",
          },
          {
            value: "7",
            label: "兴山县",
          },
          {
            value: "8",
            label: "秭归县",
          },
          {
            value: "9",
            label: "长阳土家族自治县",
          },
          {
            value: "A",
            label: "五峰土家族自治县",
          },
          {
            value: "B",
            label: "宜都市",
          },
          {
            value: "C",
            label: "当阳市",
          },
          {
            value: "D",
            label: "枝江市",
          },
        ],
      },
      {
        value: "5",
        label: "襄阳市",
        children: [
          {
            value: "1",
            label: "襄州区",
          },
          {
            value: "2",
            label: "樊城区",
          },
          {
            value: "3",
            label: "襄阳区",
          },
          {
            value: "4",
            label: "南漳县",
          },
          {
            value: "5",
            label: "谷城县",
          },
          {
            value: "6",
            label: "保康县",
          },
          {
            value: "7",
            label: "老河口市",
          },
          {
            value: "8",
            label: "枣阳市",
          },
          {
            value: "9",
            label: "宜城市",
          },
          {
            value: "A",
            label: "襄城区",
          },
        ],
      },
      {
        value: "6",
        label: "鄂州市",
        children: [
          {
            value: "1",
            label: "梁子湖区",
          },
          {
            value: "2",
            label: "华容区",
          },
          {
            value: "3",
            label: "鄂城区",
          },
        ],
      },
      {
        value: "7",
        label: "荆门市",
        children: [
          {
            value: "1",
            label: "东宝区",
          },
          {
            value: "2",
            label: "掇刀区",
          },
          {
            value: "3",
            label: "京山县",
          },
          {
            value: "4",
            label: "沙洋县",
          },
          {
            value: "5",
            label: "钟祥市",
          },
        ],
      },
      {
        value: "8",
        label: "孝感市",
        children: [
          {
            value: "1",
            label: "孝南区",
          },
          {
            value: "2",
            label: "孝昌县",
          },
          {
            value: "3",
            label: "大悟县",
          },
          {
            value: "4",
            label: "云梦县",
          },
          {
            value: "5",
            label: "应城市",
          },
          {
            value: "6",
            label: "安陆市",
          },
          {
            value: "7",
            label: "汉川市",
          },
        ],
      },
      {
        value: "9",
        label: "荆州市",
        children: [
          {
            value: "1",
            label: "沙市区",
          },
          {
            value: "2",
            label: "荆州区",
          },
          {
            value: "3",
            label: "公安县",
          },
          {
            value: "4",
            label: "监利县",
          },
          {
            value: "5",
            label: "江陵县",
          },
          {
            value: "6",
            label: "石首市",
          },
          {
            value: "7",
            label: "洪湖市",
          },
          {
            value: "8",
            label: "松滋市",
          },
        ],
      },
      {
        value: "A",
        label: "黄冈市",
        children: [
          {
            value: "1",
            label: "黄州区",
          },
          {
            value: "2",
            label: "团风县",
          },
          {
            value: "3",
            label: "红安县",
          },
          {
            value: "4",
            label: "罗田县",
          },
          {
            value: "5",
            label: "英山县",
          },
          {
            value: "6",
            label: "浠水县",
          },
          {
            value: "7",
            label: "蕲春县",
          },
          {
            value: "8",
            label: "黄梅县",
          },
          {
            value: "9",
            label: "麻城市",
          },
          {
            value: "A",
            label: "武穴市",
          },
        ],
      },
      {
        value: "B",
        label: "咸宁市",
        children: [
          {
            value: "1",
            label: "咸安区",
          },
          {
            value: "2",
            label: "嘉鱼县",
          },
          {
            value: "3",
            label: "通城县",
          },
          {
            value: "4",
            label: "崇阳县",
          },
          {
            value: "5",
            label: "通山县",
          },
          {
            value: "6",
            label: "赤壁市",
          },
          {
            value: "7",
            label: "阳新县",
          },
        ],
      },
      {
        value: "C",
        label: "随州市",
        children: [
          {
            value: "1",
            label: "曾都区",
          },
          {
            value: "2",
            label: "广水市",
          },
          {
            value: "3",
            label: "随县",
          },
        ],
      },
      {
        value: "D",
        label: "恩施土家族苗族自治州",
        children: [
          {
            value: "1",
            label: "恩施市",
          },
          {
            value: "2",
            label: "利川市",
          },
          {
            value: "3",
            label: "建始县",
          },
          {
            value: "4",
            label: "巴东县",
          },
          {
            value: "5",
            label: "宣恩县",
          },
          {
            value: "6",
            label: "咸丰县",
          },
          {
            value: "7",
            label: "来凤县",
          },
          {
            value: "8",
            label: "鹤峰县",
          },
        ],
      },
      {
        value: "E",
        label: "省直辖",
        children: [
          {
            value: "1",
            label: "仙桃市",
          },
          {
            value: "2",
            label: "潜江市",
          },
          {
            value: "3",
            label: "天门市",
          },
          {
            value: "4",
            label: "神农架林区",
          },
        ],
      },
    ],
  },
  {
    value: "I",
    label: "湖南",
    children: [
      {
        value: "1",
        label: "长沙市",
        children: [
          {
            value: "1",
            label: "芙蓉区",
          },
          {
            value: "2",
            label: "天心区",
          },
          {
            value: "3",
            label: "岳麓区",
          },
          {
            value: "4",
            label: "开福区",
          },
          {
            value: "5",
            label: "雨花区",
          },
          {
            value: "6",
            label: "长沙县",
          },
          {
            value: "7",
            label: "望城县",
          },
          {
            value: "8",
            label: "宁乡县",
          },
          {
            value: "9",
            label: "浏阳市",
          },
        ],
      },
      {
        value: "2",
        label: "株洲市",
        children: [
          {
            value: "1",
            label: "荷塘区",
          },
          {
            value: "2",
            label: "芦淞区",
          },
          {
            value: "3",
            label: "石峰区",
          },
          {
            value: "4",
            label: "天元区",
          },
          {
            value: "5",
            label: "株洲县",
          },
          {
            value: "6",
            label: "攸县",
          },
          {
            value: "7",
            label: "茶陵县",
          },
          {
            value: "8",
            label: "炎陵县",
          },
          {
            value: "9",
            label: "醴陵市",
          },
        ],
      },
      {
        value: "3",
        label: "湘潭市",
        children: [
          {
            value: "2",
            label: "雨湖区",
          },
          {
            value: "3",
            label: "岳塘区",
          },
          {
            value: "4",
            label: "湘潭县",
          },
          {
            value: "5",
            label: "湘乡市",
          },
          {
            value: "6",
            label: "韶山市",
          },
        ],
      },
      {
        value: "4",
        label: "衡阳市",
        children: [
          {
            value: "2",
            label: "珠晖区",
          },
          {
            value: "3",
            label: "雁峰区",
          },
          {
            value: "4",
            label: "石鼓区",
          },
          {
            value: "5",
            label: "蒸湘区",
          },
          {
            value: "6",
            label: "南岳区",
          },
          {
            value: "7",
            label: "衡阳县",
          },
          {
            value: "8",
            label: "衡南县",
          },
          {
            value: "9",
            label: "衡山县",
          },
          {
            value: "A",
            label: "衡东县",
          },
          {
            value: "B",
            label: "祁东县",
          },
          {
            value: "C",
            label: "耒阳市",
          },
          {
            value: "D",
            label: "常宁市",
          },
        ],
      },
      {
        value: "5",
        label: "邵阳市",
        children: [
          {
            value: "1",
            label: "双清区",
          },
          {
            value: "2",
            label: "大祥区",
          },
          {
            value: "3",
            label: "北塔区",
          },
          {
            value: "4",
            label: "邵东县",
          },
          {
            value: "5",
            label: "新邵县",
          },
          {
            value: "6",
            label: "邵阳县",
          },
          {
            value: "7",
            label: "隆回县",
          },
          {
            value: "8",
            label: "洞口县",
          },
          {
            value: "9",
            label: "绥宁县",
          },
          {
            value: "A",
            label: "新宁县",
          },
          {
            value: "B",
            label: "城步苗族自治县",
          },
          {
            value: "C",
            label: "武冈市",
          },
        ],
      },
      {
        value: "6",
        label: "岳阳市",
        children: [
          {
            value: "1",
            label: "岳阳楼区",
          },
          {
            value: "2",
            label: "云溪区",
          },
          {
            value: "3",
            label: "君山区",
          },
          {
            value: "4",
            label: "岳阳县",
          },
          {
            value: "5",
            label: "华容县",
          },
          {
            value: "6",
            label: "湘阴县",
          },
          {
            value: "7",
            label: "平江县",
          },
          {
            value: "8",
            label: "汨罗市",
          },
          {
            value: "9",
            label: "临湘市",
          },
        ],
      },
      {
        value: "7",
        label: "常德市",
        children: [
          {
            value: "1",
            label: "武陵区",
          },
          {
            value: "2",
            label: "鼎城区",
          },
          {
            value: "3",
            label: "安乡县",
          },
          {
            value: "4",
            label: "汉寿县",
          },
          {
            value: "5",
            label: "澧县",
          },
          {
            value: "6",
            label: "临澧县",
          },
          {
            value: "7",
            label: "桃源县",
          },
          {
            value: "8",
            label: "石门县",
          },
          {
            value: "9",
            label: "津市市",
          },
        ],
      },
      {
        value: "8",
        label: "张家界市",
        children: [
          {
            value: "1",
            label: "永定区",
          },
          {
            value: "2",
            label: "武陵源区",
          },
          {
            value: "3",
            label: "慈利县",
          },
          {
            value: "4",
            label: "桑植县",
          },
        ],
      },
      {
        value: "9",
        label: "益阳市",
        children: [
          {
            value: "1",
            label: "资阳区",
          },
          {
            value: "2",
            label: "赫山区",
          },
          {
            value: "3",
            label: "南县",
          },
          {
            value: "4",
            label: "桃江县",
          },
          {
            value: "5",
            label: "安化县",
          },
          {
            value: "6",
            label: "沅江市",
          },
        ],
      },
      {
        value: "A",
        label: "郴州市",
        children: [
          {
            value: "1",
            label: "北湖区",
          },
          {
            value: "2",
            label: "苏仙区",
          },
          {
            value: "3",
            label: "桂阳县",
          },
          {
            value: "4",
            label: "宜章县",
          },
          {
            value: "5",
            label: "永兴县",
          },
          {
            value: "6",
            label: "嘉禾县",
          },
          {
            value: "7",
            label: "临武县",
          },
          {
            value: "8",
            label: "汝城县",
          },
          {
            value: "9",
            label: "桂东县",
          },
          {
            value: "A",
            label: "安仁县",
          },
          {
            value: "B",
            label: "资兴市",
          },
        ],
      },
      {
        value: "B",
        label: "永州市",
        children: [
          {
            value: "1",
            label: "芝山区",
          },
          {
            value: "2",
            label: "冷水滩区",
          },
          {
            value: "3",
            label: "祁阳县",
          },
          {
            value: "4",
            label: "东安县",
          },
          {
            value: "5",
            label: "双牌县",
          },
          {
            value: "6",
            label: "道县",
          },
          {
            value: "7",
            label: "江永县",
          },
          {
            value: "8",
            label: "宁远县",
          },
          {
            value: "9",
            label: "蓝山县",
          },
          {
            value: "A",
            label: "新田县",
          },
          {
            value: "B",
            label: "江华瑶族自治县",
          },
          {
            value: "C",
            label: "零陵区",
          },
        ],
      },
      {
        value: "C",
        label: "怀化市",
        children: [
          {
            value: "1",
            label: "鹤城区",
          },
          {
            value: "2",
            label: "中方县",
          },
          {
            value: "3",
            label: "沅陵县",
          },
          {
            value: "4",
            label: "辰溪县",
          },
          {
            value: "5",
            label: "溆浦县",
          },
          {
            value: "6",
            label: "会同县",
          },
          {
            value: "7",
            label: "麻阳苗族自治县",
          },
          {
            value: "8",
            label: "新晃侗族自治县",
          },
          {
            value: "9",
            label: "芷江侗族自治县",
          },
          {
            value: "A",
            label: "靖州苗族侗族自治县",
          },
          {
            value: "B",
            label: "通道侗族自治县",
          },
          {
            value: "C",
            label: "洪江市",
          },
        ],
      },
      {
        value: "D",
        label: "娄底市",
        children: [
          {
            value: "1",
            label: "娄星区",
          },
          {
            value: "2",
            label: "双峰县",
          },
          {
            value: "3",
            label: "新化县",
          },
          {
            value: "4",
            label: "冷水江市",
          },
          {
            value: "5",
            label: "涟源市",
          },
        ],
      },
      {
        value: "E",
        label: "湘西土家族苗族自治州",
        children: [
          {
            value: "1",
            label: "吉首市",
          },
          {
            value: "2",
            label: "泸溪县",
          },
          {
            value: "3",
            label: "凤凰县",
          },
          {
            value: "4",
            label: "花垣县",
          },
          {
            value: "5",
            label: "保靖县",
          },
          {
            value: "6",
            label: "古丈县",
          },
          {
            value: "7",
            label: "永顺县",
          },
          {
            value: "8",
            label: "龙山县",
          },
        ],
      },
    ],
  },
  {
    value: "J",
    label: "广东",
    children: [
      {
        value: "1",
        label: "广州市",
        children: [
          {
            value: "1",
            label: "东山区",
          },
          {
            value: "2",
            label: "荔湾区",
          },
          {
            value: "3",
            label: "越秀区",
          },
          {
            value: "4",
            label: "海珠区",
          },
          {
            value: "5",
            label: "天河区",
          },
          {
            value: "6",
            label: "芳村区",
          },
          {
            value: "7",
            label: "白云区",
          },
          {
            value: "8",
            label: "黄埔区",
          },
          {
            value: "9",
            label: "番禺区",
          },
          {
            value: "A",
            label: "花都区",
          },
          {
            value: "B",
            label: "增城市",
          },
          {
            value: "C",
            label: "从化市",
          },
          {
            value: "D",
            label: "萝岗区",
          },
        ],
      },
      {
        value: "2",
        label: "韶关市",
        children: [
          {
            value: "1",
            label: "武江区",
          },
          {
            value: "2",
            label: "浈江区",
          },
          {
            value: "3",
            label: "曲江区",
          },
          {
            value: "4",
            label: "始兴县",
          },
          {
            value: "5",
            label: "仁化县",
          },
          {
            value: "6",
            label: "翁源县",
          },
          {
            value: "7",
            label: "乳源瑶族自治县",
          },
          {
            value: "8",
            label: "新丰县",
          },
          {
            value: "9",
            label: "乐昌市",
          },
          {
            value: "A",
            label: "南雄市",
          },
        ],
      },
      {
        value: "3",
        label: "深圳市",
        children: [
          {
            value: "1",
            label: "罗湖区",
          },
          {
            value: "2",
            label: "福田区",
          },
          {
            value: "3",
            label: "南山区",
          },
          {
            value: "4",
            label: "宝安区",
          },
          {
            value: "5",
            label: "龙岗区",
          },
          {
            value: "6",
            label: "盐田区",
          },
        ],
      },
      {
        value: "4",
        label: "珠海市",
        children: [
          {
            value: "1",
            label: "香洲区",
          },
          {
            value: "2",
            label: "斗门区",
          },
          {
            value: "3",
            label: "金湾区",
          },
        ],
      },
      {
        value: "5",
        label: "汕头市",
        children: [
          {
            value: "1",
            label: "龙湖区",
          },
          {
            value: "2",
            label: "金平区",
          },
          {
            value: "3",
            label: "濠江区",
          },
          {
            value: "4",
            label: "潮阳区",
          },
          {
            value: "5",
            label: "潮南区",
          },
          {
            value: "6",
            label: "澄海区",
          },
          {
            value: "7",
            label: "南澳县",
          },
        ],
      },
      {
        value: "6",
        label: "佛山市",
        children: [
          {
            value: "1",
            label: "禅城区",
          },
          {
            value: "2",
            label: "南海区",
          },
          {
            value: "3",
            label: "顺德区",
          },
          {
            value: "4",
            label: "三水区",
          },
          {
            value: "5",
            label: "高明区",
          },
        ],
      },
      {
        value: "7",
        label: "江门市",
        children: [
          {
            value: "1",
            label: "蓬江区",
          },
          {
            value: "2",
            label: "江海区",
          },
          {
            value: "3",
            label: "新会区",
          },
          {
            value: "4",
            label: "台山市",
          },
          {
            value: "5",
            label: "开平市",
          },
          {
            value: "6",
            label: "鹤山市",
          },
          {
            value: "7",
            label: "恩平市",
          },
        ],
      },
      {
        value: "8",
        label: "湛江市",
        children: [
          {
            value: "1",
            label: "赤坎区",
          },
          {
            value: "2",
            label: "霞山区",
          },
          {
            value: "3",
            label: "坡头区",
          },
          {
            value: "4",
            label: "麻章区",
          },
          {
            value: "5",
            label: "遂溪县",
          },
          {
            value: "6",
            label: "徐闻县",
          },
          {
            value: "7",
            label: "廉江市",
          },
          {
            value: "8",
            label: "雷州市",
          },
          {
            value: "9",
            label: "吴川市",
          },
        ],
      },
      {
        value: "9",
        label: "茂名市",
        children: [
          {
            value: "1",
            label: "茂南区",
          },
          {
            value: "2",
            label: "茂港区",
          },
          {
            value: "3",
            label: "电白县",
          },
          {
            value: "4",
            label: "高州市",
          },
          {
            value: "5",
            label: "化州市",
          },
          {
            value: "6",
            label: "信宜市",
          },
        ],
      },
      {
        value: "A",
        label: "肇庆市",
        children: [
          {
            value: "1",
            label: "端州区",
          },
          {
            value: "2",
            label: "鼎湖区",
          },
          {
            value: "3",
            label: "广宁县",
          },
          {
            value: "4",
            label: "怀集县",
          },
          {
            value: "5",
            label: "封开县",
          },
          {
            value: "6",
            label: "德庆县",
          },
          {
            value: "7",
            label: "高要市",
          },
          {
            value: "8",
            label: "四会市",
          },
        ],
      },
      {
        value: "B",
        label: "惠州市",
        children: [
          {
            value: "1",
            label: "惠城区",
          },
          {
            value: "2",
            label: "惠阳区",
          },
          {
            value: "3",
            label: "博罗县",
          },
          {
            value: "4",
            label: "惠东县",
          },
          {
            value: "5",
            label: "龙门县",
          },
        ],
      },
      {
        value: "C",
        label: "梅州市",
        children: [
          {
            value: "1",
            label: "梅江区",
          },
          {
            value: "2",
            label: "梅县",
          },
          {
            value: "3",
            label: "大埔县",
          },
          {
            value: "4",
            label: "丰顺县",
          },
          {
            value: "5",
            label: "五华县",
          },
          {
            value: "6",
            label: "平远县",
          },
          {
            value: "7",
            label: "蕉岭县",
          },
          {
            value: "8",
            label: "兴宁市",
          },
        ],
      },
      {
        value: "D",
        label: "汕尾市",
        children: [
          {
            value: "1",
            label: "城区",
          },
          {
            value: "2",
            label: "海丰县",
          },
          {
            value: "3",
            label: "陆河县",
          },
          {
            value: "4",
            label: "陆丰市",
          },
        ],
      },
      {
        value: "E",
        label: "河源市",
        children: [
          {
            value: "1",
            label: "源城区",
          },
          {
            value: "2",
            label: "紫金县",
          },
          {
            value: "3",
            label: "龙川县",
          },
          {
            value: "4",
            label: "连平县",
          },
          {
            value: "5",
            label: "和平县",
          },
          {
            value: "6",
            label: "东源县",
          },
        ],
      },
      {
        value: "F",
        label: "阳江市",
        children: [
          {
            value: "1",
            label: "江城区",
          },
          {
            value: "2",
            label: "阳西县",
          },
          {
            value: "3",
            label: "阳东县",
          },
          {
            value: "4",
            label: "阳春市",
          },
        ],
      },
      {
        value: "G",
        label: "清远市",
        children: [
          {
            value: "1",
            label: "清城区",
          },
          {
            value: "2",
            label: "佛冈县",
          },
          {
            value: "3",
            label: "阳山县",
          },
          {
            value: "4",
            label: "连山壮族瑶族自治县",
          },
          {
            value: "5",
            label: "连南瑶族自治县",
          },
          {
            value: "6",
            label: "清新县",
          },
          {
            value: "7",
            label: "英德市",
          },
          {
            value: "8",
            label: "连州市",
          },
        ],
      },
      {
        value: "H",
        label: "潮州市",
        children: [
          {
            value: "1",
            label: "湘桥区",
          },
          {
            value: "2",
            label: "潮安县",
          },
          {
            value: "3",
            label: "饶平县",
          },
          {
            value: "4",
            label: "古城区",
          },
        ],
      },
      {
        value: "I",
        label: "揭阳市",
        children: [
          {
            value: "1",
            label: "榕城区",
          },
          {
            value: "2",
            label: "揭东县",
          },
          {
            value: "3",
            label: "揭西县",
          },
          {
            value: "4",
            label: "惠来县",
          },
          {
            value: "5",
            label: "普宁市",
          },
        ],
      },
      {
        value: "J",
        label: "云浮市",
        children: [
          {
            value: "1",
            label: "云城区",
          },
          {
            value: "2",
            label: "新兴县",
          },
          {
            value: "3",
            label: "郁南县",
          },
          {
            value: "4",
            label: "云安县",
          },
          {
            value: "5",
            label: "罗定市",
          },
        ],
      },
      {
        value: "K",
        label: "东莞地区",
        children: [
          {
            value: "1",
            label: "莞城区 ",
          },
          {
            value: "2",
            label: "南城区 ",
          },
          {
            value: "3",
            label: "东城区 ",
          },
          {
            value: "4",
            label: "万江区",
          },
          {
            value: "5",
            label: "石碣镇 ",
          },
          {
            value: "6",
            label: "石龙镇 ",
          },
          {
            value: "7",
            label: "茶山镇 ",
          },
          {
            value: "8",
            label: "石排镇 ",
          },
          {
            value: "9",
            label: "企石镇",
          },
          {
            value: "A",
            label: "横沥镇 ",
          },
          {
            value: "B",
            label: "桥头镇 ",
          },
          {
            value: "C",
            label: "谢岗镇 ",
          },
          {
            value: "D",
            label: "东坑镇 ",
          },
          {
            value: "E",
            label: "常平镇 ",
          },
          {
            value: "F",
            label: "寮步镇 ",
          },
          {
            value: "G",
            label: "大朗镇 ",
          },
          {
            value: "H",
            label: "麻涌镇 ",
          },
          {
            value: "I",
            label: "中堂镇",
          },
          {
            value: "J",
            label: "高埗镇",
          },
          {
            value: "K",
            label: "樟木头镇 ",
          },
          {
            value: "L",
            label: "大岭山镇",
          },
          {
            value: "M",
            label: "望牛墩镇 ",
          },
          {
            value: "N",
            label: "黄江镇 ",
          },
          {
            value: "O",
            label: "洪梅镇 ",
          },
          {
            value: "P",
            label: "清溪镇 ",
          },
          {
            value: "Q",
            label: "沙田镇 ",
          },
          {
            value: "R",
            label: "道滘镇 ",
          },
          {
            value: "S",
            label: "塘厦镇 ",
          },
          {
            value: "T",
            label: "虎门镇 ",
          },
          {
            value: "U",
            label: "厚街镇 ",
          },
          {
            value: "V",
            label: "凤岗镇 ",
          },
          {
            value: "W",
            label: "长安镇 ",
          },
        ],
      },
      {
        value: "L",
        label: "中山地区",
        children: [
          {
            value: "1",
            label: "石岐区 ",
          },
          {
            value: "2",
            label: "西区 ",
          },
          {
            value: "3",
            label: "南区 ",
          },
          {
            value: "4",
            label: "五桂山区 ",
          },
          {
            value: "5",
            label: "火炬开发区",
          },
          {
            value: "6",
            label: "黄圃镇 ",
          },
          {
            value: "7",
            label: "南头镇 ",
          },
          {
            value: "8",
            label: "东凤镇 ",
          },
          {
            value: "9",
            label: "阜沙镇 ",
          },
          {
            value: "A",
            label: "小榄镇 ",
          },
          {
            value: "B",
            label: "东升镇 ",
          },
          {
            value: "C",
            label: "古镇镇 ",
          },
          {
            value: "D",
            label: "横栏镇 ",
          },
          {
            value: "E",
            label: "三角镇 ",
          },
          {
            value: "F",
            label: "民众镇 ",
          },
          {
            value: "G",
            label: "南朗镇 ",
          },
          {
            value: "H",
            label: "港口镇 ",
          },
          {
            value: "I",
            label: "大涌镇 ",
          },
          {
            value: "J",
            label: "沙溪镇 ",
          },
          {
            value: "K",
            label: "三乡镇 ",
          },
          {
            value: "L",
            label: "板芙镇",
          },
          {
            value: "M",
            label: "神湾镇",
          },
          {
            value: "N",
            label: "坦洲镇",
          },
          {
            value: "O",
            label: "东区 ",
          },
        ],
      },
    ],
  },
  {
    value: "K",
    label: "海南",
    children: [
      {
        value: "1",
        label: "海口市",
        children: [
          {
            value: "1",
            label: "秀英区",
          },
          {
            value: "2",
            label: "龙华区",
          },
          {
            value: "3",
            label: "琼山区",
          },
          {
            value: "4",
            label: "美兰区",
          },
        ],
      },
      {
        value: "2",
        label: "三亚市",
        children: [
          {
            value: "1",
            label: "三亚市",
          },
          {
            value: "2",
            label: "河西区",
          },
        ],
      },
      {
        value: "3",
        label: "省直辖县",
        children: [
          {
            value: "1",
            label: "五指山市",
          },
          {
            value: "2",
            label: "琼海市",
          },
          {
            value: "3",
            label: "儋州市",
          },
          {
            value: "4",
            label: "文昌市",
          },
          {
            value: "5",
            label: "万宁市",
          },
          {
            value: "6",
            label: "东方市",
          },
          {
            value: "7",
            label: "定安县",
          },
          {
            value: "8",
            label: "屯昌县",
          },
          {
            value: "9",
            label: "澄迈县",
          },
          {
            value: "A",
            label: "临高县",
          },
          {
            value: "B",
            label: "白沙黎族自治县",
          },
          {
            value: "C",
            label: "昌江黎族自治县",
          },
          {
            value: "D",
            label: "乐东黎族自治县",
          },
          {
            value: "E",
            label: "陵水黎族自治县",
          },
          {
            value: "F",
            label: "保亭黎族苗族自治县",
          },
          {
            value: "G",
            label: "琼中黎族苗族自治县",
          },
          {
            value: "H",
            label: "西沙群岛",
          },
          {
            value: "I",
            label: "南沙群岛",
          },
          {
            value: "J",
            label: "中沙群岛的岛礁及其海域",
          },
        ],
      },
    ],
  },
  {
    value: "L",
    label: "四川省",
    children: [
      {
        value: "0",
        label: "成都市",
        children: [],
      },
      {
        value: "1",
        label: "自贡市",
        children: [
          {
            value: "1",
            label: "自流井区",
          },
          {
            value: "2",
            label: "贡井区",
          },
          {
            value: "3",
            label: "大安区",
          },
          {
            value: "4",
            label: "沿滩区",
          },
          {
            value: "5",
            label: "荣县",
          },
          {
            value: "6",
            label: "富顺县",
          },
        ],
      },
      {
        value: "2",
        label: "攀枝花市",
        children: [
          {
            value: "1",
            label: "东区",
          },
          {
            value: "2",
            label: "西区",
          },
          {
            value: "3",
            label: "仁和区",
          },
          {
            value: "4",
            label: "米易县",
          },
          {
            value: "5",
            label: "盐边县",
          },
        ],
      },
      {
        value: "3",
        label: "泸州市",
        children: [
          {
            value: "1",
            label: "江阳区",
          },
          {
            value: "2",
            label: "纳溪区",
          },
          {
            value: "3",
            label: "龙马潭区",
          },
          {
            value: "4",
            label: "泸县",
          },
          {
            value: "5",
            label: "合江县",
          },
          {
            value: "6",
            label: "叙永县",
          },
          {
            value: "7",
            label: "古蔺县",
          },
        ],
      },
      {
        value: "4",
        label: "德阳市",
        children: [
          {
            value: "1",
            label: "旌阳区",
          },
          {
            value: "2",
            label: "中江县",
          },
          {
            value: "3",
            label: "罗江县",
          },
          {
            value: "4",
            label: "广汉市",
          },
          {
            value: "5",
            label: "什邡市",
          },
          {
            value: "6",
            label: "绵竹市",
          },
        ],
      },
      {
        value: "5",
        label: "绵阳市",
        children: [
          {
            value: "1",
            label: "涪城区",
          },
          {
            value: "2",
            label: "游仙区",
          },
          {
            value: "3",
            label: "三台县",
          },
          {
            value: "4",
            label: "盐亭县",
          },
          {
            value: "5",
            label: "安县",
          },
          {
            value: "6",
            label: "梓潼县",
          },
          {
            value: "7",
            label: "北川羌族自治县",
          },
          {
            value: "8",
            label: "平武县",
          },
          {
            value: "9",
            label: "江油市",
          },
        ],
      },
      {
        value: "6",
        label: "广元市",
        children: [
          {
            value: "1",
            label: "市中区",
          },
          {
            value: "2",
            label: "元坝区",
          },
          {
            value: "3",
            label: "朝天区",
          },
          {
            value: "4",
            label: "旺苍县",
          },
          {
            value: "5",
            label: "青川县",
          },
          {
            value: "6",
            label: "剑阁县",
          },
          {
            value: "7",
            label: "苍溪县",
          },
          {
            value: "8",
            label: "利州区",
          },
        ],
      },
      {
        value: "7",
        label: "遂宁市",
        children: [
          {
            value: "1",
            label: "船山区",
          },
          {
            value: "2",
            label: "安居区",
          },
          {
            value: "3",
            label: "蓬溪县",
          },
          {
            value: "4",
            label: "射洪县",
          },
          {
            value: "5",
            label: "大英县",
          },
        ],
      },
      {
        value: "8",
        label: "内江市",
        children: [
          {
            value: "1",
            label: "市中区",
          },
          {
            value: "2",
            label: "东兴区",
          },
          {
            value: "3",
            label: "威远县",
          },
          {
            value: "4",
            label: "资中县",
          },
          {
            value: "5",
            label: "隆昌县",
          },
        ],
      },
      {
        value: "9",
        label: "乐山市",
        children: [
          {
            value: "1",
            label: "市中区",
          },
          {
            value: "2",
            label: "沙湾区",
          },
          {
            value: "3",
            label: "五通桥区",
          },
          {
            value: "4",
            label: "金口河区",
          },
          {
            value: "5",
            label: "犍为县",
          },
          {
            value: "6",
            label: "井研县",
          },
          {
            value: "7",
            label: "夹江县",
          },
          {
            value: "8",
            label: "沐川县",
          },
          {
            value: "9",
            label: "峨边彝族自治县",
          },
          {
            value: "A",
            label: "马边彝族自治县",
          },
          {
            value: "B",
            label: "峨眉山市",
          },
        ],
      },
      {
        value: "A",
        label: "南充市",
        children: [
          {
            value: "1",
            label: "顺庆区",
          },
          {
            value: "2",
            label: "高坪区",
          },
          {
            value: "3",
            label: "嘉陵区",
          },
          {
            value: "4",
            label: "南部县",
          },
          {
            value: "5",
            label: "营山县",
          },
          {
            value: "6",
            label: "蓬安县",
          },
          {
            value: "7",
            label: "仪陇县",
          },
          {
            value: "8",
            label: "西充县",
          },
          {
            value: "9",
            label: "阆中市",
          },
        ],
      },
      {
        value: "B",
        label: "眉山市",
        children: [
          {
            value: "1",
            label: "东坡区",
          },
          {
            value: "2",
            label: "仁寿县",
          },
          {
            value: "3",
            label: "彭山县",
          },
          {
            value: "4",
            label: "洪雅县",
          },
          {
            value: "5",
            label: "丹棱县",
          },
          {
            value: "6",
            label: "青神县",
          },
        ],
      },
      {
        value: "C",
        label: "宜宾市",
        children: [
          {
            value: "1",
            label: "翠屏区",
          },
          {
            value: "2",
            label: "宜宾县",
          },
          {
            value: "3",
            label: "南溪县",
          },
          {
            value: "4",
            label: "江安县",
          },
          {
            value: "5",
            label: "长宁县",
          },
          {
            value: "6",
            label: "高县",
          },
          {
            value: "7",
            label: "珙县",
          },
          {
            value: "8",
            label: "筠连县",
          },
          {
            value: "9",
            label: "兴文县",
          },
          {
            value: "A",
            label: "屏山县",
          },
        ],
      },
      {
        value: "D",
        label: "广安市",
        children: [
          {
            value: "1",
            label: "广安区",
          },
          {
            value: "2",
            label: "岳池县",
          },
          {
            value: "3",
            label: "武胜县",
          },
          {
            value: "4",
            label: "邻水县",
          },
          {
            value: "5",
            label: "华莹市",
          },
        ],
      },
      {
        value: "E",
        label: "达州市",
        children: [
          {
            value: "1",
            label: "通川区",
          },
          {
            value: "2",
            label: "达县",
          },
          {
            value: "3",
            label: "宣汉县",
          },
          {
            value: "4",
            label: "开江县",
          },
          {
            value: "5",
            label: "大竹县",
          },
          {
            value: "6",
            label: "渠县",
          },
          {
            value: "7",
            label: "万源市",
          },
        ],
      },
      {
        value: "F",
        label: "雅安市",
        children: [
          {
            value: "1",
            label: "雨城区",
          },
          {
            value: "2",
            label: "名山县",
          },
          {
            value: "3",
            label: "荥经县",
          },
          {
            value: "4",
            label: "汉源县",
          },
          {
            value: "5",
            label: "石棉县",
          },
          {
            value: "6",
            label: "天全县",
          },
          {
            value: "7",
            label: "芦山县",
          },
          {
            value: "8",
            label: "宝兴县",
          },
        ],
      },
      {
        value: "G",
        label: "巴中市",
        children: [
          {
            value: "1",
            label: "巴州区",
          },
          {
            value: "2",
            label: "通江县",
          },
          {
            value: "3",
            label: "南江县",
          },
          {
            value: "4",
            label: "平昌县",
          },
        ],
      },
      {
        value: "H",
        label: "资阳市",
        children: [
          {
            value: "1",
            label: "雁江区",
          },
          {
            value: "2",
            label: "安岳县",
          },
          {
            value: "3",
            label: "乐至县",
          },
          {
            value: "4",
            label: "简阳市",
          },
        ],
      },
      {
        value: "I",
        label: "阿坝藏族羌族自治州",
        children: [
          {
            value: "1",
            label: "汶川县",
          },
          {
            value: "2",
            label: "理县",
          },
          {
            value: "3",
            label: "茂县",
          },
          {
            value: "4",
            label: "松潘县",
          },
          {
            value: "5",
            label: "九寨沟县",
          },
          {
            value: "6",
            label: "金川县",
          },
          {
            value: "7",
            label: "小金县",
          },
          {
            value: "8",
            label: "黑水县",
          },
          {
            value: "9",
            label: "马尔康县",
          },
          {
            value: "A",
            label: "壤塘县",
          },
          {
            value: "B",
            label: "阿坝县",
          },
          {
            value: "C",
            label: "若尔盖县",
          },
          {
            value: "D",
            label: "红原县",
          },
        ],
      },
      {
        value: "J",
        label: "甘孜藏族自治州",
        children: [
          {
            value: "1",
            label: "康定县",
          },
          {
            value: "2",
            label: "泸定县",
          },
          {
            value: "3",
            label: "丹巴县",
          },
          {
            value: "4",
            label: "九龙县",
          },
          {
            value: "5",
            label: "雅江县",
          },
          {
            value: "6",
            label: "道孚县",
          },
          {
            value: "7",
            label: "炉霍县",
          },
          {
            value: "8",
            label: "甘孜县",
          },
          {
            value: "9",
            label: "新龙县",
          },
          {
            value: "A",
            label: "德格县",
          },
          {
            value: "B",
            label: "白玉县",
          },
          {
            value: "C",
            label: "石渠县",
          },
          {
            value: "D",
            label: "色达县",
          },
          {
            value: "E",
            label: "理塘县",
          },
          {
            value: "F",
            label: "巴塘县",
          },
          {
            value: "G",
            label: "乡城县",
          },
          {
            value: "H",
            label: "稻城县",
          },
          {
            value: "I",
            label: "得荣县",
          },
        ],
      },
      {
        value: "K",
        label: "凉山彝族自治州",
        children: [
          {
            value: "1",
            label: "西昌市",
          },
          {
            value: "2",
            label: "木里藏族自治县",
          },
          {
            value: "3",
            label: "盐源县",
          },
          {
            value: "4",
            label: "德昌县",
          },
          {
            value: "5",
            label: "会理县",
          },
          {
            value: "6",
            label: "会东县",
          },
          {
            value: "7",
            label: "宁南县",
          },
          {
            value: "8",
            label: "普格县",
          },
          {
            value: "9",
            label: "布拖县",
          },
          {
            value: "A",
            label: "金阳县",
          },
          {
            value: "B",
            label: "昭觉县",
          },
          {
            value: "C",
            label: "喜德县",
          },
          {
            value: "D",
            label: "冕宁县",
          },
          {
            value: "E",
            label: "越西县",
          },
          {
            value: "F",
            label: "甘洛县",
          },
          {
            value: "G",
            label: "美姑县",
          },
          {
            value: "H",
            label: "雷波县",
          },
        ],
      },
      {
        value: "O",
        label: "成都",
        children: [
          {
            value: "1",
            label: "锦江区",
          },
          {
            value: "2",
            label: "青羊区",
          },
          {
            value: "3",
            label: "金牛区",
          },
          {
            value: "4",
            label: "武侯区",
          },
          {
            value: "5",
            label: "成华区",
          },
          {
            value: "6",
            label: "龙泉驿区",
          },
          {
            value: "7",
            label: "青白江区",
          },
          {
            value: "8",
            label: "新都区",
          },
          {
            value: "9",
            label: "温江区",
          },
          {
            value: "A",
            label: "金堂县",
          },
          {
            value: "B",
            label: "双流县",
          },
          {
            value: "C",
            label: "郫县",
          },
          {
            value: "D",
            label: "大邑县",
          },
          {
            value: "E",
            label: "蒲江县",
          },
          {
            value: "F",
            label: "新津县",
          },
          {
            value: "G",
            label: "都江堰市",
          },
          {
            value: "H",
            label: "彭州市",
          },
          {
            value: "I",
            label: "邛崃市",
          },
          {
            value: "J",
            label: "崇州市",
          },
          {
            value: "K",
            label: "高新区",
          },
        ],
      },
    ],
  },
  {
    value: "M",
    label: "贵州",
    children: [
      {
        value: "0",
        label: "贵阳市",
        children: [
          {
            value: "1",
            label: "南明区",
          },
          {
            value: "2",
            label: "云岩区",
          },
          {
            value: "3",
            label: "花溪区",
          },
          {
            value: "4",
            label: "乌当区",
          },
          {
            value: "5",
            label: "白云区",
          },
          {
            value: "6",
            label: "小河区",
          },
          {
            value: "7",
            label: "开阳县",
          },
          {
            value: "8",
            label: "息烽县",
          },
          {
            value: "9",
            label: "修文县",
          },
          {
            value: "A",
            label: "清镇市",
          },
        ],
      },
      {
        value: "1",
        label: "六盘水市",
        children: [
          {
            value: "1",
            label: "钟山区",
          },
          {
            value: "2",
            label: "六枝特区",
          },
          {
            value: "3",
            label: "水城县",
          },
          {
            value: "4",
            label: "盘县",
          },
        ],
      },
      {
        value: "2",
        label: "遵义市",
        children: [
          {
            value: "1",
            label: "红花岗区",
          },
          {
            value: "2",
            label: "汇川区",
          },
          {
            value: "3",
            label: "遵义县",
          },
          {
            value: "4",
            label: "桐梓县",
          },
          {
            value: "5",
            label: "绥阳县",
          },
          {
            value: "6",
            label: "正安县",
          },
          {
            value: "7",
            label: "道真仡佬族苗族自治县",
          },
          {
            value: "8",
            label: "务川仡佬族苗族自治县",
          },
          {
            value: "9",
            label: "凤冈县",
          },
          {
            value: "A",
            label: "湄潭县",
          },
          {
            value: "B",
            label: "余庆县",
          },
          {
            value: "C",
            label: "习水县",
          },
          {
            value: "D",
            label: "赤水市",
          },
          {
            value: "E",
            label: "仁怀市",
          },
        ],
      },
      {
        value: "3",
        label: "安顺市",
        children: [
          {
            value: "1",
            label: "西秀区",
          },
          {
            value: "2",
            label: "平坝县",
          },
          {
            value: "3",
            label: "普定县",
          },
          {
            value: "4",
            label: "镇宁布依族苗族自治县",
          },
          {
            value: "5",
            label: "关岭布依族苗族自治县",
          },
          {
            value: "6",
            label: "紫云苗族布依族自治县",
          },
        ],
      },
      {
        value: "4",
        label: "铜仁地区",
        children: [
          {
            value: "1",
            label: "铜仁市",
          },
          {
            value: "2",
            label: "江口县",
          },
          {
            value: "3",
            label: "玉屏侗族自治县",
          },
          {
            value: "4",
            label: "石阡县",
          },
          {
            value: "5",
            label: "思南县",
          },
          {
            value: "6",
            label: "印江土家族苗族自治县",
          },
          {
            value: "7",
            label: "德江县",
          },
          {
            value: "8",
            label: "沿河土家族自治县",
          },
          {
            value: "9",
            label: "松桃苗族自治县",
          },
          {
            value: "A",
            label: "万山特区",
          },
        ],
      },
      {
        value: "5",
        label: "黔西南布依族苗族自治州",
        children: [
          {
            value: "1",
            label: "兴义市",
          },
          {
            value: "2",
            label: "兴仁县",
          },
          {
            value: "3",
            label: "普安县",
          },
          {
            value: "4",
            label: "晴隆县",
          },
          {
            value: "5",
            label: "贞丰县",
          },
          {
            value: "6",
            label: "望谟县",
          },
          {
            value: "7",
            label: "册亨县",
          },
          {
            value: "8",
            label: "安龙县",
          },
        ],
      },
      {
        value: "6",
        label: "毕节地区",
        children: [
          {
            value: "1",
            label: "毕节市",
          },
          {
            value: "2",
            label: "大方县",
          },
          {
            value: "3",
            label: "黔西县",
          },
          {
            value: "4",
            label: "金沙县",
          },
          {
            value: "5",
            label: "织金县",
          },
          {
            value: "6",
            label: "纳雍县",
          },
          {
            value: "7",
            label: "威宁彝族回族苗族自治县",
          },
          {
            value: "8",
            label: "赫章县",
          },
        ],
      },
      {
        value: "7",
        label: "黔东南苗族侗族自治州",
        children: [
          {
            value: "1",
            label: "凯里市",
          },
          {
            value: "2",
            label: "黄平县",
          },
          {
            value: "3",
            label: "施秉县",
          },
          {
            value: "4",
            label: "三穗县",
          },
          {
            value: "5",
            label: "镇远县",
          },
          {
            value: "6",
            label: "岑巩县",
          },
          {
            value: "7",
            label: "天柱县",
          },
          {
            value: "8",
            label: "锦屏县",
          },
          {
            value: "9",
            label: "剑河县",
          },
          {
            value: "A",
            label: "台江县",
          },
          {
            value: "B",
            label: "黎平县",
          },
          {
            value: "C",
            label: "榕江县",
          },
          {
            value: "D",
            label: "从江县",
          },
          {
            value: "E",
            label: "雷山县",
          },
          {
            value: "F",
            label: "麻江县",
          },
          {
            value: "G",
            label: "丹寨县",
          },
          {
            value: "H",
            label: "都匀市",
          },
          {
            value: "I",
            label: "福泉市",
          },
          {
            value: "J",
            label: "荔波县",
          },
          {
            value: "K",
            label: "贵定县",
          },
          {
            value: "L",
            label: "瓮安县",
          },
          {
            value: "M",
            label: "独山县",
          },
          {
            value: "N",
            label: "平塘县",
          },
          {
            value: "O",
            label: "罗甸县",
          },
          {
            value: "P",
            label: "长顺县",
          },
          {
            value: "Q",
            label: "龙里县",
          },
          {
            value: "R",
            label: "惠水县",
          },
          {
            value: "S",
            label: "三都水族自治县",
          },
        ],
      },
    ],
  },
  {
    value: "N",
    label: "云南",
    children: [
      {
        value: "0",
        label: "昆明市",
        children: [
          {
            value: "1",
            label: "五华区",
          },
          {
            value: "2",
            label: "盘龙区",
          },
          {
            value: "3",
            label: "官渡区",
          },
          {
            value: "4",
            label: "西山区",
          },
          {
            value: "5",
            label: "东川区",
          },
          {
            value: "6",
            label: "呈贡县",
          },
          {
            value: "7",
            label: "晋宁县",
          },
          {
            value: "8",
            label: "富民县",
          },
          {
            value: "9",
            label: "宜良县",
          },
          {
            value: "A",
            label: "石林彝族自治县",
          },
          {
            value: "B",
            label: "嵩明县",
          },
          {
            value: "C",
            label: "禄劝彝族苗族自治县",
          },
          {
            value: "D",
            label: "寻甸回族彝族自治县",
          },
          {
            value: "E",
            label: "安宁市",
          },
        ],
      },
      {
        value: "1",
        label: "曲靖市",
        children: [
          {
            value: "1",
            label: "麒麟区",
          },
          {
            value: "2",
            label: "马龙县",
          },
          {
            value: "3",
            label: "陆良县",
          },
          {
            value: "4",
            label: "师宗县",
          },
          {
            value: "5",
            label: "罗平县",
          },
          {
            value: "6",
            label: "富源县",
          },
          {
            value: "7",
            label: "会泽县",
          },
          {
            value: "8",
            label: "沾益县",
          },
          {
            value: "9",
            label: "宣威市",
          },
        ],
      },
      {
        value: "2",
        label: "玉溪市",
        children: [
          {
            value: "1",
            label: "红塔区",
          },
          {
            value: "2",
            label: "江川县",
          },
          {
            value: "3",
            label: "澄江县",
          },
          {
            value: "4",
            label: "通海县",
          },
          {
            value: "5",
            label: "华宁县",
          },
          {
            value: "6",
            label: "易门县",
          },
          {
            value: "7",
            label: "峨山彝族自治县",
          },
          {
            value: "8",
            label: "新平彝族傣族自治县",
          },
          {
            value: "9",
            label: "元江哈尼族彝族傣族自治县",
          },
        ],
      },
      {
        value: "3",
        label: "保山市",
        children: [
          {
            value: "1",
            label: "隆阳区",
          },
          {
            value: "2",
            label: "施甸县",
          },
          {
            value: "3",
            label: "腾冲县",
          },
          {
            value: "4",
            label: "龙陵县",
          },
          {
            value: "5",
            label: "昌宁县",
          },
        ],
      },
      {
        value: "4",
        label: "昭通市",
        children: [
          {
            value: "1",
            label: "昭阳区",
          },
          {
            value: "2",
            label: "鲁甸县",
          },
          {
            value: "3",
            label: "巧家县",
          },
          {
            value: "4",
            label: "盐津县",
          },
          {
            value: "5",
            label: "大关县",
          },
          {
            value: "6",
            label: "永善县",
          },
          {
            value: "7",
            label: "绥江县",
          },
          {
            value: "8",
            label: "镇雄县",
          },
          {
            value: "9",
            label: "彝良县",
          },
          {
            value: "A",
            label: "威信县",
          },
          {
            value: "B",
            label: "水富县",
          },
        ],
      },
      {
        value: "5",
        label: "丽江市",
        children: [
          {
            value: "1",
            label: "古城区",
          },
          {
            value: "2",
            label: "玉龙纳西族自治县",
          },
          {
            value: "3",
            label: "永胜县",
          },
          {
            value: "4",
            label: "华坪县",
          },
          {
            value: "5",
            label: "宁蒗彝族自治县",
          },
        ],
      },
      {
        value: "6",
        label: "思茅市",
        children: [
          {
            value: "1",
            label: "翠云区",
          },
          {
            value: "2",
            label: "普洱哈尼族彝族自治县",
          },
          {
            value: "3",
            label: "墨江哈尼族自治县",
          },
          {
            value: "4",
            label: "景东彝族自治县",
          },
          {
            value: "5",
            label: "景谷傣族彝族自治县",
          },
          {
            value: "6",
            label: "镇沅彝族哈尼族拉祜族自治县",
          },
          {
            value: "7",
            label: "江城哈尼族彝族自治县",
          },
          {
            value: "8",
            label: "孟连傣族拉祜族佤族自治县",
          },
          {
            value: "9",
            label: "澜沧拉祜族自治县",
          },
          {
            value: "A",
            label: "西盟佤族自治县",
          },
        ],
      },
      {
        value: "7",
        label: "临沧市",
        children: [
          {
            value: "1",
            label: "临翔区",
          },
          {
            value: "2",
            label: "凤庆县",
          },
          {
            value: "3",
            label: "云县",
          },
          {
            value: "4",
            label: "永德县",
          },
          {
            value: "5",
            label: "镇康县",
          },
          {
            value: "6",
            label: "双江拉祜族佤族布朗族傣族自治县",
          },
          {
            value: "7",
            label: "耿马傣族佤族自治县",
          },
          {
            value: "8",
            label: "沧源佤族自治县",
          },
        ],
      },
      {
        value: "8",
        label: "楚雄彝族自治州",
        children: [
          {
            value: "1",
            label: "楚雄市",
          },
          {
            value: "2",
            label: "双柏县",
          },
          {
            value: "3",
            label: "牟定县",
          },
          {
            value: "4",
            label: "南华县",
          },
          {
            value: "5",
            label: "姚安县",
          },
          {
            value: "6",
            label: "大姚县",
          },
          {
            value: "7",
            label: "永仁县",
          },
          {
            value: "8",
            label: "元谋县",
          },
          {
            value: "9",
            label: "武定县",
          },
          {
            value: "A",
            label: "禄丰县",
          },
        ],
      },
      {
        value: "9",
        label: "红河哈尼族彝族自治州",
        children: [
          {
            value: "1",
            label: "个旧市",
          },
          {
            value: "2",
            label: "开远市",
          },
          {
            value: "3",
            label: "蒙自县",
          },
          {
            value: "4",
            label: "屏边苗族自治县",
          },
          {
            value: "5",
            label: "建水县",
          },
          {
            value: "6",
            label: "石屏县",
          },
          {
            value: "7",
            label: "弥勒县",
          },
          {
            value: "8",
            label: "泸西县",
          },
          {
            value: "9",
            label: "元阳县",
          },
          {
            value: "A",
            label: "红河县",
          },
          {
            value: "B",
            label: "金平苗族瑶族傣族自治县",
          },
          {
            value: "C",
            label: "绿春县",
          },
          {
            value: "D",
            label: "河口瑶族自治县",
          },
        ],
      },
      {
        value: "A",
        label: "文山壮族苗族自治州",
        children: [
          {
            value: "1",
            label: "文山县",
          },
          {
            value: "2",
            label: "砚山县",
          },
          {
            value: "3",
            label: "西畴县",
          },
          {
            value: "4",
            label: "麻栗坡县",
          },
          {
            value: "5",
            label: "马关县",
          },
          {
            value: "6",
            label: "丘北县",
          },
          {
            value: "7",
            label: "广南县",
          },
          {
            value: "8",
            label: "富宁县",
          },
        ],
      },
      {
        value: "B",
        label: "西双版纳傣族自治州",
        children: [
          {
            value: "1",
            label: "景洪市",
          },
          {
            value: "2",
            label: "勐海县",
          },
          {
            value: "3",
            label: "勐腊县",
          },
        ],
      },
      {
        value: "C",
        label: "大理白族自治州",
        children: [
          {
            value: "1",
            label: "大理市",
          },
          {
            value: "2",
            label: "漾濞彝族自治县",
          },
          {
            value: "3",
            label: "祥云县",
          },
          {
            value: "4",
            label: "宾川县",
          },
          {
            value: "5",
            label: "弥渡县",
          },
          {
            value: "6",
            label: "南涧彝族自治县",
          },
          {
            value: "7",
            label: "巍山彝族回族自治县",
          },
          {
            value: "8",
            label: "永平县",
          },
          {
            value: "9",
            label: "云龙县",
          },
          {
            value: "A",
            label: "洱源县",
          },
          {
            value: "B",
            label: "剑川县",
          },
          {
            value: "C",
            label: "鹤庆县",
          },
        ],
      },
      {
        value: "D",
        label: "德宏傣族景颇族自治州",
        children: [
          {
            value: "1",
            label: "瑞丽市",
          },
          {
            value: "2",
            label: "潞西市",
          },
          {
            value: "3",
            label: "梁河县",
          },
          {
            value: "4",
            label: "盈江县",
          },
          {
            value: "5",
            label: "陇川县",
          },
        ],
      },
      {
        value: "E",
        label: "怒江傈僳族自治州",
        children: [
          {
            value: "1",
            label: "泸水县",
          },
          {
            value: "2",
            label: "福贡县",
          },
          {
            value: "3",
            label: "贡山独龙族怒族自治县",
          },
          {
            value: "4",
            label: "兰坪白族普米族自治县",
          },
        ],
      },
      {
        value: "F",
        label: "迪庆藏族自治州",
        children: [
          {
            value: "1",
            label: "香格里拉县",
          },
          {
            value: "2",
            label: "德钦县",
          },
          {
            value: "3",
            label: "维西傈僳族自治县",
          },
        ],
      },
    ],
  },
  {
    value: "O",
    label: "陕西",
    children: [
      {
        value: "0",
        label: "西安市",
        children: [
          {
            value: "1",
            label: "新城区",
          },
          {
            value: "2",
            label: "碑林区",
          },
          {
            value: "3",
            label: "莲湖区",
          },
          {
            value: "4",
            label: "灞桥区",
          },
          {
            value: "5",
            label: "未央区",
          },
          {
            value: "6",
            label: "雁塔区",
          },
          {
            value: "7",
            label: "阎良区",
          },
          {
            value: "8",
            label: "临潼区",
          },
          {
            value: "9",
            label: "长安区",
          },
          {
            value: "A",
            label: "蓝田县",
          },
          {
            value: "B",
            label: "周至县",
          },
          {
            value: "C",
            label: "户县",
          },
          {
            value: "D",
            label: "高陵县",
          },
          {
            value: "E",
            label: "高新区",
          },
        ],
      },
      {
        value: "1",
        label: "铜川市",
        children: [
          {
            value: "1",
            label: "王益区",
          },
          {
            value: "2",
            label: "印台区",
          },
          {
            value: "3",
            label: "耀州区",
          },
          {
            value: "4",
            label: "宜君县",
          },
          {
            value: "5",
            label: "新区",
          },
        ],
      },
      {
        value: "2",
        label: "宝鸡市",
        children: [
          {
            value: "1",
            label: "渭滨区",
          },
          {
            value: "2",
            label: "金台区",
          },
          {
            value: "3",
            label: "陈仓区",
          },
          {
            value: "4",
            label: "凤翔县",
          },
          {
            value: "5",
            label: "岐山县",
          },
          {
            value: "6",
            label: "扶风县",
          },
          {
            value: "7",
            label: "眉县",
          },
          {
            value: "8",
            label: "陇县",
          },
          {
            value: "9",
            label: "千阳县",
          },
          {
            value: "A",
            label: "麟游县",
          },
          {
            value: "B",
            label: "凤县",
          },
          {
            value: "C",
            label: "太白县",
          },
        ],
      },
      {
        value: "3",
        label: "咸阳市",
        children: [
          {
            value: "1",
            label: "秦都区",
          },
          {
            value: "2",
            label: "杨凌区",
          },
          {
            value: "3",
            label: "渭城区",
          },
          {
            value: "4",
            label: "三原县",
          },
          {
            value: "5",
            label: "泾阳县",
          },
          {
            value: "6",
            label: "乾县",
          },
          {
            value: "7",
            label: "礼泉县",
          },
          {
            value: "8",
            label: "永寿县",
          },
          {
            value: "9",
            label: "彬县",
          },
          {
            value: "A",
            label: "长武县",
          },
          {
            value: "B",
            label: "旬邑县",
          },
          {
            value: "C",
            label: "淳化县",
          },
          {
            value: "D",
            label: "武功县",
          },
          {
            value: "E",
            label: "兴平市",
          },
        ],
      },
      {
        value: "4",
        label: "渭南市",
        children: [
          {
            value: "1",
            label: "临渭区",
          },
          {
            value: "2",
            label: "华县",
          },
          {
            value: "3",
            label: "潼关县",
          },
          {
            value: "4",
            label: "大荔县",
          },
          {
            value: "5",
            label: "合阳县",
          },
          {
            value: "6",
            label: "澄城县",
          },
          {
            value: "7",
            label: "蒲城县",
          },
          {
            value: "8",
            label: "白水县",
          },
          {
            value: "9",
            label: "富平县",
          },
          {
            value: "A",
            label: "韩城市",
          },
          {
            value: "B",
            label: "华阴市",
          },
        ],
      },
      {
        value: "5",
        label: "延安市",
        children: [
          {
            value: "1",
            label: "宝塔区",
          },
          {
            value: "2",
            label: "延长县",
          },
          {
            value: "3",
            label: "延川县",
          },
          {
            value: "4",
            label: "子长县",
          },
          {
            value: "5",
            label: "安塞县",
          },
          {
            value: "6",
            label: "志丹县",
          },
          {
            value: "7",
            label: "吴旗县",
          },
          {
            value: "8",
            label: "甘泉县",
          },
          {
            value: "9",
            label: "富县",
          },
          {
            value: "A",
            label: "洛川县",
          },
          {
            value: "B",
            label: "宜川县",
          },
          {
            value: "C",
            label: "黄龙县",
          },
          {
            value: "D",
            label: "黄陵县",
          },
        ],
      },
      {
        value: "6",
        label: "汉中市",
        children: [
          {
            value: "1",
            label: "汉台区",
          },
          {
            value: "2",
            label: "南郑县",
          },
          {
            value: "3",
            label: "城固县",
          },
          {
            value: "4",
            label: "洋县",
          },
          {
            value: "5",
            label: "西乡县",
          },
          {
            value: "6",
            label: "勉县",
          },
          {
            value: "7",
            label: "宁强县",
          },
          {
            value: "8",
            label: "略阳县",
          },
          {
            value: "9",
            label: "镇巴县",
          },
          {
            value: "A",
            label: "留坝县",
          },
          {
            value: "B",
            label: "佛坪县",
          },
        ],
      },
      {
        value: "7",
        label: "榆林市",
        children: [
          {
            value: "1",
            label: "榆阳区",
          },
          {
            value: "2",
            label: "神木县",
          },
          {
            value: "3",
            label: "府谷县",
          },
          {
            value: "4",
            label: "横山县",
          },
          {
            value: "5",
            label: "靖边县",
          },
          {
            value: "6",
            label: "定边县",
          },
          {
            value: "7",
            label: "绥德县",
          },
          {
            value: "8",
            label: "米脂县",
          },
          {
            value: "9",
            label: "佳县",
          },
          {
            value: "A",
            label: "吴堡县",
          },
          {
            value: "B",
            label: "清涧县",
          },
          {
            value: "C",
            label: "子洲县",
          },
        ],
      },
      {
        value: "8",
        label: "安康市",
        children: [
          {
            value: "1",
            label: "汉滨区",
          },
          {
            value: "2",
            label: "汉阴县",
          },
          {
            value: "3",
            label: "石泉县",
          },
          {
            value: "4",
            label: "宁陕县",
          },
          {
            value: "5",
            label: "紫阳县",
          },
          {
            value: "6",
            label: "岚皋县",
          },
          {
            value: "7",
            label: "平利县",
          },
          {
            value: "8",
            label: "镇坪县",
          },
          {
            value: "A",
            label: "旬阳县",
          },
          {
            value: "B",
            label: "白河县",
          },
        ],
      },
      {
        value: "9",
        label: "商洛市",
        children: [
          {
            value: "1",
            label: "商州区",
          },
          {
            value: "2",
            label: "洛南县",
          },
          {
            value: "3",
            label: "丹凤县",
          },
          {
            value: "4",
            label: "商南县",
          },
          {
            value: "5",
            label: "山阳县",
          },
          {
            value: "6",
            label: "镇安县",
          },
          {
            value: "7",
            label: "柞水县",
          },
        ],
      },
    ],
  },
  {
    value: "P",
    label: "甘肃",
    children: [
      {
        value: "0",
        label: "兰州市",
        children: [
          {
            value: "1",
            label: "城关区",
          },
          {
            value: "2",
            label: "七里河区",
          },
          {
            value: "3",
            label: "西固区",
          },
          {
            value: "4",
            label: "安宁区",
          },
          {
            value: "5",
            label: "红古区",
          },
          {
            value: "6",
            label: "永登县",
          },
          {
            value: "7",
            label: "皋兰县",
          },
          {
            value: "8",
            label: "榆中县",
          },
        ],
      },
      {
        value: "1",
        label: "嘉峪关市",
        children: [
          {
            value: "1",
            label: "嘉峪关市",
          },
        ],
      },
      {
        value: "2",
        label: "金昌市",
        children: [
          {
            value: "1",
            label: "金川区",
          },
          {
            value: "2",
            label: "永昌县",
          },
        ],
      },
      {
        value: "3",
        label: "白银市",
        children: [
          {
            value: "1",
            label: "白银区",
          },
          {
            value: "2",
            label: "平川区",
          },
          {
            value: "3",
            label: "靖远县",
          },
          {
            value: "4",
            label: "会宁县",
          },
          {
            value: "5",
            label: "景泰县",
          },
        ],
      },
      {
        value: "4",
        label: "天水市",
        children: [
          {
            value: "1",
            label: "秦城区",
          },
          {
            value: "2",
            label: "北道区",
          },
          {
            value: "3",
            label: "清水县",
          },
          {
            value: "4",
            label: "秦安县",
          },
          {
            value: "5",
            label: "甘谷县",
          },
          {
            value: "6",
            label: "武山县",
          },
          {
            value: "7",
            label: "张家川回族自治县",
          },
          {
            value: "8",
            label: "麦积区",
          },
        ],
      },
      {
        value: "5",
        label: "武威市",
        children: [
          {
            value: "1",
            label: "凉州区",
          },
          {
            value: "2",
            label: "民勤县",
          },
          {
            value: "3",
            label: "古浪县",
          },
          {
            value: "4",
            label: "天祝藏族自治县",
          },
        ],
      },
      {
        value: "6",
        label: "张掖市",
        children: [
          {
            value: "1",
            label: "甘州区",
          },
          {
            value: "2",
            label: "肃南裕固族自治县",
          },
          {
            value: "3",
            label: "民乐县",
          },
          {
            value: "4",
            label: "临泽县",
          },
          {
            value: "5",
            label: "高台县",
          },
          {
            value: "6",
            label: "山丹县",
          },
        ],
      },
      {
        value: "7",
        label: "平凉市",
        children: [
          {
            value: "1",
            label: "崆峒区",
          },
          {
            value: "2",
            label: "泾川县",
          },
          {
            value: "3",
            label: "灵台县",
          },
          {
            value: "4",
            label: "崇信县",
          },
          {
            value: "5",
            label: "华亭县",
          },
          {
            value: "6",
            label: "庄浪县",
          },
          {
            value: "7",
            label: "静宁县",
          },
        ],
      },
      {
        value: "8",
        label: "酒泉市",
        children: [
          {
            value: "1",
            label: "肃州区",
          },
          {
            value: "2",
            label: "金塔县",
          },
          {
            value: "3",
            label: "安西县",
          },
          {
            value: "4",
            label: "肃北蒙古族自治县",
          },
          {
            value: "5",
            label: "阿克塞哈萨克族自治县",
          },
          {
            value: "6",
            label: "玉门市",
          },
          {
            value: "7",
            label: "敦煌市",
          },
        ],
      },
      {
        value: "9",
        label: "庆阳市",
        children: [
          {
            value: "1",
            label: "西峰区",
          },
          {
            value: "2",
            label: "庆城县",
          },
          {
            value: "3",
            label: "环县",
          },
          {
            value: "4",
            label: "华池县",
          },
          {
            value: "5",
            label: "合水县",
          },
          {
            value: "6",
            label: "正宁县",
          },
          {
            value: "7",
            label: "宁县",
          },
          {
            value: "8",
            label: "镇原县",
          },
        ],
      },
      {
        value: "A",
        label: "定西市",
        children: [
          {
            value: "1",
            label: "安定区",
          },
          {
            value: "2",
            label: "通渭县",
          },
          {
            value: "3",
            label: "陇西县",
          },
          {
            value: "4",
            label: "渭源县",
          },
          {
            value: "5",
            label: "临洮县",
          },
          {
            value: "6",
            label: "漳县",
          },
          {
            value: "7",
            label: "岷县",
          },
        ],
      },
      {
        value: "B",
        label: "陇南市",
        children: [
          {
            value: "1",
            label: "武都区",
          },
          {
            value: "2",
            label: "成县",
          },
          {
            value: "3",
            label: "文县",
          },
          {
            value: "4",
            label: "宕昌县",
          },
          {
            value: "5",
            label: "康县",
          },
          {
            value: "6",
            label: "西和县",
          },
          {
            value: "7",
            label: "礼县",
          },
          {
            value: "8",
            label: "徽县",
          },
          {
            value: "9",
            label: "两当县",
          },
        ],
      },
      {
        value: "C",
        label: "临夏回族自治州",
        children: [
          {
            value: "1",
            label: "临夏市",
          },
          {
            value: "2",
            label: "临夏县",
          },
          {
            value: "3",
            label: "康乐县",
          },
          {
            value: "4",
            label: "永靖县",
          },
          {
            value: "5",
            label: "广河县",
          },
          {
            value: "6",
            label: "和政县",
          },
          {
            value: "7",
            label: "东乡族自治县",
          },
          {
            value: "8",
            label: "积石山保安族东乡族撒拉族自治县",
          },
        ],
      },
      {
        value: "D",
        label: "甘南藏族自治州",
        children: [
          {
            value: "1",
            label: "合作市",
          },
          {
            value: "2",
            label: "临潭县",
          },
          {
            value: "3",
            label: "卓尼县",
          },
          {
            value: "4",
            label: "舟曲县",
          },
          {
            value: "5",
            label: "迭部县",
          },
          {
            value: "6",
            label: "玛曲县",
          },
          {
            value: "7",
            label: "碌曲县",
          },
          {
            value: "8",
            label: "夏河县",
          },
        ],
      },
    ],
  },
  {
    value: "Q",
    label: "青海",
    children: [
      {
        value: "0",
        label: "西宁市",
        children: [
          {
            value: "1",
            label: "城东区",
          },
          {
            value: "2",
            label: "城中区",
          },
          {
            value: "3",
            label: "城西区",
          },
          {
            value: "4",
            label: "城北区",
          },
          {
            value: "5",
            label: "大通回族土族自治县",
          },
          {
            value: "6",
            label: "湟中县",
          },
          {
            value: "7",
            label: "湟源县",
          },
        ],
      },
      {
        value: "1",
        label: "海东地区",
        children: [
          {
            value: "1",
            label: "平安县",
          },
          {
            value: "2",
            label: "民和回族土族自治县",
          },
          {
            value: "3",
            label: "乐都县",
          },
          {
            value: "4",
            label: "互助土族自治县",
          },
          {
            value: "5",
            label: "化隆回族自治县",
          },
          {
            value: "6",
            label: "循化撒拉族自治县",
          },
        ],
      },
      {
        value: "2",
        label: "海北藏族自治州",
        children: [
          {
            value: "1",
            label: "门源回族自治县",
          },
          {
            value: "2",
            label: "祁连县",
          },
          {
            value: "3",
            label: "海晏县",
          },
          {
            value: "4",
            label: "刚察县",
          },
        ],
      },
      {
        value: "3",
        label: "黄南藏族自治州",
        children: [
          {
            value: "1",
            label: "同仁县",
          },
          {
            value: "2",
            label: "尖扎县",
          },
          {
            value: "3",
            label: "泽库县",
          },
          {
            value: "4",
            label: "河南蒙古族自治县",
          },
        ],
      },
      {
        value: "4",
        label: "海南藏族自治州",
        children: [
          {
            value: "1",
            label: "共和县",
          },
          {
            value: "2",
            label: "同德县",
          },
          {
            value: "3",
            label: "贵德县",
          },
          {
            value: "4",
            label: "兴海县",
          },
          {
            value: "5",
            label: "贵南县",
          },
        ],
      },
      {
        value: "5",
        label: "果洛藏族自治州",
        children: [
          {
            value: "1",
            label: "玛沁县",
          },
          {
            value: "2",
            label: "班玛县",
          },
          {
            value: "3",
            label: "甘德县",
          },
          {
            value: "4",
            label: "达日县",
          },
          {
            value: "5",
            label: "久治县",
          },
          {
            value: "6",
            label: "玛多县",
          },
        ],
      },
      {
        value: "6",
        label: "玉树藏族自治州",
        children: [
          {
            value: "1",
            label: "玉树县",
          },
          {
            value: "2",
            label: "杂多县",
          },
          {
            value: "3",
            label: "称多县",
          },
          {
            value: "4",
            label: "治多县",
          },
          {
            value: "5",
            label: "囊谦县",
          },
          {
            value: "6",
            label: "曲麻莱县",
          },
        ],
      },
      {
        value: "7",
        label: "海西蒙古族藏族自治州",
        children: [
          {
            value: "1",
            label: "格尔木市",
          },
          {
            value: "2",
            label: "德令哈市",
          },
          {
            value: "3",
            label: "乌兰县",
          },
          {
            value: "4",
            label: "都兰县",
          },
          {
            value: "5",
            label: "天峻县",
          },
        ],
      },
    ],
  },
  {
    value: "R",
    label: "台湾",
    children: [
      {
        value: "0",
        label: "台北",
        children: [
          {
            value: "1",
            label: "松山區",
          },
          {
            value: "2",
            label: "信義區",
          },
          {
            value: "3",
            label: "大安區",
          },
          {
            value: "4",
            label: "中山區",
          },
          {
            value: "5",
            label: "中正區",
          },
          {
            value: "6",
            label: "大同區",
          },
          {
            value: "7",
            label: "萬華區",
          },
          {
            value: "8",
            label: "文山區",
          },
          {
            value: "9",
            label: "南港區",
          },
          {
            value: "A",
            label: "內湖區",
          },
          {
            value: "B",
            label: "士林區",
          },
          {
            value: "C",
            label: "北投區",
          },
        ],
      },
      {
        value: "1",
        label: "高雄",
        children: [
          {
            value: "1",
            label: "鹽埕區",
          },
          {
            value: "2",
            label: "鼓山區",
          },
          {
            value: "3",
            label: "左營區",
          },
          {
            value: "4",
            label: "楠梓區",
          },
          {
            value: "5",
            label: "三民區",
          },
          {
            value: "6",
            label: "新興區",
          },
          {
            value: "7",
            label: "前金區",
          },
          {
            value: "8",
            label: "苓雅區",
          },
          {
            value: "9",
            label: "前鎮區",
          },
          {
            value: "A",
            label: "旗津區",
          },
          {
            value: "B",
            label: "小港區",
          },
        ],
      },
      {
        value: "2",
        label: "基隆",
        children: [
          {
            value: "1",
            label: "中正區",
          },
          {
            value: "2",
            label: "七堵區",
          },
          {
            value: "3",
            label: "暖暖區",
          },
          {
            value: "4",
            label: "仁愛區",
          },
          {
            value: "5",
            label: "中山區",
          },
          {
            value: "6",
            label: "安樂區",
          },
          {
            value: "7",
            label: "信義區",
          },
        ],
      },
      {
        value: "3",
        label: "台中",
        children: [
          {
            value: "1",
            label: "中區",
          },
          {
            value: "2",
            label: "東區",
          },
          {
            value: "3",
            label: "西區",
          },
          {
            value: "4",
            label: "南區",
          },
          {
            value: "5",
            label: "北區",
          },
          {
            value: "6",
            label: "西屯區",
          },
          {
            value: "7",
            label: "南屯區",
          },
          {
            value: "8",
            label: "北屯區",
          },
        ],
      },
      {
        value: "4",
        label: "台南",
        children: [
          {
            value: "1",
            label: "東區",
          },
          {
            value: "2",
            label: "南區",
          },
          {
            value: "3",
            label: "北區",
          },
          {
            value: "4",
            label: "安南區",
          },
          {
            value: "5",
            label: "安平區",
          },
          {
            value: "6",
            label: "中西區",
          },
        ],
      },
      {
        value: "5",
        label: "新竹",
        children: [
          {
            value: "1",
            label: "東區",
          },
          {
            value: "2",
            label: "北區",
          },
          {
            value: "3",
            label: "香山區",
          },
        ],
      },
      {
        value: "6",
        label: "嘉义",
        children: [
          {
            value: "1",
            label: "東區",
          },
          {
            value: "2",
            label: "西區",
          },
        ],
      },
      {
        value: "7",
        label: "台北县",
        children: [
          {
            value: "1",
            label: "板橋市",
          },
          {
            value: "2",
            label: "三重市",
          },
          {
            value: "3",
            label: "中和市",
          },
          {
            value: "4",
            label: "永和市",
          },
          {
            value: "5",
            label: "新莊市",
          },
          {
            value: "6",
            label: "新店市",
          },
          {
            value: "7",
            label: "樹林市",
          },
          {
            value: "8",
            label: "汐止市",
          },
          {
            value: "9",
            label: "土城市",
          },
          {
            value: "A",
            label: "蘆洲市",
          },
          {
            value: "B",
            label: "鶯歌鎮",
          },
          {
            value: "C",
            label: "三峽鎮",
          },
          {
            value: "D",
            label: "淡水鎮",
          },
          {
            value: "E",
            label: "瑞芳鎮",
          },
          {
            value: "F",
            label: "五股鄉",
          },
          {
            value: "G",
            label: "泰山鄉",
          },
          {
            value: "H",
            label: "林口鄉",
          },
          {
            value: "I",
            label: "深坑鄉",
          },
          {
            value: "J",
            label: "石碇鄉",
          },
          {
            value: "K",
            label: "坪林鄉",
          },
          {
            value: "L",
            label: "三芝鄉",
          },
          {
            value: "M",
            label: "石門鄉",
          },
          {
            value: "N",
            label: "八里鄉",
          },
          {
            value: "O",
            label: "平溪鄉",
          },
          {
            value: "P",
            label: "雙溪鄉",
          },
          {
            value: "Q",
            label: "貢寮鄉",
          },
          {
            value: "R",
            label: "金山鄉",
          },
          {
            value: "S",
            label: "萬里鄉",
          },
          {
            value: "T",
            label: "烏來鄉",
          },
        ],
      },
      {
        value: "8",
        label: "宜兰县",
        children: [
          {
            value: "1",
            label: "宜蘭市",
          },
          {
            value: "2",
            label: "羅東鎮",
          },
          {
            value: "3",
            label: "蘇澳鎮",
          },
          {
            value: "4",
            label: "頭城鎮",
          },
          {
            value: "5",
            label: "礁溪鄉",
          },
          {
            value: "6",
            label: "壯圍鄉",
          },
          {
            value: "7",
            label: "員山鄉",
          },
          {
            value: "8",
            label: "冬山鄉",
          },
          {
            value: "9",
            label: "五結鄉",
          },
          {
            value: "A",
            label: "三星鄉",
          },
          {
            value: "B",
            label: "大同鄉",
          },
        ],
      },
      {
        value: "9",
        label: "桃园县",
        children: [
          {
            value: "1",
            label: "桃園市",
          },
          {
            value: "2",
            label: "中壢市",
          },
          {
            value: "3",
            label: "八德市",
          },
          {
            value: "4",
            label: "平鎮市",
          },
          {
            value: "5",
            label: "大溪鎮",
          },
          {
            value: "6",
            label: "楊梅鎮",
          },
          {
            value: "7",
            label: "蘆竹鄉",
          },
          {
            value: "8",
            label: "大園鄉",
          },
          {
            value: "9",
            label: "龜山鄉",
          },
          {
            value: "A",
            label: "龍潭鄉",
          },
          {
            value: "B",
            label: "新屋鄉",
          },
          {
            value: "C",
            label: "觀音鄉",
          },
          {
            value: "D",
            label: "復興鄉",
          },
        ],
      },
      {
        value: "A",
        label: "新竹县",
        children: [
          {
            value: "1",
            label: "竹北市",
          },
          {
            value: "2",
            label: "竹東鎮",
          },
          {
            value: "3",
            label: "新埔鎮",
          },
          {
            value: "4",
            label: "關西鎮",
          },
          {
            value: "5",
            label: "湖口鄉",
          },
          {
            value: "6",
            label: "新豐鄉",
          },
          {
            value: "7",
            label: "芎林鄉",
          },
          {
            value: "8",
            label: "橫山鄉",
          },
          {
            value: "9",
            label: "北埔鄉",
          },
          {
            value: "A",
            label: "寶山鄉",
          },
          {
            value: "B",
            label: "峨眉鄉",
          },
          {
            value: "C",
            label: "尖石鄉",
          },
          {
            value: "D",
            label: "五峰鄉",
          },
        ],
      },
      {
        value: "B",
        label: "苗栗县",
        children: [
          {
            value: "1",
            label: "苗栗市",
          },
          {
            value: "2",
            label: "苑裡鎮",
          },
          {
            value: "3",
            label: "通霄鎮",
          },
          {
            value: "4",
            label: "竹南鎮",
          },
          {
            value: "5",
            label: "頭份鎮",
          },
          {
            value: "6",
            label: "後龍鎮",
          },
          {
            value: "7",
            label: "卓蘭鎮",
          },
          {
            value: "8",
            label: "大湖鄉",
          },
          {
            value: "9",
            label: "公館鄉",
          },
          {
            value: "A",
            label: "銅鑼鄉",
          },
          {
            value: "B",
            label: "南庄鄉",
          },
          {
            value: "C",
            label: "頭屋鄉",
          },
          {
            value: "D",
            label: "三義鄉",
          },
          {
            value: "E",
            label: "西湖鄉",
          },
          {
            value: "F",
            label: "造橋鄉",
          },
          {
            value: "G",
            label: "三灣鄉",
          },
          {
            value: "H",
            label: "獅潭鄉",
          },
          {
            value: "I",
            label: "泰安鄉",
          },
        ],
      },
      {
        value: "C",
        label: "台中县",
        children: [
          {
            value: "1",
            label: "豐原市",
          },
          {
            value: "2",
            label: "太平市",
          },
          {
            value: "3",
            label: "大里市",
          },
          {
            value: "4",
            label: "東勢鎮",
          },
          {
            value: "5",
            label: "大甲鎮",
          },
          {
            value: "6",
            label: "清水鎮",
          },
          {
            value: "7",
            label: "沙鹿鎮",
          },
          {
            value: "8",
            label: "梧棲鎮",
          },
          {
            value: "9",
            label: "后里鄉",
          },
          {
            value: "A",
            label: "神岡鄉",
          },
          {
            value: "B",
            label: "潭子鄉",
          },
          {
            value: "C",
            label: "大雅鄉",
          },
          {
            value: "D",
            label: "新社鄉",
          },
          {
            value: "E",
            label: "石岡鄉",
          },
          {
            value: "F",
            label: "外埔鄉",
          },
          {
            value: "G",
            label: "大安鄉",
          },
          {
            value: "H",
            label: "烏日鄉",
          },
          {
            value: "I",
            label: "大肚鄉",
          },
          {
            value: "J",
            label: "龍井鄉",
          },
          {
            value: "K",
            label: "霧峰鄉",
          },
          {
            value: "L",
            label: "和平鄉",
          },
        ],
      },
      {
        value: "D",
        label: "彰化县",
        children: [
          {
            value: "1",
            label: "彰化市",
          },
          {
            value: "2",
            label: "鹿港鎮",
          },
          {
            value: "3",
            label: "和美鎮",
          },
          {
            value: "4",
            label: "員林鎮",
          },
          {
            value: "5",
            label: "溪湖鎮",
          },
          {
            value: "6",
            label: "田中鎮",
          },
          {
            value: "7",
            label: "北斗鎮",
          },
          {
            value: "8",
            label: "二林鎮",
          },
          {
            value: "9",
            label: "線西鄉",
          },
          {
            value: "A",
            label: "伸港鄉",
          },
          {
            value: "B",
            label: "福興鄉",
          },
          {
            value: "C",
            label: "秀水鄉",
          },
          {
            value: "D",
            label: "花壇鄉",
          },
          {
            value: "E",
            label: "芬園鄉",
          },
          {
            value: "F",
            label: "大村鄉",
          },
          {
            value: "G",
            label: "埔鹽鄉",
          },
          {
            value: "H",
            label: "埔心鄉",
          },
          {
            value: "I",
            label: "永靖鄉",
          },
          {
            value: "J",
            label: "社頭鄉",
          },
          {
            value: "K",
            label: "二水鄉",
          },
          {
            value: "L",
            label: "田尾鄉",
          },
          {
            value: "M",
            label: "埤頭鄉",
          },
          {
            value: "N",
            label: "芳苑鄉",
          },
          {
            value: "O",
            label: "大城鄉",
          },
          {
            value: "P",
            label: "竹塘鄉",
          },
          {
            value: "Q",
            label: "溪州鄉",
          },
        ],
      },
      {
        value: "E",
        label: "南投县",
        children: [
          {
            value: "1",
            label: "南投市",
          },
          {
            value: "2",
            label: "埔里鎮",
          },
          {
            value: "3",
            label: "草屯鎮",
          },
          {
            value: "4",
            label: "竹山鎮",
          },
          {
            value: "5",
            label: "集集鎮",
          },
          {
            value: "6",
            label: "名間鄉",
          },
          {
            value: "7",
            label: "鹿谷鄉",
          },
          {
            value: "8",
            label: "中寮鄉",
          },
          {
            value: "9",
            label: "魚池鄉",
          },
          {
            value: "A",
            label: "國姓鄉",
          },
          {
            value: "B",
            label: "水里鄉",
          },
          {
            value: "C",
            label: "信義鄉",
          },
          {
            value: "D",
            label: "仁愛鄉",
          },
        ],
      },
      {
        value: "F",
        label: "云林县",
        children: [
          {
            value: "1",
            label: "斗六市",
          },
          {
            value: "2",
            label: "斗南鎮",
          },
          {
            value: "3",
            label: "虎尾鎮",
          },
          {
            value: "4",
            label: "西螺鎮",
          },
          {
            value: "5",
            label: "土庫鎮",
          },
          {
            value: "6",
            label: "北港鎮",
          },
          {
            value: "7",
            label: "古坑鄉",
          },
          {
            value: "8",
            label: "大埤鄉",
          },
          {
            value: "9",
            label: "莿桐鄉",
          },
          {
            value: "A",
            label: "林內鄉",
          },
          {
            value: "B",
            label: "二崙鄉",
          },
          {
            value: "C",
            label: "崙背鄉",
          },
          {
            value: "D",
            label: "麥寮鄉",
          },
          {
            value: "E",
            label: "東勢鄉",
          },
          {
            value: "F",
            label: "褒忠鄉",
          },
          {
            value: "G",
            label: "台西鄉",
          },
          {
            value: "H",
            label: "元長鄉",
          },
          {
            value: "I",
            label: "四湖鄉",
          },
          {
            value: "J",
            label: "口湖鄉",
          },
          {
            value: "K",
            label: "水林鄉",
          },
        ],
      },
      {
        value: "G",
        label: "嘉义县",
        children: [
          {
            value: "1",
            label: "太保市",
          },
          {
            value: "2",
            label: "朴子市",
          },
          {
            value: "3",
            label: "布袋鎮",
          },
          {
            value: "4",
            label: "大林鎮",
          },
          {
            value: "5",
            label: "民雄鄉",
          },
          {
            value: "6",
            label: "溪口鄉",
          },
          {
            value: "7",
            label: "新港鄉",
          },
          {
            value: "8",
            label: "六腳鄉",
          },
          {
            value: "9",
            label: "東石鄉",
          },
          {
            value: "A",
            label: "義竹鄉",
          },
          {
            value: "B",
            label: "水上鄉",
          },
          {
            value: "C",
            label: "中埔鄉",
          },
          {
            value: "D",
            label: "竹崎鄉",
          },
          {
            value: "E",
            label: "梅山鄉",
          },
          {
            value: "F",
            label: "番路鄉",
          },
          {
            value: "G",
            label: "大埔鄉",
          },
          {
            value: "H",
            label: "阿里山鄉",
          },
          {
            value: "I",
            label: "鹿草鄉",
          },
        ],
      },
      {
        value: "H",
        label: "台南县",
        children: [
          {
            value: "1",
            label: "新營市",
          },
          {
            value: "2",
            label: "永康市",
          },
          {
            value: "3",
            label: "鹽水鎮",
          },
          {
            value: "4",
            label: "白河鎮",
          },
          {
            value: "5",
            label: "麻豆鎮",
          },
          {
            value: "6",
            label: "新化鎮",
          },
          {
            value: "7",
            label: "善化鎮",
          },
          {
            value: "8",
            label: "佳里鎮",
          },
          {
            value: "9",
            label: "學甲鎮",
          },
          {
            value: "A",
            label: "柳營鄉",
          },
          {
            value: "B",
            label: "後壁鄉",
          },
          {
            value: "C",
            label: "東山鄉",
          },
          {
            value: "D",
            label: "下營鄉",
          },
          {
            value: "E",
            label: "六甲鄉",
          },
          {
            value: "F",
            label: "官田鄉",
          },
          {
            value: "G",
            label: "大內鄉",
          },
          {
            value: "H",
            label: "西港鄉",
          },
          {
            value: "I",
            label: "七股鄉",
          },
          {
            value: "J",
            label: "將軍鄉",
          },
          {
            value: "K",
            label: "北門鄉",
          },
          {
            value: "L",
            label: "新市鄉",
          },
          {
            value: "M",
            label: "安定鄉",
          },
          {
            value: "N",
            label: "山上鄉",
          },
          {
            value: "O",
            label: "玉井鄉",
          },
          {
            value: "P",
            label: "楠西鄉",
          },
          {
            value: "Q",
            label: "南化鄉",
          },
          {
            value: "R",
            label: "左鎮鄉",
          },
          {
            value: "S",
            label: "仁德鄉",
          },
          {
            value: "T",
            label: "歸仁鄉",
          },
          {
            value: "U",
            label: "關廟鄉",
          },
          {
            value: "V",
            label: "龍崎鄉",
          },
        ],
      },
      {
        value: "I",
        label: "高雄县",
        children: [
          {
            value: "1",
            label: "鳳山市",
          },
          {
            value: "2",
            label: "岡山鎮",
          },
          {
            value: "3",
            label: "旗山鎮",
          },
          {
            value: "4",
            label: "美濃鎮",
          },
          {
            value: "5",
            label: "林園鄉",
          },
          {
            value: "6",
            label: "大寮鄉",
          },
          {
            value: "7",
            label: "大樹鄉",
          },
          {
            value: "8",
            label: "大社鄉",
          },
          {
            value: "9",
            label: "仁武鄉",
          },
          {
            value: "A",
            label: "鳥松鄉",
          },
          {
            value: "B",
            label: "橋頭鄉",
          },
          {
            value: "C",
            label: "燕巢鄉",
          },
          {
            value: "D",
            label: "田寮鄉",
          },
          {
            value: "E",
            label: "阿蓮鄉",
          },
          {
            value: "F",
            label: "路竹鄉",
          },
          {
            value: "G",
            label: "湖內鄉",
          },
          {
            value: "H",
            label: "茄萣鄉",
          },
          {
            value: "I",
            label: "永安鄉",
          },
          {
            value: "J",
            label: "彌陀鄉",
          },
          {
            value: "K",
            label: "梓官鄉",
          },
          {
            value: "L",
            label: "六龜鄉",
          },
          {
            value: "M",
            label: "甲仙鄉",
          },
          {
            value: "N",
            label: "杉林鄉",
          },
          {
            value: "O",
            label: "內門鄉",
          },
          {
            value: "P",
            label: "茂林鄉",
          },
          {
            value: "Q",
            label: "桃源鄉",
          },
          {
            value: "R",
            label: "三民鄉",
          },
        ],
      },
      {
        value: "J",
        label: "屏东县",
        children: [
          {
            value: "1",
            label: "屏東市",
          },
          {
            value: "2",
            label: "潮州鎮",
          },
          {
            value: "3",
            label: "東港鎮",
          },
          {
            value: "4",
            label: "恆春鎮",
          },
          {
            value: "5",
            label: "萬丹鄉",
          },
          {
            value: "6",
            label: "長治鄉",
          },
          {
            value: "7",
            label: "麟洛鄉",
          },
          {
            value: "8",
            label: "九如鄉",
          },
          {
            value: "9",
            label: "里港鄉",
          },
          {
            value: "A",
            label: "鹽埔鄉",
          },
          {
            value: "B",
            label: "高樹鄉",
          },
          {
            value: "C",
            label: "萬巒鄉",
          },
          {
            value: "D",
            label: "內埔鄉",
          },
          {
            value: "E",
            label: "竹田鄉",
          },
          {
            value: "F",
            label: "新埤鄉",
          },
          {
            value: "G",
            label: "枋寮鄉",
          },
          {
            value: "H",
            label: "新園鄉",
          },
          {
            value: "I",
            label: "崁頂鄉",
          },
          {
            value: "J",
            label: "林邊鄉",
          },
          {
            value: "K",
            label: "南州鄉",
          },
          {
            value: "L",
            label: "佳冬鄉",
          },
          {
            value: "M",
            label: "琉球鄉",
          },
          {
            value: "N",
            label: "車城鄉",
          },
          {
            value: "O",
            label: "滿州鄉",
          },
          {
            value: "P",
            label: "枋山鄉",
          },
          {
            value: "Q",
            label: "三地門鄉",
          },
          {
            value: "R",
            label: "霧臺鄉",
          },
          {
            value: "S",
            label: "瑪家鄉",
          },
          {
            value: "T",
            label: "泰武鄉",
          },
          {
            value: "U",
            label: "來義鄉",
          },
          {
            value: "V",
            label: "春日鄉",
          },
          {
            value: "W",
            label: "獅子鄉",
          },
          {
            value: "X",
            label: "牡丹鄉",
          },
        ],
      },
      {
        value: "K",
        label: "台东县",
        children: [
          {
            value: "1",
            label: "臺東市",
          },
          {
            value: "2",
            label: "成功鎮",
          },
          {
            value: "3",
            label: "關山鎮",
          },
          {
            value: "4",
            label: "卑南鄉",
          },
          {
            value: "5",
            label: "鹿野鄉",
          },
          {
            value: "6",
            label: "池上鄉",
          },
          {
            value: "7",
            label: "東河鄉",
          },
          {
            value: "8",
            label: "長濱鄉",
          },
          {
            value: "9",
            label: "太麻里鄉",
          },
          {
            value: "A",
            label: "大武鄉",
          },
          {
            value: "B",
            label: "綠島鄉",
          },
          {
            value: "C",
            label: "海端鄉",
          },
          {
            value: "D",
            label: "延平鄉",
          },
          {
            value: "E",
            label: "金峰鄉",
          },
          {
            value: "F",
            label: "達仁鄉",
          },
          {
            value: "G",
            label: "蘭嶼鄉",
          },
        ],
      },
      {
        value: "L",
        label: "花莲县",
        children: [
          {
            value: "1",
            label: "花蓮市",
          },
          {
            value: "2",
            label: "鳳林鎮",
          },
          {
            value: "3",
            label: "玉里鎮",
          },
          {
            value: "4",
            label: "新城鄉",
          },
          {
            value: "5",
            label: "吉安鄉",
          },
          {
            value: "6",
            label: "壽豐鄉",
          },
          {
            value: "7",
            label: "光復鄉",
          },
          {
            value: "8",
            label: "豐濱鄉",
          },
          {
            value: "9",
            label: "瑞穗鄉",
          },
          {
            value: "A",
            label: "富里鄉",
          },
          {
            value: "B",
            label: "秀林鄉",
          },
          {
            value: "C",
            label: "萬榮鄉",
          },
          {
            value: "D",
            label: "卓溪鄉",
          },
        ],
      },
      {
        value: "M",
        label: "澎湖县",
        children: [
          {
            value: "1",
            label: "馬公市",
          },
          {
            value: "2",
            label: "湖西鄉",
          },
          {
            value: "3",
            label: "白沙鄉",
          },
          {
            value: "4",
            label: "西嶼鄉",
          },
          {
            value: "5",
            label: "望安鄉",
          },
          {
            value: "6",
            label: "七美鄉",
          },
        ],
      },
    ],
  },
  {
    value: "S",
    label: "内蒙古",
    children: [
      {
        value: "0",
        label: "呼和浩特市",
        children: [
          {
            value: "1",
            label: "呼和浩特市",
          },
          {
            value: "2",
            label: "新城区",
          },
          {
            value: "3",
            label: "回民区",
          },
          {
            value: "4",
            label: "玉泉区",
          },
          {
            value: "5",
            label: "赛罕区",
          },
          {
            value: "6",
            label: "土默特左旗",
          },
          {
            value: "7",
            label: "托克托县",
          },
          {
            value: "8",
            label: "和林格尔县",
          },
          {
            value: "9",
            label: "清水河县",
          },
          {
            value: "A",
            label: "武川县",
          },
        ],
      },
      {
        value: "1",
        label: "包头市",
        children: [
          {
            value: "1",
            label: "包头市",
          },
          {
            value: "2",
            label: "东河区",
          },
          {
            value: "3",
            label: "昆都仑区",
          },
          {
            value: "4",
            label: "青山区",
          },
          {
            value: "5",
            label: "石拐区",
          },
          {
            value: "6",
            label: "白云矿区",
          },
          {
            value: "7",
            label: "九原区",
          },
          {
            value: "8",
            label: "土默特右旗",
          },
          {
            value: "9",
            label: "固阳县",
          },
          {
            value: "A",
            label: "达尔罕茂明安联合旗",
          },
        ],
      },
      {
        value: "2",
        label: "乌海市",
        children: [
          {
            value: "1",
            label: "乌海市",
          },
          {
            value: "2",
            label: "海勃湾区",
          },
          {
            value: "3",
            label: "海南区",
          },
          {
            value: "4",
            label: "乌达区",
          },
        ],
      },
      {
        value: "3",
        label: "赤峰市",
        children: [
          {
            value: "1",
            label: "赤峰市",
          },
          {
            value: "2",
            label: "红山区",
          },
          {
            value: "3",
            label: "元宝山区",
          },
          {
            value: "4",
            label: "松山区",
          },
          {
            value: "5",
            label: "阿鲁科尔沁旗",
          },
          {
            value: "6",
            label: "巴林左旗",
          },
          {
            value: "7",
            label: "巴林右旗",
          },
          {
            value: "8",
            label: "林西县",
          },
          {
            value: "9",
            label: "克什克腾旗",
          },
          {
            value: "A",
            label: "翁牛特旗",
          },
          {
            value: "B",
            label: "喀喇沁旗",
          },
          {
            value: "C",
            label: "宁城县",
          },
          {
            value: "D",
            label: "敖汉旗",
          },
        ],
      },
      {
        value: "4",
        label: "通辽市",
        children: [
          {
            value: "1",
            label: "通辽市",
          },
          {
            value: "2",
            label: "科尔沁区",
          },
          {
            value: "3",
            label: "科尔沁左翼中旗",
          },
          {
            value: "4",
            label: "科尔沁左翼后旗",
          },
          {
            value: "5",
            label: "开鲁县",
          },
          {
            value: "6",
            label: "库伦旗",
          },
          {
            value: "7",
            label: "奈曼旗",
          },
          {
            value: "8",
            label: "扎鲁特旗",
          },
          {
            value: "9",
            label: "霍林郭勒市",
          },
        ],
      },
      {
        value: "5",
        label: "鄂尔多斯市",
        children: [
          {
            value: "1",
            label: "东胜区",
          },
          {
            value: "2",
            label: "达拉特旗",
          },
          {
            value: "3",
            label: "准格尔旗",
          },
          {
            value: "4",
            label: "鄂托克前旗",
          },
          {
            value: "5",
            label: "鄂托克旗",
          },
          {
            value: "6",
            label: "杭锦旗",
          },
          {
            value: "7",
            label: "乌审旗",
          },
          {
            value: "8",
            label: "伊金霍洛旗",
          },
        ],
      },
      {
        value: "6",
        label: "呼伦贝尔市",
        children: [
          {
            value: "1",
            label: "呼伦贝尔市",
          },
          {
            value: "2",
            label: "海拉尔区",
          },
          {
            value: "3",
            label: "阿荣旗",
          },
          {
            value: "4",
            label: "莫力达瓦达斡尔族自治旗",
          },
          {
            value: "5",
            label: "鄂伦春自治旗",
          },
          {
            value: "6",
            label: "鄂温克族自治旗",
          },
          {
            value: "7",
            label: "陈巴尔虎旗",
          },
          {
            value: "8",
            label: "新巴尔虎左旗",
          },
          {
            value: "9",
            label: "新巴尔虎右旗",
          },
          {
            value: "A",
            label: "满洲里市",
          },
          {
            value: "B",
            label: "牙克石市",
          },
          {
            value: "C",
            label: "扎兰屯市",
          },
          {
            value: "D",
            label: "额尔古纳市",
          },
          {
            value: "E",
            label: "根河市",
          },
        ],
      },
      {
        value: "7",
        label: "巴彦淖尔市",
        children: [
          {
            value: "1",
            label: "巴彦淖尔市",
          },
          {
            value: "2",
            label: "临河区",
          },
          {
            value: "3",
            label: "五原县",
          },
          {
            value: "4",
            label: "磴口县",
          },
          {
            value: "5",
            label: "乌拉特前旗",
          },
          {
            value: "6",
            label: "乌拉特中旗",
          },
          {
            value: "7",
            label: "乌拉特后旗",
          },
          {
            value: "8",
            label: "杭锦后旗",
          },
        ],
      },
      {
        value: "8",
        label: "乌兰察布市",
        children: [
          {
            value: "1",
            label: "乌兰察布市",
          },
          {
            value: "2",
            label: "集宁区",
          },
          {
            value: "3",
            label: "卓资县",
          },
          {
            value: "4",
            label: "化德县",
          },
          {
            value: "5",
            label: "商都县",
          },
          {
            value: "6",
            label: "兴和县",
          },
          {
            value: "7",
            label: "凉城县",
          },
          {
            value: "8",
            label: "察哈尔右翼前旗",
          },
          {
            value: "9",
            label: "察哈尔右翼中旗",
          },
          {
            value: "A",
            label: "察哈尔右翼后旗",
          },
          {
            value: "B",
            label: "四子王旗",
          },
          {
            value: "C",
            label: "丰镇市",
          },
        ],
      },
      {
        value: "9",
        label: "兴安盟",
        children: [
          {
            value: "1",
            label: "乌兰浩特市",
          },
          {
            value: "2",
            label: "阿尔山市",
          },
          {
            value: "3",
            label: "科尔沁右翼前旗",
          },
          {
            value: "4",
            label: "科尔沁右翼中旗",
          },
          {
            value: "5",
            label: "扎赉特旗",
          },
          {
            value: "6",
            label: "突泉县",
          },
        ],
      },
      {
        value: "A",
        label: "锡林郭勒盟",
        children: [
          {
            value: "1",
            label: "二连浩特市",
          },
          {
            value: "2",
            label: "锡林浩特市",
          },
          {
            value: "3",
            label: "阿巴嘎旗",
          },
          {
            value: "4",
            label: "苏尼特左旗",
          },
          {
            value: "5",
            label: "苏尼特右旗",
          },
          {
            value: "6",
            label: "东乌珠穆沁旗",
          },
          {
            value: "7",
            label: "西乌珠穆沁旗",
          },
          {
            value: "8",
            label: "太仆寺旗",
          },
          {
            value: "9",
            label: "镶黄旗",
          },
          {
            value: "A",
            label: "正镶白旗",
          },
          {
            value: "B",
            label: "正蓝旗",
          },
          {
            value: "C",
            label: "多伦县",
          },
        ],
      },
      {
        value: "B",
        label: "阿拉善盟",
        children: [
          {
            value: "1",
            label: "阿拉善左旗",
          },
          {
            value: "2",
            label: "阿拉善右旗",
          },
          {
            value: "3",
            label: "额济纳旗",
          },
        ],
      },
    ],
  },
  {
    value: "T",
    label: "广西",
    children: [
      {
        value: "1",
        label: "南宁市",
        children: [
          {
            value: "1",
            label: "兴宁区",
          },
          {
            value: "2",
            label: "青秀区",
          },
          {
            value: "3",
            label: "江南区",
          },
          {
            value: "4",
            label: "西乡塘区",
          },
          {
            value: "5",
            label: "良庆区",
          },
          {
            value: "6",
            label: "邕宁区",
          },
          {
            value: "7",
            label: "武鸣县",
          },
          {
            value: "8",
            label: "隆安县",
          },
          {
            value: "9",
            label: "马山县",
          },
          {
            value: "A",
            label: "上林县",
          },
          {
            value: "B",
            label: "宾阳县",
          },
          {
            value: "C",
            label: "横县",
          },
        ],
      },
      {
        value: "2",
        label: "柳州市",
        children: [
          {
            value: "1",
            label: "城中区",
          },
          {
            value: "2",
            label: "鱼峰区",
          },
          {
            value: "3",
            label: "柳南区",
          },
          {
            value: "4",
            label: "柳北区",
          },
          {
            value: "5",
            label: "柳江县",
          },
          {
            value: "6",
            label: "柳城县",
          },
          {
            value: "7",
            label: "鹿寨县",
          },
          {
            value: "8",
            label: "融安县",
          },
          {
            value: "9",
            label: "融水苗族自治县",
          },
          {
            value: "A",
            label: "三江侗族自治县",
          },
        ],
      },
      {
        value: "3",
        label: "桂林市",
        children: [
          {
            value: "1",
            label: "秀峰区",
          },
          {
            value: "2",
            label: "叠彩区",
          },
          {
            value: "3",
            label: "象山区",
          },
          {
            value: "4",
            label: "七星区",
          },
          {
            value: "5",
            label: "雁山区",
          },
          {
            value: "6",
            label: "阳朔县",
          },
          {
            value: "7",
            label: "临桂县",
          },
          {
            value: "8",
            label: "灵川县",
          },
          {
            value: "9",
            label: "全州县",
          },
          {
            value: "A",
            label: "兴安县",
          },
          {
            value: "B",
            label: "永福县",
          },
          {
            value: "C",
            label: "灌阳县",
          },
          {
            value: "D",
            label: "龙胜各族自治县",
          },
          {
            value: "E",
            label: "资源县",
          },
          {
            value: "F",
            label: "平乐县",
          },
          {
            value: "G",
            label: "荔蒲县",
          },
          {
            value: "H",
            label: "恭城瑶族自治县",
          },
        ],
      },
      {
        value: "4",
        label: "梧州市",
        children: [
          {
            value: "1",
            label: "万秀区",
          },
          {
            value: "2",
            label: "蝶山区",
          },
          {
            value: "3",
            label: "长洲区",
          },
          {
            value: "4",
            label: "苍梧县",
          },
          {
            value: "5",
            label: "藤县",
          },
          {
            value: "6",
            label: "蒙山县",
          },
          {
            value: "7",
            label: "岑溪市",
          },
        ],
      },
      {
        value: "5",
        label: "北海市",
        children: [
          {
            value: "1",
            label: "海城区",
          },
          {
            value: "2",
            label: "银海区",
          },
          {
            value: "3",
            label: "铁山港区",
          },
          {
            value: "4",
            label: "合浦县",
          },
          {
            value: "6",
            label: "北海市",
          },
        ],
      },
      {
        value: "6",
        label: "防城港市",
        children: [
          {
            value: "1",
            label: "港口区",
          },
          {
            value: "2",
            label: "防城区",
          },
          {
            value: "3",
            label: "上思县",
          },
          {
            value: "4",
            label: "东兴市",
          },
        ],
      },
      {
        value: "7",
        label: "钦州市",
        children: [
          {
            value: "1",
            label: "钦南区",
          },
          {
            value: "2",
            label: "钦北区",
          },
          {
            value: "3",
            label: "灵山县",
          },
          {
            value: "4",
            label: "浦北县",
          },
          {
            value: "5",
            label: "钦州市",
          },
        ],
      },
      {
        value: "8",
        label: "贵港市",
        children: [
          {
            value: "1",
            label: "港北区",
          },
          {
            value: "2",
            label: "港南区",
          },
          {
            value: "3",
            label: "覃塘区",
          },
          {
            value: "4",
            label: "平南县",
          },
          {
            value: "5",
            label: "桂平市",
          },
        ],
      },
      {
        value: "9",
        label: "玉林市",
        children: [
          {
            value: "1",
            label: "玉州区",
          },
          {
            value: "2",
            label: "容县",
          },
          {
            value: "3",
            label: "陆川县",
          },
          {
            value: "4",
            label: "博白县",
          },
          {
            value: "5",
            label: "兴业县",
          },
          {
            value: "6",
            label: "北流市",
          },
        ],
      },
      {
        value: "A",
        label: "百色市",
        children: [
          {
            value: "1",
            label: "右江区",
          },
          {
            value: "2",
            label: "田阳县",
          },
          {
            value: "3",
            label: "田东县",
          },
          {
            value: "4",
            label: "平果县",
          },
          {
            value: "5",
            label: "德保县",
          },
          {
            value: "6",
            label: "靖西县",
          },
          {
            value: "7",
            label: "那坡县",
          },
          {
            value: "8",
            label: "凌云县",
          },
          {
            value: "9",
            label: "乐业县",
          },
          {
            value: "A",
            label: "田林县",
          },
          {
            value: "B",
            label: "西林县",
          },
          {
            value: "C",
            label: "隆林各族自治县",
          },
        ],
      },
      {
        value: "B",
        label: "贺州市",
        children: [
          {
            value: "2",
            label: "八步区",
          },
          {
            value: "3",
            label: "昭平县",
          },
          {
            value: "4",
            label: "钟山县",
          },
          {
            value: "5",
            label: "富川瑶族自治县",
          },
        ],
      },
      {
        value: "C",
        label: "市辖区",
        children: [
          {
            value: "1",
            label: "金城江区",
          },
          {
            value: "2",
            label: "南丹县",
          },
          {
            value: "3",
            label: "天峨县",
          },
          {
            value: "4",
            label: "凤山县",
          },
          {
            value: "5",
            label: "东兰县",
          },
          {
            value: "6",
            label: "罗城仫佬族自治县",
          },
          {
            value: "7",
            label: "环江毛南族自治县",
          },
          {
            value: "8",
            label: "巴马瑶族自治县",
          },
          {
            value: "9",
            label: "都安瑶族自治县",
          },
          {
            value: "A",
            label: "大化瑶族自治县",
          },
          {
            value: "B",
            label: "宜州市",
          },
        ],
      },
      {
        value: "D",
        label: "来宾市",
        children: [
          {
            value: "1",
            label: "兴宾区",
          },
          {
            value: "2",
            label: "忻城县",
          },
          {
            value: "3",
            label: "象州县",
          },
          {
            value: "4",
            label: "武宣县",
          },
          {
            value: "5",
            label: "金秀瑶族自治县",
          },
          {
            value: "6",
            label: "合山市",
          },
        ],
      },
      {
        value: "E",
        label: "崇左市",
        children: [
          {
            value: "1",
            label: "江洲区",
          },
          {
            value: "2",
            label: "扶绥县",
          },
          {
            value: "3",
            label: "宁明县",
          },
          {
            value: "4",
            label: "龙州县",
          },
          {
            value: "5",
            label: "大新县",
          },
          {
            value: "6",
            label: "天等县",
          },
          {
            value: "7",
            label: "凭祥市",
          },
        ],
      },
    ],
  },
  {
    value: "U",
    label: "宁夏",
    children: [
      {
        value: "0",
        label: "银川市",
        children: [
          {
            value: "1",
            label: "兴庆区",
          },
          {
            value: "2",
            label: "西夏区",
          },
          {
            value: "3",
            label: "金凤区",
          },
          {
            value: "4",
            label: "永宁县",
          },
          {
            value: "5",
            label: "贺兰县",
          },
          {
            value: "6",
            label: "灵武市",
          },
        ],
      },
      {
        value: "1",
        label: "石嘴山市",
        children: [
          {
            value: "1",
            label: "大武口区",
          },
          {
            value: "2",
            label: "惠农区",
          },
          {
            value: "3",
            label: "平罗县",
          },
        ],
      },
      {
        value: "2",
        label: "吴忠市",
        children: [
          {
            value: "1",
            label: "利通区",
          },
          {
            value: "2",
            label: "盐池县",
          },
          {
            value: "3",
            label: "同心县",
          },
          {
            value: "4",
            label: "青铜峡市",
          },
        ],
      },
      {
        value: "3",
        label: "固原市",
        children: [
          {
            value: "1",
            label: "原州区",
          },
          {
            value: "2",
            label: "西吉县",
          },
          {
            value: "3",
            label: "隆德县",
          },
          {
            value: "4",
            label: "泾源县",
          },
          {
            value: "5",
            label: "彭阳县",
          },
        ],
      },
      {
        value: "4",
        label: "中卫市",
        children: [
          {
            value: "1",
            label: "沙坡头区",
          },
          {
            value: "2",
            label: "中宁县",
          },
          {
            value: "3",
            label: "海原县",
          },
        ],
      },
    ],
  },
  {
    value: "V",
    label: "新疆",
    children: [
      {
        value: "0",
        label: "乌鲁木齐市",
        children: [
          {
            value: "1",
            label: "天山区",
          },
          {
            value: "2",
            label: "沙依巴克区",
          },
          {
            value: "3",
            label: "新市区",
          },
          {
            value: "4",
            label: "水磨沟区",
          },
          {
            value: "5",
            label: "头屯河区",
          },
          {
            value: "6",
            label: "达坂城区",
          },
          {
            value: "7",
            label: "东山区",
          },
          {
            value: "8",
            label: "乌鲁木齐县",
          },
          {
            value: "9",
            label: "高新技术开发区",
          },
        ],
      },
      {
        value: "1",
        label: "克拉玛依市",
        children: [
          {
            value: "1",
            label: "独山子区",
          },
          {
            value: "2",
            label: "克拉玛依区",
          },
          {
            value: "3",
            label: "白碱滩区",
          },
          {
            value: "4",
            label: "乌尔禾区",
          },
        ],
      },
      {
        value: "2",
        label: "吐鲁番地区",
        children: [
          {
            value: "1",
            label: "吐鲁番市",
          },
          {
            value: "2",
            label: "鄯善县",
          },
          {
            value: "3",
            label: "托克逊县",
          },
        ],
      },
      {
        value: "3",
        label: "哈密地区",
        children: [
          {
            value: "1",
            label: "哈密市",
          },
          {
            value: "2",
            label: "巴里坤哈萨克自治县",
          },
          {
            value: "3",
            label: "伊吾县",
          },
        ],
      },
      {
        value: "4",
        label: "昌吉回族自治州",
        children: [
          {
            value: "1",
            label: "昌吉市",
          },
          {
            value: "2",
            label: "阜康市",
          },
          {
            value: "3",
            label: "米泉市",
          },
          {
            value: "4",
            label: "呼图壁县",
          },
          {
            value: "5",
            label: "玛纳斯县",
          },
          {
            value: "6",
            label: "奇台县",
          },
          {
            value: "7",
            label: "吉木萨尔县",
          },
          {
            value: "8",
            label: "木垒哈萨克自治县",
          },
        ],
      },
      {
        value: "5",
        label: "博尔塔拉蒙古自治州",
        children: [
          {
            value: "1",
            label: "博乐市",
          },
          {
            value: "2",
            label: "精河县",
          },
          {
            value: "3",
            label: "温泉县",
          },
        ],
      },
      {
        value: "6",
        label: "巴音郭楞蒙古自治州",
        children: [
          {
            value: "1",
            label: "库尔勒市",
          },
          {
            value: "2",
            label: "轮台县",
          },
          {
            value: "3",
            label: "尉犁县",
          },
          {
            value: "4",
            label: "若羌县",
          },
          {
            value: "5",
            label: "且末县",
          },
          {
            value: "6",
            label: "焉耆回族自治县",
          },
          {
            value: "7",
            label: "和静县",
          },
          {
            value: "8",
            label: "和硕县",
          },
          {
            value: "9",
            label: "博湖县",
          },
        ],
      },
      {
        value: "7",
        label: "阿克苏地区",
        children: [
          {
            value: "1",
            label: "阿克苏市",
          },
          {
            value: "2",
            label: "温宿县",
          },
          {
            value: "3",
            label: "库车县",
          },
          {
            value: "4",
            label: "沙雅县",
          },
          {
            value: "5",
            label: "新和县",
          },
          {
            value: "6",
            label: "拜城县",
          },
          {
            value: "7",
            label: "乌什县",
          },
          {
            value: "8",
            label: "阿瓦提县",
          },
          {
            value: "9",
            label: "柯坪县",
          },
        ],
      },
      {
        value: "8",
        label: "克孜勒苏柯尔克孜自治州",
        children: [
          {
            value: "1",
            label: "阿图什市",
          },
          {
            value: "2",
            label: "阿克陶县",
          },
          {
            value: "3",
            label: "阿合奇县",
          },
          {
            value: "4",
            label: "乌恰县",
          },
        ],
      },
      {
        value: "9",
        label: "喀什地区",
        children: [
          {
            value: "1",
            label: "喀什市",
          },
          {
            value: "2",
            label: "疏附县",
          },
          {
            value: "3",
            label: "疏勒县",
          },
          {
            value: "4",
            label: "英吉沙县",
          },
          {
            value: "5",
            label: "泽普县",
          },
          {
            value: "6",
            label: "莎车县",
          },
          {
            value: "7",
            label: "叶城县",
          },
          {
            value: "8",
            label: "麦盖提县",
          },
          {
            value: "9",
            label: "岳普湖县",
          },
          {
            value: "A",
            label: "伽师县",
          },
          {
            value: "B",
            label: "巴楚县",
          },
          {
            value: "C",
            label: "塔什库尔干塔吉克自治县",
          },
        ],
      },
      {
        value: "A",
        label: "和田地区",
        children: [
          {
            value: "1",
            label: "和田市",
          },
          {
            value: "2",
            label: "和田县",
          },
          {
            value: "3",
            label: "墨玉县",
          },
          {
            value: "4",
            label: "皮山县",
          },
          {
            value: "5",
            label: "洛浦县",
          },
          {
            value: "6",
            label: "策勒县",
          },
          {
            value: "7",
            label: "于田县",
          },
          {
            value: "8",
            label: "民丰县",
          },
        ],
      },
      {
        value: "B",
        label: "伊犁哈萨克自治州",
        children: [
          {
            value: "1",
            label: "伊宁市",
          },
          {
            value: "2",
            label: "奎屯市",
          },
          {
            value: "3",
            label: "伊宁县",
          },
          {
            value: "4",
            label: "察布查尔锡伯自治县",
          },
          {
            value: "5",
            label: "霍城县",
          },
          {
            value: "6",
            label: "巩留县",
          },
          {
            value: "7",
            label: "新源县",
          },
          {
            value: "8",
            label: "昭苏县",
          },
          {
            value: "9",
            label: "特克斯县",
          },
          {
            value: "A",
            label: "尼勒克县",
          },
        ],
      },
      {
        value: "C",
        label: "塔城地区",
        children: [
          {
            value: "1",
            label: "塔城市",
          },
          {
            value: "2",
            label: "乌苏市",
          },
          {
            value: "3",
            label: "额敏县",
          },
          {
            value: "4",
            label: "沙湾县",
          },
          {
            value: "5",
            label: "托里县",
          },
          {
            value: "6",
            label: "裕民县",
          },
          {
            value: "7",
            label: "和布克赛尔蒙古自治县",
          },
        ],
      },
      {
        value: "D",
        label: "阿勒泰地区",
        children: [
          {
            value: "1",
            label: "阿勒泰市",
          },
          {
            value: "2",
            label: "布尔津县",
          },
          {
            value: "3",
            label: "富蕴县",
          },
          {
            value: "4",
            label: "福海县",
          },
          {
            value: "5",
            label: "哈巴河县",
          },
          {
            value: "6",
            label: "青河县",
          },
          {
            value: "7",
            label: "吉木乃县",
          },
        ],
      },
      {
        value: "E",
        label: "省直辖行政单位",
        children: [
          {
            value: "1",
            label: "石河子市",
          },
          {
            value: "2",
            label: "阿拉尔市",
          },
          {
            value: "3",
            label: "图木舒克市",
          },
          {
            value: "4",
            label: "五家渠市",
          },
        ],
      },
    ],
  },
  {
    value: "W",
    label: "西藏",
    children: [
      {
        value: "0",
        label: "拉萨市",
        children: [
          {
            value: "1",
            label: "城关区",
          },
          {
            value: "2",
            label: "林周县",
          },
          {
            value: "3",
            label: "当雄县",
          },
          {
            value: "4",
            label: "尼木县",
          },
          {
            value: "5",
            label: "曲水县",
          },
          {
            value: "6",
            label: "堆龙德庆县",
          },
          {
            value: "7",
            label: "达孜县",
          },
          {
            value: "8",
            label: "墨竹工卡县",
          },
        ],
      },
      {
        value: "1",
        label: "昌都地区",
        children: [
          {
            value: "1",
            label: "昌都县",
          },
          {
            value: "2",
            label: "江达县",
          },
          {
            value: "3",
            label: "贡觉县",
          },
          {
            value: "4",
            label: "类乌齐县",
          },
          {
            value: "5",
            label: "丁青县",
          },
          {
            value: "6",
            label: "察雅县",
          },
          {
            value: "7",
            label: "八宿县",
          },
          {
            value: "8",
            label: "左贡县",
          },
          {
            value: "9",
            label: "芒康县",
          },
          {
            value: "A",
            label: "洛隆县",
          },
          {
            value: "B",
            label: "边坝县",
          },
        ],
      },
      {
        value: "2",
        label: "山南地区",
        children: [
          {
            value: "1",
            label: "乃东县",
          },
          {
            value: "2",
            label: "扎囊县",
          },
          {
            value: "3",
            label: "贡嘎县",
          },
          {
            value: "4",
            label: "桑日县",
          },
          {
            value: "5",
            label: "琼结县",
          },
          {
            value: "6",
            label: "曲松县",
          },
          {
            value: "7",
            label: "措美县",
          },
          {
            value: "8",
            label: "洛扎县",
          },
          {
            value: "9",
            label: "加查县",
          },
          {
            value: "A",
            label: "隆子县",
          },
          {
            value: "B",
            label: "错那县",
          },
          {
            value: "C",
            label: "浪卡子县",
          },
        ],
      },
      {
        value: "3",
        label: "日喀则地区",
        children: [
          {
            value: "1",
            label: "日喀则市",
          },
          {
            value: "2",
            label: "南木林县",
          },
          {
            value: "3",
            label: "江孜县",
          },
          {
            value: "4",
            label: "定日县",
          },
          {
            value: "5",
            label: "萨迦县",
          },
          {
            value: "6",
            label: "拉孜县",
          },
          {
            value: "7",
            label: "昂仁县",
          },
          {
            value: "8",
            label: "谢通门县",
          },
          {
            value: "9",
            label: "白朗县",
          },
          {
            value: "A",
            label: "仁布县",
          },
          {
            value: "B",
            label: "康马县",
          },
          {
            value: "C",
            label: "定结县",
          },
          {
            value: "D",
            label: "仲巴县",
          },
          {
            value: "E",
            label: "亚东县",
          },
          {
            value: "F",
            label: "吉隆县",
          },
          {
            value: "G",
            label: "聂拉木县",
          },
          {
            value: "H",
            label: "萨嘎县",
          },
          {
            value: "I",
            label: "岗巴县",
          },
        ],
      },
      {
        value: "4",
        label: "那曲地区",
        children: [
          {
            value: "1",
            label: "那曲县",
          },
          {
            value: "2",
            label: "嘉黎县",
          },
          {
            value: "3",
            label: "比如县",
          },
          {
            value: "4",
            label: "聂荣县",
          },
          {
            value: "5",
            label: "安多县",
          },
          {
            value: "6",
            label: "申扎县",
          },
          {
            value: "7",
            label: "索县",
          },
          {
            value: "8",
            label: "班戈县",
          },
          {
            value: "9",
            label: "巴青县",
          },
          {
            value: "A",
            label: "尼玛县",
          },
        ],
      },
      {
        value: "5",
        label: "阿里地区",
        children: [
          {
            value: "1",
            label: "普兰县",
          },
          {
            value: "2",
            label: "札达县",
          },
          {
            value: "3",
            label: "噶尔县",
          },
          {
            value: "4",
            label: "日土县",
          },
          {
            value: "5",
            label: "革吉县",
          },
          {
            value: "6",
            label: "改则县",
          },
          {
            value: "7",
            label: "措勤县",
          },
        ],
      },
      {
        value: "8",
        label: "林芝地区",
        children: [
          {
            value: "1",
            label: "林芝县",
          },
          {
            value: "2",
            label: "工布江达县",
          },
          {
            value: "3",
            label: "米林县",
          },
          {
            value: "4",
            label: "墨脱县",
          },
          {
            value: "5",
            label: "波密县",
          },
          {
            value: "6",
            label: "察隅县",
          },
          {
            value: "7",
            label: "朗县",
          },
        ],
      },
    ],
  },
  {
    value: "X",
    label: "香港",
    children: [
      {
        value: "0",
        label: "香港",
        children: [
          {
            value: "1",
            label: "離島",
          },
          {
            value: "2",
            label: "大埔",
          },
          {
            value: "3",
            label: "元朗",
          },
          {
            value: "4",
            label: "北區",
          },
          {
            value: "5",
            label: "西貢",
          },
          {
            value: "6",
            label: "屯門",
          },
          {
            value: "7",
            label: "沙田",
          },
          {
            value: "8",
            label: "荃灣",
          },
          {
            value: "9",
            label: "南區",
          },
          {
            value: "A",
            label: "葵青",
          },
          {
            value: "B",
            label: "東區",
          },
          {
            value: "C",
            label: "中西區",
          },
          {
            value: "D",
            label: "觀塘",
          },
          {
            value: "E",
            label: "九龍城",
          },
          {
            value: "F",
            label: "灣仔",
          },
          {
            value: "G",
            label: "深水埗",
          },
          {
            value: "H",
            label: "黃大仙",
          },
          {
            value: "I",
            label: "油尖旺",
          },
        ],
      },
    ],
  },
  {
    value: "Y",
    label: "澳门",
    children: [
      {
        value: "0",
        label: "澳门",
        children: [
          {
            value: "1",
            label: "澳门半岛",
          },
          {
            value: "2",
            label: "凼仔",
          },
          {
            value: "3",
            label: "路环",
          },
        ],
      },
    ],
  },
  {
    value: "Z",
    label: "CRO",
    children: [
      {
        value: "0",
        label: "CRO",
        children: [
          {
            value: "0",
            label: "CRO",
          },
        ],
      },
    ],
  },
];
